(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a80"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a80"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ejSnv", function(module, exports) {
const discountModal = document.querySelector(".discount-modal");
if (!discountModal) return;
const lastDiscountCode = localStorage.getItem("lastDiscountCode");
function getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
const urlDiscountCookie = getCookieValue("discount_code");
let newDiscountCode = "";
if (current_discounts && current_discounts.length > 0) current_discounts.forEach((discount)=>{
    if (discount != lastDiscountCode) newDiscountCode = discount;
});
else if (urlDiscountCookie) newDiscountCode = urlDiscountCookie;
if (newDiscountCode != "" && newDiscountCode != lastDiscountCode) sessionStorage.removeItem('discount_modal_shown');
if (!sessionStorage.getItem('discount_modal_shown') && newDiscountCode != "") {
    localStorage.setItem("lastDiscountCode", newDiscountCode);
    sessionStorage.setItem("discount_modal_shown", "true");
    discountModal.open();
    discountModal.querySelector("[data-discount]").textContent = newDiscountCode;
    let discountNr = "";
    let match = newDiscountCode.match(/\d+/);
    if (match != null) discountNr = match[0];
    const valueTextElements = discountModal.querySelectorAll("[data-value]");
    if (!valueTextElements.length) return;
    if (discountNr == "") discountModal.querySelector("[data-discount-value-text]").remove();
    // format ex 5 -> 05 if needed with discountNr.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }
    valueTextElements.forEach((el)=>el.textContent = discountNr);
}

});

parcelRegister("5eAAb", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("69fOT")), (parcelRequire("kr5WN")), (parcelRequire("1zy08")), (parcelRequire("5rOkc")), (parcelRequire("59btK")), (parcelRequire("aTTMY")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("69fOT", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("kr5WN", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == 'object' && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("1zy08", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("5rOkc", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("kr5WN")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    const cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("59btK", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("aTTMY", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("1zy08")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("2jNIg", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5eAAb")), (parcelRequire("4HYi2")), (parcelRequire("1zy08")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === 'touchstart';
        let isTouchPointer = event.pointerType === 'touch';
        let isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("4HYi2", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("69fOT")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    const clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("lUkdk", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    const svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement('button');
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        let title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? 'right' : 'left';
        let nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("8yoKV", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")), (parcelRequire("1zy08")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            let num = i + 1 + this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("1hZWV", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("cus4c", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")), (parcelRequire("1zy08")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("77NAy", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")), (parcelRequire("1zy08")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = 'data-flickity-lazyload';
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("c7TRI", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("5eAAb")), (parcelRequire("hj7My")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("hj7My", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("69fOT")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});


parcelRegister("8H191", function(module, exports) {
const parentBlock = document.querySelector('.packs-block');
if (!parentBlock) return;
const sortedPackCombinations = packCombinations.sort((a, b)=>a.packSize - b.packSize);
// Bra products have two variant option groups (band + cup). Their `[data-size]`
// labels carry just the band digits (e.g. "65") and `[data-cup]` labels carry
// just the cup letter (e.g. "B"); pack variant titles still contain the
// combined token (e.g. "Black / 65B"). Token matching needs to handle this.
const isBraProduct = !!document.querySelector('variant-radios[data-bra-options="true"]');
const sectionId = (document.querySelector('variant-radios') || document.querySelector('variant-selects'))?.dataset?.section;
// ─── State ──────────────────────────────────────────────────────────────────
// `displayedPackSize` is the pack size whose product is currently rendered in
// the product-info container. On page load it's the size of the product that was
// actually navigated to (1 = single). Each pack switch replaces the whole
// product-info container with the target pack's server-rendered section, so the
// inline DOM literally becomes that pack's PDP — colour swatches, size
// availability, price and CTA all come correct from the server. This removes the
// need for the previous hand-maintained incremental repaint/restore machinery.
let displayedPackSize = function() {
    const cur = sortedPackCombinations.find((c)=>c.isCurrent);
    return cur ? cur.packSize : 1;
}();
let currentSize = ''; // last band/size read from the variant radios
let currentCup = ''; // last cup (bra products only)
let preselectedPackSize = null; // from ?pack= URL param on page load (legacy links)
let isRepainting = false; // guards against overlapping repaints
let activeTriggerClass = null; // unique Klaviyo trigger class currently on the BIS button
let triggerClassCounter = 0; // incremented per reinit to produce a unique class
// Read URL param for pack preselection (backward-compat with existing ?pack= links)
(function initFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const packParam = params.get('pack');
    if (packParam) preselectedPackSize = parseInt(packParam, 10);
})();
// ─── Full product-info repaint ────────────────────────────────────────────────
function buildProductUrl(productUrl, variantId) {
    let url;
    try {
        url = new URL(productUrl, window.location.origin);
    } catch (_) {
        return productUrl;
    }
    if (variantId) url.searchParams.set('variant', variantId);
    return url.pathname + url.search;
}
// Hard fallback: if the section fetch fails we simply navigate to the target
// product so the user still ends up on the right pack/colour.
function navigateFallback(productUrl, variantId) {
    window.location.href = buildProductUrl(productUrl, variantId);
}
// Fetch the target product's main-product section and swap it into the live
// `#ProductInfo-<sectionId>` container. The packs dropdown lives *inside* that
// container, so we detach the live `.packs-block` node first (keeping all its
// listeners + state) and re-insert it over the freshly-rendered placeholder.
function repaintInfoContainer(productUrl, variantId, productId) {
    if (!sectionId) {
        navigateFallback(productUrl, variantId);
        return;
    }
    const container = document.getElementById('ProductInfo-' + sectionId);
    if (!container) {
        navigateFallback(productUrl, variantId);
        return;
    }
    isRepainting = true;
    showRepaintLoading();
    // Fetch the FULL product page (not ?section_id) so the response also carries
    // the <head> — we sync the title + canonical/social meta from it. The full page
    // still contains `#ProductInfo-<sectionId>` and the inline data scripts, so the
    // body swap works exactly as with a section fetch (one request, not two).
    const fetchUrl = new URL(productUrl, window.location.origin);
    if (variantId) fetchUrl.searchParams.set('variant', variantId);
    fetch(fetchUrl.pathname + fetchUrl.search).then(function(r) {
        return r.text();
    }).then(function(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.getElementById('ProductInfo-' + sectionId);
        if (!incoming) throw new Error('packs: no product-info container in fetched section');
        // Refresh the page-load product-data globals (`variantStock`,
        // `connectedProductVariantData`) to the target product's values BEFORE the
        // swap. The new variant-radios upgrades synchronously during innerHTML and
        // immediately runs onVariantChange → updateInventoryNote, which looks the
        // current variant up in `variantStock`; if it still holds the old product's
        // ids the lookup is undefined and global.js throws, aborting the handler
        // (leaving the CTA stuck disabled / "Unavailable").
        refreshProductDataGlobals(parsed);
        // `#option-map` lives outside the swapped container, so update it too — the
        // new variant-radios reads it (for colour-swatch size detection) on upgrade.
        const incomingOptionMap = parsed.getElementById('option-map');
        const liveOptionMap = document.getElementById('option-map');
        if (incomingOptionMap && liveOptionMap) liveOptionMap.textContent = incomingOptionMap.textContent;
        // Detach the live dropdown so the innerHTML swap can't destroy it.
        const liveDropdown = parentBlock;
        liveDropdown.remove();
        // Swap. Custom elements in the new markup (variant-radios, product-form,
        // color-swatches, size-guide…) upgrade synchronously here and re-bind
        // themselves; variant-radios also re-dispatches `colorSwatchesUpdated`.
        container.innerHTML = incoming.innerHTML;
        const freshDropdown = container.querySelector('.packs-block');
        if (freshDropdown) freshDropdown.replaceWith(liveDropdown);
        else container.appendChild(liveDropdown);
        // Correct the URL to the new product. global.js's updateURL ran during the
        // swap and resolved ?variant=&size= for the selected variant, but on the OLD
        // pathname (it only rewrites search params). Preserve the variant it settled
        // on (read from the form input) AND the size, swapping only the pathname.
        // Dropping ?size here would break bras: their radios are re-selected from
        // ?size on the next swap (the server doesn't pre-check bra radios).
        const target = new URL(productUrl, window.location.origin);
        const settled = new URL(window.location.href);
        const settledForm = document.getElementById('product-form-' + sectionId);
        const settledIdInput = settledForm && settledForm.querySelector('input[name="id"]');
        const resolvedVariantId = settledIdInput && settledIdInput.value || variantId;
        if (resolvedVariantId) target.searchParams.set('variant', resolvedVariantId);
        const settledSize = settled.searchParams.get('size');
        if (settledSize) target.searchParams.set('size', settledSize);
        window.history.replaceState({}, '', target.pathname + target.search);
        // Sync <head> (title + canonical/social meta) so analytics, sharing and the
        // browser tab reflect the displayed product instead of the page-load one.
        updateHeadFromParsed(parsed);
        reinitAfterRepaint(productId, variantId);
        isRepainting = false;
        hideRepaintLoading();
    }).catch(function() {
        isRepainting = false;
        hideRepaintLoading();
        navigateFallback(productUrl, variantId);
    });
}
// Loading state shown over the product info while a pack switch is in flight. It
// gives visual feedback AND prevents adding the WRONG product: until the section
// swap lands, the previous product's form is still live. The overlay blocks
// direct clicks on the in-form Add button, and we set aria-disabled on the Add
// button(s) so a programmatic click (e.g. the sticky ATC delegating to it) is
// skipped by product-form.js too. The swap replaces these buttons, clearing it.
function showRepaintLoading() {
    const wrapper = document.querySelector('.product__info-wrapper');
    if (wrapper) {
        if (window.getComputedStyle(wrapper).position === 'static') wrapper.style.position = 'relative';
        if (!wrapper.querySelector('.packs-repaint-overlay')) {
            const overlay = document.createElement('div');
            overlay.className = 'packs-repaint-overlay';
            overlay.setAttribute('aria-hidden', 'true');
            overlay.innerHTML = '<div class="packs-repaint-spinner"></div>';
            wrapper.appendChild(overlay);
        }
    }
    if (sectionId) {
        const form = document.getElementById('product-form-' + sectionId);
        if (form) form.querySelectorAll('[name="add"]').forEach(function(b) {
            b.setAttribute('aria-disabled', 'true');
        });
    }
}
function hideRepaintLoading() {
    const overlay = document.querySelector('.product__info-wrapper .packs-repaint-overlay');
    if (overlay) overlay.remove();
}
// Re-run the inline data scripts from the fetched section so the page-load
// globals match the target product. These `<script>`s don't execute when
// inserted via innerHTML, and one of them (`connectedProductVariantData`) lives
// outside the swapped container entirely. We execute them by appending a new
// <script> (inline scripts run synchronously on insertion), neutralising the
// top-level `let connectedProductVariantData` declaration to a reassignment so
// re-running can't throw "already declared" against the existing global.
// `variantStock` is declared with `var`, which is safe to re-declare.
function refreshProductDataGlobals(parsedDoc) {
    const scripts = parsedDoc.querySelectorAll('script:not([src]):not([type])');
    let code = '';
    scripts.forEach(function(s) {
        const txt = s.textContent || '';
        if (txt.indexOf('connectedProductVariantData') !== -1 && txt.indexOf('.push(') !== -1) code += '\n' + txt.replace(/\b(let|const|var)\s+connectedProductVariantData\b/, 'connectedProductVariantData') + '\n;';
        else if (txt.indexOf('variantStock') !== -1 && txt.indexOf('.push(') !== -1) code += '\n' + txt + '\n;';
    });
    if (!code) return;
    try {
        const runner = document.createElement('script');
        runner.textContent = code;
        document.body.appendChild(runner);
        runner.remove();
    } catch (_) {}
}
// Sync the document <head> to the fetched product page: title, canonical link,
// description, all og:*/twitter:* social meta, and the Product JSON-LD. Keeps
// analytics/sharing/tab in step with the displayed pack (the body swap only
// touches #ProductInfo, never <head>). Wrapped so a head hiccup can't break the
// repaint.
function updateHeadFromParsed(parsedDoc) {
    try {
        if (!parsedDoc || !parsedDoc.head || !document.head) return;
        const head = document.head;
        const incoming = parsedDoc.head;
        const titleEl = incoming.querySelector('title');
        if (titleEl) document.title = titleEl.textContent;
        const selectors = [
            'link[rel="canonical"]',
            'meta[name="description"]'
        ];
        incoming.querySelectorAll('meta[property]').forEach(function(el) {
            const p = el.getAttribute('property');
            if (p) selectors.push('meta[property="' + p + '"]');
        });
        incoming.querySelectorAll('meta[name^="twitter:"]').forEach(function(el) {
            const n = el.getAttribute('name');
            if (n) selectors.push('meta[name="' + n + '"]');
        });
        const done = {};
        selectors.forEach(function(sel) {
            if (done[sel]) return;
            done[sel] = true;
            const incomingEls = incoming.querySelectorAll(sel);
            if (!incomingEls.length) return;
            // Replace the live set for this key with the incoming set.
            head.querySelectorAll(sel).forEach(function(el) {
                el.remove();
            });
            incomingEls.forEach(function(el) {
                head.appendChild(el.cloneNode(true));
            });
        });
        // Product JSON-LD schema (if present in <head>).
        function findProductLd(root) {
            return Array.prototype.slice.call(root.querySelectorAll('script[type="application/ld+json"]')).find(function(s) {
                return /"@type"\s*:\s*"Product"/.test(s.textContent || '');
            });
        }
        const incomingLd = findProductLd(incoming);
        if (incomingLd) {
            const liveLd = findProductLd(head);
            if (liveLd) liveLd.textContent = incomingLd.textContent;
            else head.appendChild(incomingLd.cloneNode(true));
        }
    } catch (_) {}
}
// Re-bind everything that doesn't auto-upgrade after a container swap.
function reinitAfterRepaint(productId, variantId) {
    // Re-render the dropdown option list against the now-current variant selection.
    const sel = readCheckedVariantSelection();
    currentCup = sel.cup;
    filterPacksByColorAndSize(sortedPackCombinations, currentColor, sel.size, '.packs-tiles');
    // Re-init Klaviyo BIS for the now-displayed product.
    reinitKlaviyoForProduct(productId, variantId);
    // Let the other product-info features (sticky ATC, accordions, co2 chips…)
    // re-bind to the freshly-swapped DOM.
    window.dispatchEvent(new CustomEvent('product-info-repainted', {
        detail: {
            sectionId: sectionId
        }
    }));
}
// Klaviyo BIS is initialised per-product at page load, so after switching to a
// different product (every pack/single is its own product) the page-load instance
// doesn't know the new product's variants — clicking the wishlist button then
// throws "Cannot read properties of undefined (reading 'id')" because the URL's
// variant isn't in Klaviyo's data. So we must re-init Klaviyo for the displayed
// product on each repaint. We re-init even when the current size is in stock (the
// button is hidden), so the instance already matches the product if the user then
// picks an out-of-stock size (a same-product size change does NOT repaint).
function reinitKlaviyoForProduct(productId, variantId) {
    if (!sectionId || typeof window.reinitKlaviyoBIS !== 'function') return;
    const form = document.getElementById('product-form-' + sectionId);
    if (!form) return;
    const bisBtn = form.querySelector('.klaviyo-bis-trigger');
    if (!bisBtn) return; // Klaviyo BIS not configured for this product
    // Clone the button to strip the dead click handler left by the previous
    // (now-destroyed) Klaviyo instance, and drop the page-load `klaviyo-bis-trigger-ob`
    // class so that instance's observer can't re-attach a stale handler (that combo —
    // dead handler + removed iframe — is what threw "...null (reading 'document')").
    // The new instance gets a unique trigger class that only it watches.
    const fresh = bisBtn.cloneNode(true);
    bisBtn.parentNode.replaceChild(fresh, bisBtn);
    fresh.classList.remove('klaviyo-bis-trigger-ob');
    if (activeTriggerClass) fresh.classList.remove(activeTriggerClass);
    const triggerClass = 'klaviyo-bis-trigger-ob-' + ++triggerClassCounter;
    fresh.classList.add(triggerClass);
    activeTriggerClass = triggerClass;
    const input = form.querySelector('input[name="id"]');
    const vId = input && input.value || variantId;
    // forceShow:false — the server render already set the button's visibility.
    window.reinitKlaviyoBIS({
        variantId: vId,
        productId: productId,
        triggerClass: triggerClass,
        forceShow: false
    });
}
// ─── Core filter + render ─────────────────────────────────────────────────────
// Exact token match for sizes: splits variant title on "/" and whitespace so that
// "xs" does not match "xxs", and "s" does not match "xs" or "xxs". For bras the
// option2 token is band+cup combined (e.g. "65B"), so we match against `band+cup`.
function titleMatchesSize(title, size, cup) {
    if (!size && !cup) return true;
    const tokens = title.toLowerCase().split(/[\s/]+/).map(function(t) {
        return t.trim();
    }).filter(Boolean);
    if (isBraProduct) {
        if (size && cup) return tokens.includes((size + cup).toLowerCase());
        if (size) return tokens.some(function(t) {
            return /^\d+\D+$/.test(t) && t.indexOf(size.toLowerCase()) === 0;
        });
        if (cup) return tokens.some(function(t) {
            return /^\d+\D+$/.test(t) && t.replace(/[0-9]/g, '') === cup.toLowerCase();
        });
        return true;
    }
    return tokens.includes(size.toLowerCase());
}
function filterPacksByColorAndSize(packs, currentColorArg, variantSize, containerOrSelector) {
    const color = (currentColorArg || '').toLowerCase();
    const size = (variantSize || '').toLowerCase();
    const cup = (currentCup || '').toLowerCase();
    currentSize = variantSize || '';
    // A "fully selected" variant — for bras requires both band and cup. Until
    // then we render the dropdown but suppress availability indicators.
    const fullyVariantSelected = isBraProduct ? !!size && !!cup : !!size;
    const mappedPacks = packs.map(function(pack) {
        const sizeColorMatches = !fullyVariantSelected ? [] : pack.variants.filter(function(v) {
            const t = (v.title || '').toLowerCase();
            const matchesColor = color && pack.packSize > 1 ? t.includes(color) : true;
            const matchesSize = titleMatchesSize(t, size, cup);
            return matchesColor && matchesSize;
        });
        // Fallback: color-only (so the pack still appears when size isn't selected)
        const colorOnlyMatches = pack.variants.filter(function(v) {
            const t = (v.title || '').toLowerCase();
            return color && pack.packSize > 1 ? t.includes(color) : true;
        });
        const displayVariant = sizeColorMatches.length > 0 ? sizeColorMatches[0] : colorOnlyMatches.length > 0 ? colorOnlyMatches[0] : null;
        const isAvailableForSizeColor = sizeColorMatches.length > 0 && sizeColorMatches.some(function(v) {
            return v.available === true;
        });
        return {
            title: pack.title,
            displayName: pack.displayName,
            packSize: pack.packSize,
            productId: pack.productId,
            productUrl: pack.productUrl,
            isCurrent: pack.isCurrent,
            variants: pack.variants,
            displayVariant: displayVariant,
            isAvailableForSizeColor: isAvailableForSizeColor,
            fullyVariantSelected: fullyVariantSelected
        };
    });
    // One tile per pack size: drifted colour tags can let a second product of
    // the same size through the colour filter (e.g. two different 3-packs),
    // which rendered as duplicate tiles. Keep the displayed product for its
    // size, otherwise the first entry.
    const seenSizes = {};
    const dedupedPacks = [];
    mappedPacks.forEach(function(p) {
        const idx = seenSizes[p.packSize];
        if (typeof idx === 'undefined') {
            seenSizes[p.packSize] = dedupedPacks.length;
            dedupedPacks.push(p);
        } else if (p.isCurrent && !dedupedPacks[idx].isCurrent) dedupedPacks[idx] = p;
    });
    // Hide the block when there is no real multipack, or nothing besides the
    // product already being viewed (a lone option is not an upsell).
    const hasPacks = dedupedPacks.some(function(p) {
        return p.packSize > 1;
    }) && dedupedPacks.length > 1;
    if (hasPacks) parentBlock.classList.remove('hidden');
    else parentBlock.classList.add('hidden');
    if (containerOrSelector) generateVariantDropdown(dedupedPacks, variantSize, containerOrSelector);
    return dedupedPacks;
}
function generateVariantDropdown(mappedPacks, variantSize, containerOrSelector) {
    if (!Array.isArray(mappedPacks)) return;
    const container = typeof containerOrSelector === 'string' ? parentBlock.querySelector(containerOrSelector) : containerOrSelector;
    if (!container) return;
    const template = document.getElementById('pack-tile-template');
    if (!template) return;
    container.innerHTML = '';
    function buildUrlWithSize(baseUrl, sizeValue) {
        if (!baseUrl) return '#';
        let absolute;
        try {
            absolute = new URL(baseUrl);
        } catch (_) {
            absolute = new URL(baseUrl, window.location.origin);
        }
        if (sizeValue) absolute.searchParams.set('size', String(sizeValue));
        return baseUrl.startsWith('/') ? absolute.pathname + absolute.search + absolute.hash : absolute.toString();
    }
    mappedPacks.forEach(function(pack) {
        const variant = pack.displayVariant;
        const clone = template.content.cloneNode(true);
        const tileEl = clone.querySelector('.pack-tile');
        tileEl.querySelector('.pack-tile__name').textContent = pack.displayName;
        // The tile shows the saving, not the price: a second "(Save X%)" line —
        // also for on-sale packs, whose saving is already computed from the
        // discounted price ("(On Sale)" only remains as a fallback when no
        // percentage can be computed).
        const onSale = variant && (variant.on_sale === true || variant.on_sale === 'true');
        const saving = variant && typeof variant.saving_percentage !== 'undefined' ? Number(variant.saving_percentage) : 0;
        const badgeEl = tileEl.querySelector('.pack-tile__badge');
        if (saving > 0) {
            badgeEl.textContent = '(' + packsI18n.savePercent.replace('[[P]]', saving) + ')';
            tileEl.classList.add('has-badge');
        } else if (onSale) {
            badgeEl.textContent = '(' + packsI18n.onSale + ')';
            tileEl.classList.add('has-badge', 'on-sale');
        }
        // Out-of-stock state — only indicate availability once the user has fully
        // selected a variant (for bras: both band and cup).
        if (pack.fullyVariantSelected && !pack.isAvailableForSizeColor) tileEl.classList.add('is-unavailable');
        // Selected / current state reflects the product currently rendered inline.
        const isSelected = pack.packSize === displayedPackSize;
        if (isSelected) tileEl.classList.add('is-selected');
        tileEl.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        // Data attributes
        tileEl.dataset.packSize = pack.packSize;
        tileEl.dataset.productId = pack.productId;
        // URL (used for the navigation fallback)
        const baseUrl = variant ? variant.base_url || pack.productUrl : pack.productUrl || '#';
        tileEl.dataset.targetUrl = buildUrlWithSize(baseUrl, variantSize);
        // ── Click handler: switch product by repainting the info container ───────
        tileEl.addEventListener('click', function() {
            if (isRepainting) return; // ignore clicks mid-swap
            if (pack.packSize === displayedPackSize) return; // already showing this product
            // Optimistic selection update for snappiness; reinitAfterRepaint re-syncs
            // it from the freshly-rendered data once the swap lands.
            displayedPackSize = pack.packSize;
            container.querySelectorAll('.pack-tile').forEach(function(el) {
                const sel = parseInt(el.dataset.packSize, 10) === pack.packSize;
                el.classList.toggle('is-selected', sel);
                el.setAttribute('aria-pressed', sel ? 'true' : 'false');
            });
            repaintInfoContainer(pack.productUrl, variant ? variant.id : null, pack.productId);
        });
        container.appendChild(clone);
    });
    // Apply preselected pack from URL params (runs once, on first render).
    if (preselectedPackSize !== null) {
        const toPreselect = mappedPacks.find(function(p) {
            return p.packSize === preselectedPackSize;
        });
        preselectedPackSize = null; // clear regardless
        if (toPreselect && toPreselect.packSize !== displayedPackSize) {
            const optionToClick = container.querySelector('[data-pack-size="' + toPreselect.packSize + '"]');
            if (optionToClick) optionToClick.click();
        }
    }
}
// ─── Event listener ───────────────────────────────────────────────────────────
function readCheckedVariantSelection() {
    // For bras, event.detail from updateColorSwatches is the combined "65B" only
    // when both band and cup are checked; otherwise it's empty. The band radio's
    // value alone is "65" (just digits), which can't match the combined token in
    // pack variant titles — so we always read both groups directly.
    if (isBraProduct) {
        const checkedBand = document.querySelector('input[type="radio"][name="Size"]:checked');
        const checkedCup = document.querySelector('input[type="radio"][name="Cup"]:checked');
        return {
            size: checkedBand ? checkedBand.value : '',
            cup: checkedCup ? checkedCup.value : ''
        };
    }
    const checkedSize = document.querySelector('input[type="radio"][name="Size"]:checked');
    return {
        size: checkedSize ? checkedSize.value : '',
        cup: ''
    };
}
// Fires on size/colour changes within the currently displayed product. We only
// rebuild the dropdown option list (prices/availability for the new selection) —
// switching products is driven solely by option clicks (→ repaintInfoContainer).
window.addEventListener('colorSwatchesUpdated', function(event) {
    const sel = readCheckedVariantSelection();
    let variantSize = isBraProduct ? sel.size : event.detail || sel.size;
    currentCup = sel.cup;
    filterPacksByColorAndSize(sortedPackCombinations, currentColor, variantSize, '.packs-tiles');
});
// Initial render: populate the dropdown immediately so all bundles are visible
// from the start, even on products that don't dispatch `colorSwatchesUpdated`
// on load. Deferred past obScripts/global.js's customElements.define so
// VariantRadios has had a chance to upgrade the DOM.
setTimeout(function() {
    const sel = readCheckedVariantSelection();
    currentCup = sel.cup;
    filterPacksByColorAndSize(sortedPackCombinations, currentColor, sel.size, '.packs-tiles');
}, 0);

});

parcelRegister("75MpZ", function(module, exports) {
if (window.location.href.includes('/collections/')) {
    const quickLinksSection = document.querySelector('.quick-links-section');
    if (!quickLinksSection) return;
    const quickLinks = quickLinksSection.querySelectorAll('.quick-link-item-link');
    const collectionHandle = quickLinksSection.getAttribute('data-collection-handle');
    quickLinks.forEach((link)=>{
        let linkHref = link.getAttribute('href');
        if (!linkHref) return;
        if (linkHref.includes('collection-name')) {
            linkHref = linkHref.replace('collection-name', collectionHandle);
            link.setAttribute('href', linkHref);
        }
    });
}

});

parcelRegister("7Wc4a", function(module, exports) {
const stickyAtc = document.querySelector('.section-sticky-atc');
if (!stickyAtc) return;
// `atcForm` is inside the product-info container, so a packs-dropdown repaint
// replaces it with a fresh element. Re-query it on every init and re-bind, and
// re-run init when the container is repainted (`product-info-repainted`).
let atcForm = null;
let stickyAtcObserver = null;
init();
window.addEventListener('product-info-repainted', init);
function init() {
    atcForm = document.querySelector("[data-type=add-to-cart-form]");
    if (!atcForm) return;
    if (!stickyAtc.querySelector("button")) return;
    const submit = atcForm.querySelector(".product-form__submit:not(.hidden)");
    if (!submit) return;
    stickyAtc.querySelector("button").replaceWith(submit.cloneNode(true));
    stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    document.body.appendChild(stickyAtc);
    addEvents();
}
function addEvents() {
    stickyAtc.querySelector('button').addEventListener('click', (e)=>{
        e.preventDefault();
        const btn = atcForm.querySelector(".product-form__submit:not(.hidden).button");
        if (btn) btn.click();
    });
    addObserver();
    atcForm.addEventListener('change', ()=>{
        const submit = atcForm.querySelector(".product-form__submit:not(.hidden)");
        if (!submit) return;
        stickyAtc.querySelector("button").replaceWith(submit.cloneNode(true));
        stickyAtc.querySelector("button").setAttribute("form", atcForm.getAttribute('id'));
    });
}
function addObserver() {
    if (stickyAtcObserver) stickyAtcObserver.disconnect();
    stickyAtc.classList.remove('section-sticky-atc--visible');
    stickyAtcObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            const stickyAtcRect = stickyAtc.getBoundingClientRect();
            const atcFormRect = atcForm.getBoundingClientRect();
            if (stickyAtcRect.bottom < atcFormRect.top) // If stickyAtc is above atcForm, do not add the class
            return;
            if (entry.isIntersecting) stickyAtc.classList.remove('section-sticky-atc--visible');
            else stickyAtc.classList.add('section-sticky-atc--visible');
        });
    }, {
        root: null,
        threshold: 0.2
    });
    stickyAtcObserver.observe(atcForm);
}

});

/* util */ /*************************
 * instead of prodId, variant ID can also be passed
 *
**************************/ function $d3f55548ebb0c62b$var$addProductToCart(prodId, quantity) {
    let formData = {
        'items': [
            {
                'id': prodId,
                'quantity': quantity
            }
        ]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then((response)=>{
        return response.json();
    }).catch((error)=>{
        console.error('Error:', error);
    });
}
function $d3f55548ebb0c62b$var$addProductListToCart(prodList) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(prodList)
    }).then((response)=>{
        return response.json();
    }).catch((error)=>{
        console.error('Error:', error);
    });
}


/*************************
 * in a div, make a <custom-select></custom-select> , with <option></option> inside
 * the custom-select will be converted into a custom dropdown
 * 
*************************/ function $66f2a9276f510009$var$initCustomDropdowns(el) {
    var j, ll, selElmnt, a, b, c;
    /* Look for any elements with the class "custom-select": */ const thisCustomSelect = el;
    selElmnt = thisCustomSelect.getElementsByTagName("select")[0];
    ll = selElmnt.length;
    let isSortSelector = false;
    let isColorSelector = false;
    switch(thisCustomSelect.getAttribute("name")){
        case "sort_by":
            isSortSelector = true;
            break;
        case "color":
            isColorSelector = true;
            break;
        default:
            isColorSelector = false;
            isSortSelector = false;
            break;
    }
    /* For each element, create a new DIV that will act as the selected item: */ a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    if (thisCustomSelect.hasAttribute("select-text")) a.textContent = thisCustomSelect.getAttribute("select-text");
    thisCustomSelect.appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */ b = document.createElement("DIV");
    b.setAttribute("class", "select-items");
    for(j = 1; j < ll; j++){
        /* For each option in the original select element,
    create a new DIV that will act as an option item: */ c = document.createElement("custom-option");
        if (isColorSelector) {
            c.innerHTML = `<div class='color-swatch'></div>` + selElmnt.options[j].innerHTML;
            c.setAttribute("data-color", selElmnt.options[j].innerHTML.toLowerCase().split(" ").join("-"));
        } else c.innerHTML = `<div>` + selElmnt.options[j].innerHTML + `</div>`;
        if (selElmnt.options[j]?.selected) c.setAttribute("class", "same-as-selected");
        c.addEventListener("click", function(e) {
            /* When an item is clicked, update the original select box,
      and the selected item: */ var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for(i = 0; i < sl; i++)if (s.options[i].innerHTML.includes(this.textContent)) {
                s.selectedIndex = i;
                if (!isSortSelector) {
                    h.innerHTML = this.innerHTML;
                    h.parentNode.setAttribute("value", this.textContent);
                    h.setAttribute("data-color", this.getAttribute("data-color"));
                }
                if (isSortSelector) {
                    s.dispatchEvent(new Event('change'));
                    s.onchange();
                    if ("createEvent" in document) {
                        var evt = document.createEvent("HTMLEvents");
                        evt.initEvent("change", false, true);
                        s.dispatchEvent(evt);
                    } else s.fireEvent("onchange");
                }
                y = this.parentNode.getElementsByClassName("same-as-selected");
                this.parentNode.parentNode.removeAttribute("open");
                yl = y.length;
                for(k = 0; k < yl; k++)y[k].removeAttribute("class");
                this.setAttribute("class", "same-as-selected");
                break;
            }
            h.click();
        }, true);
        b.appendChild(c);
    }
    thisCustomSelect.appendChild(b);
}
class $66f2a9276f510009$var$CustomSelector extends HTMLElement {
    constructor(node){
        super();
        this.props();
        this.init();
    }
    get value() {
        return this.getAttribute("value");
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    set options(options) {}
    get options() {
        return this.querySelectorAll("custom-option");
    }
    init() {
        this.generate();
        document.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.closeAll();
            this.close();
        });
        this.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.closeAll();
            this.toggle();
        });
        this.inited = true;
    }
    generate() {
        $66f2a9276f510009$var$initCustomDropdowns(this);
    }
    props() {
        this.open = false;
        this.inited = false;
        this.type = this.querySelector("[data-type]").getAttribute("data-type");
    }
    toggle() {
        if (this.hasAttribute("open")) this.removeAttribute("open");
        else this.setAttribute("open", '');
    }
    close() {
        this.removeAttribute("open");
    }
    closeAll() {
        document.querySelectorAll('custom-select')?.forEach((sel)=>{
            sel != this && sel.close();
        });
    }
}
customElements.define('custom-select', $66f2a9276f510009$var$CustomSelector);


// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.theme.moneyFormat || '{{amount}} DKK';
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]){
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};


class $327f21513f7983f9$var$InfiniteScrollPagination extends HTMLElement {
    constructor(){
        super();
        // --- START ORIGINAL SELECTORS ---
        const watcher = this.querySelector('.pagination-wrapper.more');
        const moreAnchor = this.querySelector('.pagination-wrapper.more > a');
        if (moreAnchor) moreAnchor.style.pointerEvents = 'none';
        let observerOptions = {
            root: null,
            rootMargin: '0px 0px 200% 0px',
            threshold: 0
        };
        let phase = 'inStock';
        // --- END ORIGINAL SELECTORS ---
        // --- NEW: RESTORATION WRAPPER ---
        const init = async ()=>{
            const navigationEntries = performance.getEntriesByType('navigation');
            const isBackForward = navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward';
            const lastPage = parseInt(sessionStorage.getItem('collectionPageLoaded'));
            setupScrollSaving();
            if (isBackForward && lastPage && lastPage >= 2) {
                // Display overlay and jump to top to prevent observer firing early
                const overlay = document.querySelector('.loading-overlay-container');
                if (overlay) overlay.style.display = 'flex';
                window.scrollTo(0, 0);
                console.log(`Restoring up to page ${lastPage}...`);
                for(let p = 2; p <= lastPage; p++)await loadMoreContent(p); // Call original function with forced page
                const savedScroll = sessionStorage.getItem('scrollPosition');
                if (savedScroll) setTimeout(()=>{
                    window.scrollTo({
                        top: parseInt(savedScroll),
                        behavior: 'instant'
                    });
                    if (overlay) overlay.style.display = 'none';
                }, 150);
            } else if (!isBackForward) {
                sessionStorage.removeItem('scrollPosition');
                sessionStorage.removeItem('collectionPageLoaded');
            }
            // Start observing AFTER restoration
            if (watcher) observer.observe(watcher);
            // Final call to ensure content fills screen
            await loadMoreContent();
        };
        function setupScrollSaving() {
            document.addEventListener('click', function(event) {
                const link = event.target.closest('a');
                if (!link) return;
                const card = link.closest('li.grid__item');
                if (card) sessionStorage.setItem('scrollPosition', window.scrollY);
            });
        }
        let observer = new IntersectionObserver(async (entries, observer)=>{
            for (let entry of entries)if (entry.isIntersecting) await loadMoreContent();
        }, observerOptions);
        function hasExplicitAvailabilityFilter() {
            const params = new URLSearchParams(window.location.search);
            return Array.from(params.keys()).some((key)=>key.includes('availability'));
        }
        // --- YOUR ORIGINAL LOADMORECONTENT (Updated to accept forcedPage) ---
        async function loadMoreContent(forcedPage = null) {
            try {
                if (!moreAnchor) return;
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = document.documentElement;
                const scrollPosition = scrollTop + clientHeight;
                const scrollOffset = 6000;
                // Condition: Run if manually forced OR if user scrolled into view
                if (forcedPage || scrollPosition >= scrollHeight - scrollOffset && moreAnchor.innerHTML != watcher.dataset.loading) {
                    if (!forcedPage) moreAnchor.innerHTML = watcher.dataset.loading;
                    const anchorURL = new URL(moreAnchor.href);
                    let page = forcedPage || anchorURL.searchParams.get('page') || 1;
                    let currentURL = new URL(moreAnchor.baseURI);
                    const productGrid = document.querySelector('ul#product-grid');
                    const explicitAvailability = hasExplicitAvailabilityFilter();
                    if (!explicitAvailability) {
                        const needsFirstPageFetch = !productGrid?.dataset.firstPageFetched;
                        if (needsFirstPageFetch && !forcedPage) {
                            page = 1;
                            productGrid.dataset.firstPageFetched = true;
                        }
                        const availabilityInput = document.querySelector('li[data-radio-group="availability"] input');
                        const availabilityParamName = availabilityInput ? availabilityInput.name : 'filter.v.availability';
                        const availabilityValue = phase === 'inStock' ? '1' : '0';
                        currentURL.searchParams.set(availabilityParamName, availabilityValue);
                    }
                    currentURL.searchParams.set('page', page);
                    const response = await fetch(currentURL.toString());
                    const html = await response.text();
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const source = doc.body.querySelector('ul#product-grid')?.innerHTML;
                    sessionStorage.setItem('collectionPageLoaded', page);
                    if (source && source.trim()) {
                        productGrid.insertAdjacentHTML('beforeend', source);
                        const nextPage = parseInt(page) + 1;
                        if (nextPage <= parseInt(moreAnchor.id)) {
                            anchorURL.searchParams.set('page', nextPage);
                            moreAnchor.href = anchorURL.href;
                            moreAnchor.innerHTML = watcher.dataset.noticelabel;
                        } else if (phase === 'inStock' && !hasExplicitAvailabilityFilter()) {
                            phase = 'outOfStock';
                            const outURL = new URL(moreAnchor.baseURI);
                            const availabilityInput = document.querySelector('li[data-radio-group="availability"] input');
                            const availabilityParamName = availabilityInput ? availabilityInput.name : 'filter.v.availability';
                            outURL.searchParams.set(availabilityParamName, '0');
                            outURL.searchParams.set('page', '1');
                            moreAnchor.href = outURL.toString();
                            moreAnchor.innerHTML = watcher.dataset.noticelabel;
                        } else moreAnchor.remove();
                    } else if (phase === 'inStock' && !hasExplicitAvailabilityFilter()) {
                        phase = 'outOfStock';
                        const outURL = new URL(moreAnchor.baseURI);
                        const availabilityInput = document.querySelector('li[data-radio-group="availability"] input');
                        const availabilityParamName = availabilityInput ? availabilityInput.name : 'filter.v.availability';
                        outURL.searchParams.set(availabilityParamName, '0');
                        outURL.searchParams.set('page', '1');
                        moreAnchor.href = outURL.toString();
                        moreAnchor.innerHTML = watcher.dataset.noticelabel;
                    } else moreAnchor.remove();
                }
            } catch (error) {
                console.error(error);
                moreAnchor.style.pointerEvents = 'auto';
            }
            window.dispatchEvent(new Event('more-content-loaded'));
        }
        // Start the combined init logic
        init();
    }
}
customElements.define('infinite-scroll-pagination', $327f21513f7983f9$var$InfiniteScrollPagination);


function $aae3385802a54085$var$isMobile() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}
// The accordion lives inside the product-info container, so a packs-dropdown
// repaint replaces it with fresh markup. Re-run init on `product-info-repainted`
// so the new headers get their click handlers (handlers are assigned via
// `onclick`, so re-running never stacks listeners).
$aae3385802a54085$var$initAccordion();
window.addEventListener('product-info-repainted', $aae3385802a54085$var$initAccordion);
function $aae3385802a54085$var$initAccordion() {
    const accContainer = document.querySelector('.info-accordion__container');
    if (!accContainer) return;
    // Manually opening the tab with class 'styled-with-slider'
    const styledWithSliderPanel = accContainer.querySelector('#styled-with-slider');
    if (styledWithSliderPanel) {
        styledWithSliderPanel.previousElementSibling.classList.add('active');
        styledWithSliderPanel.style.maxHeight = styledWithSliderPanel.scrollHeight + 'px';
    }
    const acc = accContainer.querySelectorAll('.info-accordion__header');
    // Manually opening and closing tabs
    acc.forEach((item)=>{
        if (item.dataset.desktopOpen === 'true' && !$aae3385802a54085$var$isMobile()) {
            item.classList.add('active');
            if (item.nextElementSibling) item.nextElementSibling.style.maxHeight = item.nextElementSibling.scrollHeight + 'px';
        }
        item.onclick = function() {
            let panel = this.nextElementSibling;
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                if (panel) panel.style.maxHeight = null;
            } else {
                acc.forEach((item2)=>{
                    if (item2) {
                        item2.classList.remove('active');
                        if (item2.nextElementSibling) item2.nextElementSibling.style.maxHeight = null;
                    }
                });
                this.classList.add('active');
                if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
            }
        };
    });
}


const $55fa5e4ca058fc8f$export$d9e84cf132188bd9 = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate"
};
const $55fa5e4ca058fc8f$export$17c596ad066dd33e = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
    "/cart/add.js",
    "/cart/update.js",
    "/cart/change.js",
    "/cart/clear.js"
];


let $5833cbeca986fbef$var$freeShippingAmount;
let $5833cbeca986fbef$var$shippingPlaceholder;
let $5833cbeca986fbef$var$giftPlaceholder;
let $5833cbeca986fbef$var$cartCurrency = '';
let $5833cbeca986fbef$var$$counterCaptionBelow = document.querySelector('.counter__caption--below');
let $5833cbeca986fbef$var$$counterCaptionAboveInitial = document.querySelector('.counter__caption--above');
if ($5833cbeca986fbef$var$$counterCaptionBelow) {
    $5833cbeca986fbef$var$shippingPlaceholder = $5833cbeca986fbef$var$$counterCaptionBelow.dataset.freeShippingText;
    $5833cbeca986fbef$var$giftPlaceholder = $5833cbeca986fbef$var$$counterCaptionBelow.dataset.freeGiftText;
}
let $5833cbeca986fbef$var$freeShippingDisabled = $5833cbeca986fbef$var$$counterCaptionAboveInitial.dataset.freeShippingDisabled;
let $5833cbeca986fbef$var$freeShippingEnabled = $5833cbeca986fbef$var$$counterCaptionAboveInitial.dataset.freeShippingEnabled;
let $5833cbeca986fbef$var$freeGiftDisabled = $5833cbeca986fbef$var$$counterCaptionAboveInitial.dataset.freeGiftDisabled;
let $5833cbeca986fbef$var$freeGiftShippingEnabled = $5833cbeca986fbef$var$$counterCaptionAboveInitial.dataset.freeGiftShippingEnabled;
let $5833cbeca986fbef$var$cartFetched = false;
function $5833cbeca986fbef$export$2363dce3b16cd138() {
    let giftAmount = Number(document.querySelector('.cart-countdown').dataset.minGift).toFixed(2);
    $5833cbeca986fbef$var$freeShippingAmount = Number(sessionStorage.getItem('CountryMinFreeShipping')).toFixed(2);
    if ($5833cbeca986fbef$var$cartFetched) return;
    $5833cbeca986fbef$var$cartFetched = true;
    fetch('/cart.js', {
        cache: 'no-store'
    }).then((response)=>{
        if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
        return response.json();
    }).then((data)=>{
        // The store/cart currency (e.g. DKK) - the locale strings used to
        // hardcode a EUR symbol, wrong on every non-euro market.
        $5833cbeca986fbef$var$cartCurrency = data.currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '';
        // Use total_price (after all discounts, incl. cart-level discount codes) rather than
        // items_subtotal_price (line-item discounts only) so the free-shipping progress reflects
        // discount codes applied at checkout. See BLE-11137.
        // MERGE 2026-09-16: two independent fixes to the same two lines — the currency fix is
        // mine, the total_price fix is the PDP track's. Both are wanted; neither supersedes
        // the other, so both are kept.
        const cartValue = (data.total_price / 100).toFixed(2);
        if (giftAmount) {
            $5833cbeca986fbef$var$dividerPosition($5833cbeca986fbef$var$freeShippingAmount, giftAmount, cartValue);
            $5833cbeca986fbef$var$messageControler($5833cbeca986fbef$var$freeShippingAmount, giftAmount, cartValue);
        } else {
            $5833cbeca986fbef$var$messageControler($5833cbeca986fbef$var$freeShippingAmount, 0, cartValue);
            $5833cbeca986fbef$var$dividerPosition($5833cbeca986fbef$var$freeShippingAmount, 0, cartValue);
        }
    }).catch((error)=>{
        console.error('Unable to fetch cart data', error);
        $5833cbeca986fbef$var$cartFetched = false;
    });
}
function $5833cbeca986fbef$var$dividerPosition(freeShippingAmount, giftAmount, cartValue) {
    if (giftAmount > 0) {
        let divider = document.querySelector('.progress-bar__free-gift--line');
        let max;
        let dividerPercentage;
        let dividerTextFirst = document.querySelector('.counter-progress__placeholder--first');
        let dividerTextLast = document.querySelector('.counter-progress__placeholder--last');
        if (Math.round(freeShippingAmount * 100) > Math.round(giftAmount * 100)) {
            dividerPercentage = (giftAmount / freeShippingAmount * 100).toFixed(2);
            dividerTextFirst.innerHTML = $5833cbeca986fbef$var$giftPlaceholder;
            dividerTextLast.innerHTML = $5833cbeca986fbef$var$shippingPlaceholder;
            max = freeShippingAmount;
        } else {
            dividerPercentage = (freeShippingAmount / giftAmount * 100).toFixed(2);
            dividerTextFirst.innerHTML = $5833cbeca986fbef$var$shippingPlaceholder;
            dividerTextLast.innerHTML = $5833cbeca986fbef$var$giftPlaceholder;
            max = giftAmount;
        }
        divider.style.left = dividerPercentage + '%';
        dividerTextFirst.style.flexBasis = dividerPercentage + '%';
        $5833cbeca986fbef$var$animateProgressBar(cartValue, max);
    } else $5833cbeca986fbef$var$animateProgressBar(cartValue, freeShippingAmount);
}
function $5833cbeca986fbef$var$animateProgressBar(cartValue, max) {
    let progressBar = document.querySelector('.progress-bar__filling');
    let progressWidth = cartValue / max * 100;
    if (progressBar) {
        progressBar.style.width = progressWidth + '%';
        console.log('Progress bar updated');
    } else console.log('Progress bar element not found');
}
function $5833cbeca986fbef$var$stringReplace(initialText, difference) {
    const amount = Math.abs(difference).toFixed(2) + ($5833cbeca986fbef$var$cartCurrency ? ` ${$5833cbeca986fbef$var$cartCurrency}` : '');
    // 'XXXX€' fallback covers cached/untranslated locale strings that still
    // carry the hardcoded euro sign.
    return initialText.replace("XXXX\u20AC", 'XXXX').replace('XXXX', amount);
}
function $5833cbeca986fbef$var$messageControler(freeShippingAmount, giftAmount, cartValue) {
    let firstMessage;
    let secondMessage;
    let thirdMessage;
    let $counterCaptionAbove = document.querySelector('.counter__caption--above');
    if (giftAmount > 0) {
        if (Math.round(freeShippingAmount * 100) > Math.round(giftAmount * 100)) {
            firstMessage = $5833cbeca986fbef$var$freeGiftDisabled;
            secondMessage = $5833cbeca986fbef$var$freeShippingDisabled;
            thirdMessage = $5833cbeca986fbef$var$freeGiftShippingEnabled;
            if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) $counterCaptionAbove.innerHTML = thirdMessage;
            else if (Math.round(cartValue * 100) > Math.round(giftAmount * 100)) {
                let difference = cartValue - freeShippingAmount;
                $counterCaptionAbove.innerHTML = $5833cbeca986fbef$var$stringReplace(secondMessage, difference);
            } else {
                let difference = cartValue - giftAmount;
                $counterCaptionAbove.innerHTML = $5833cbeca986fbef$var$stringReplace(firstMessage, difference);
            }
        } else {
            firstMessage = $5833cbeca986fbef$var$freeShippingDisabled;
            secondMessage = $5833cbeca986fbef$var$freeGiftDisabled;
            thirdMessage = $5833cbeca986fbef$var$freeGiftShippingEnabled;
            if (Math.round(cartValue * 100) > Math.round(giftAmount * 100)) $counterCaptionAbove.innerHTML = thirdMessage;
            else if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) {
                let difference = cartValue - giftAmount;
                $counterCaptionAbove.innerHTML = $5833cbeca986fbef$var$stringReplace(secondMessage, difference);
            } else {
                let difference = cartValue - freeShippingAmount;
                $counterCaptionAbove.innerHTML = $5833cbeca986fbef$var$stringReplace(firstMessage, difference);
            }
        }
    } else {
        firstMessage = $5833cbeca986fbef$var$freeShippingDisabled;
        secondMessage = $5833cbeca986fbef$var$freeShippingEnabled;
        if (Math.round(cartValue * 100) > Math.round(freeShippingAmount * 100)) $counterCaptionAbove.innerHTML = secondMessage;
        else {
            let difference = cartValue - freeShippingAmount;
            $counterCaptionAbove.innerHTML = $5833cbeca986fbef$var$stringReplace(firstMessage, difference);
        }
    }
}
(function() {
    if (!window || !window.Shopify) return;
    function isShopifyCartURL(url) {
        if (!url || url.href?.includes('?page=')) return false;
        const path = url.split('/').pop();
        return (0, $55fa5e4ca058fc8f$export$17c596ad066dd33e).includes(`/cart/${path}`);
    }
    function updateType(url) {
        if (!url) return false;
        if (url.includes('cart/add')) return 'add';
        else if (url.includes('cart/update')) return 'update';
        else if (url.includes('cart/change')) return 'change';
        else if (url.includes('cart/clear')) return 'clear';
        else return false;
    }
    function dispatchEvent(url, detail) {
        if (typeof detail === 'string') try {
            detail = JSON.parse(detail);
        } catch  {}
        window.dispatchEvent(new CustomEvent((0, $55fa5e4ca058fc8f$export$d9e84cf132188bd9).mutate, {
            detail: detail
        }));
        const type = updateType(url);
        switch(type){
            case 'add':
                window.dispatchEvent(new CustomEvent((0, $55fa5e4ca058fc8f$export$d9e84cf132188bd9).add, {
                    detail: detail
                }));
                break;
            case 'update':
                window.dispatchEvent(new CustomEvent((0, $55fa5e4ca058fc8f$export$d9e84cf132188bd9).update, {
                    detail: detail
                }));
                break;
            case 'change':
                window.dispatchEvent(new CustomEvent((0, $55fa5e4ca058fc8f$export$d9e84cf132188bd9).change, {
                    detail: detail
                }));
                break;
            case 'clear':
                window.dispatchEvent(new CustomEvent((0, $55fa5e4ca058fc8f$export$d9e84cf132188bd9).clear, {
                    detail: detail
                }));
                break;
            default:
                break;
        }
    }
    function XHROverride() {
        if (!window.XMLHttpRequest) return;
        const originalOpen = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function() {
            const url = arguments[1];
            this.addEventListener('load', function() {
                if (isShopifyCartURL(url)) dispatchEvent(url, this.response);
            });
            return originalOpen.apply(this, arguments);
        };
    }
    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== 'function') return;
        const originalFetch = window.fetch;
        window.fetch = function() {
            const argument = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;
            const response = originalFetch.apply(this, arguments);
            if (isShopifyCartURL(argument)) response.then((res)=>{
                res.clone().json().then((data)=>dispatchEvent(res.url, data));
            });
            return response;
        };
    }
    fetchOverride();
    XHROverride();
})();
window.addEventListener('rendered-cart', ()=>{
    console.log('rendered-cart event triggered');
    setTimeout(()=>{
        $5833cbeca986fbef$var$cartFetched = false;
        $5833cbeca986fbef$export$2363dce3b16cd138();
    }, 100);
});


let $c6ca6864d06916d1$var$shippingModalInitialized = false;
function $c6ca6864d06916d1$export$703d9b492af7fd15() {
    if ($c6ca6864d06916d1$var$shippingModalInitialized) return;
    if (!document.querySelector('[shipping-modal-enabled]')) return;
    const start = ()=>{
        if ($c6ca6864d06916d1$var$shippingModalInitialized) return;
        $c6ca6864d06916d1$var$shippingModalInitialized = true;
        $c6ca6864d06916d1$var$setupShippingModalFeature();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {
        once: true
    });
    else start();
}
function $c6ca6864d06916d1$var$setupShippingModalFeature() {
    const shippingAnnouncementElements = Array.from(document.querySelectorAll('[shipping-modal-enabled]'));
    if (!shippingAnnouncementElements.length) return;
    let countryMinFreeShipping = sessionStorage.getItem('CountryMinFreeShipping');
    let searchInitialized = false;
    const replaceVariables = (token, replacement)=>{
        if (!token || replacement == null) return;
        shippingAnnouncementElements.forEach((wrapper)=>{
            const announcementText = wrapper.querySelector('.announcement-bar__text');
            if (!announcementText || !announcementText.textContent.includes(token)) return;
            announcementText.textContent = announcementText.textContent.replace(token, replacement);
        });
    };
    const checkFreeShippingAmount = (matchesFilter, element)=>{
        if (countryMinFreeShipping) {
            const formatted = Number(countryMinFreeShipping).toFixed(2);
            replaceVariables('[VALUE]', formatted);
            (0, $5833cbeca986fbef$export$2363dce3b16cd138)();
        } else if (matchesFilter && element) {
            const amountElement = element.querySelector('.free.min-amount');
            if (!amountElement) return;
            const [amountValue] = amountElement.textContent.trim().split(' ');
            if (!amountValue) return;
            sessionStorage.setItem('CountryMinFreeShipping', amountValue);
            countryMinFreeShipping = amountValue;
            replaceVariables('[VALUE]', Number(amountValue).toFixed(2));
            (0, $5833cbeca986fbef$export$2363dce3b16cd138)();
        }
    };
    const workingDays = window.shippingTranslationKeys?.['shipping_modal.shipping_table.working_days'] || '';
    const currencySymbols = {
        EUR: "\u20AC",
        USD: '$',
        GBP: "\xa3",
        DKK: 'DKK'
    };
    const getCurrencySymbol = ()=>{
        const activeCurrency = window.Shopify?.currency?.active;
        return currencySymbols[activeCurrency] || activeCurrency || '';
    };
    const buildShippingRow = (entry, includeCountry, rowSpan)=>{
        const row = document.createElement('tr');
        row.classList.add('shipping-row');
        if (includeCountry) {
            const countryCell = document.createElement('th');
            countryCell.classList.add('country', 'col--country');
            countryCell.scope = 'rowgroup';
            countryCell.rowSpan = rowSpan;
            countryCell.textContent = entry.country || '';
            row.appendChild(countryCell);
        }
        const shippingCell = document.createElement('th');
        shippingCell.classList.add('shipping', 'col--shipping');
        shippingCell.scope = 'row';
        shippingCell.textContent = entry.shipping_name || '';
        row.appendChild(shippingCell);
        const deliveryCell = document.createElement('td');
        deliveryCell.classList.add('delivery', 'col--delivery');
        const deliveryDays = entry.days?.split(' ')[0] || '';
        deliveryCell.textContent = [
            deliveryDays,
            workingDays
        ].filter(Boolean).join(' ').trim();
        row.appendChild(deliveryCell);
        const priceCell = document.createElement('td');
        priceCell.classList.add('price');
        const hasPrice = entry.price !== undefined && entry.price !== null && entry.price !== '';
        priceCell.textContent = hasPrice ? `${entry.price} ${getCurrencySymbol()}`.trim() : '';
        row.appendChild(priceCell);
        const freeCell = document.createElement('td');
        freeCell.classList.add('free');
        const hasFreeThreshold = entry.free_above !== undefined && entry.free_above !== null && entry.free_above !== '';
        if (entry.free_above === 'N/A') {
            freeCell.textContent = entry.free_above;
            freeCell.classList.remove('min-amount');
        } else if (hasFreeThreshold) {
            freeCell.classList.add('min-amount');
            freeCell.textContent = `${entry.free_above} ${getCurrencySymbol()}`.trim();
        }
        row.appendChild(freeCell);
        return row;
    };
    const toAmount = (value)=>{
        if (value === undefined || value === null || value === '' || value === 'N/A') return null;
        const num = Number(value);
        return Number.isFinite(num) ? num : null;
    };
    // Shopify keeps one rate per price band, so a method that is paid below its
    // free-shipping threshold arrives as TWO rows ("Royal Mail 8.0 / N/A" plus
    // "Royal Mail 0.0 / 90.0") - which rendered as a duplicated method, one of
    // them claiming to cost 0. The table already has a Price column and a Free
    // above column, so fold the bands into one row per method: cheapest paid
    // band as the price, lowest threshold as the free-above amount. Original
    // strings are carried over so the displayed formatting is unchanged.
    const mergeCountryEntries = (entries)=>{
        const order = [];
        const merged = new Map();
        entries.forEach((entry)=>{
            const key = `${entry.shipping_name || ''}||${entry.days || ''}`;
            if (!merged.has(key)) {
                order.push(key);
                merged.set(key, {
                    entry: {
                        ...entry
                    },
                    price: null,
                    priceRaw: '',
                    free: null,
                    freeRaw: 'N/A'
                });
            }
            const slot = merged.get(key);
            const price = toAmount(entry.price);
            if (price !== null && price > 0 && (slot.price === null || price < slot.price)) {
                slot.price = price;
                slot.priceRaw = entry.price;
            }
            const free = toAmount(entry.free_above);
            if (free !== null && (slot.free === null || free < slot.free)) {
                slot.free = free;
                slot.freeRaw = entry.free_above;
            }
        });
        // price '' = the method only exists above its free threshold, so no amount
        // applies below it; the Free above column carries the meaning on its own.
        return order.map((key)=>{
            const slot = merged.get(key);
            return {
                ...slot.entry,
                price: slot.priceRaw,
                free_above: slot.freeRaw
            };
        });
    };
    const populateTable = (data)=>{
        if (!Array.isArray(data) || !data.length) return;
        const table = document.querySelector('.shipping-prices-table');
        if (!table || table.dataset.populated === 'true') return;
        const templateBody = table.querySelector('tbody.country.tbody-country');
        if (!templateBody) return;
        templateBody.innerHTML = '';
        const fragment = document.createDocumentFragment();
        data.forEach((countryEntries, index)=>{
            if (!Array.isArray(countryEntries) || !countryEntries.length) return;
            const targetBody = index === 0 ? templateBody : templateBody.cloneNode(false);
            targetBody.innerHTML = '';
            const entries = mergeCountryEntries(countryEntries);
            entries.forEach((entry, entryIndex)=>{
                const row = buildShippingRow(entry, entryIndex === 0, entries.length);
                targetBody.appendChild(row);
            });
            if (index !== 0) fragment.appendChild(targetBody);
        });
        if (fragment.childNodes.length) table.appendChild(fragment);
        table.dataset.populated = 'true';
    };
    const setBodyVisibility = (tbody, shouldShow)=>{
        tbody.style.display = shouldShow ? '' : 'none';
    };
    const toggleCountryDetails = (tbody)=>{
        const paragraphs = tbody.querySelectorAll('p');
        paragraphs.forEach((paragraph)=>{
            const isHidden = paragraph.hasAttribute('hidden');
            if (isHidden) {
                paragraph.removeAttribute('hidden');
                paragraph.style.display = '';
            } else {
                paragraph.setAttribute('hidden', 'true');
                paragraph.style.display = 'none';
            }
            paragraph.classList.toggle('el-content');
        });
    };
    const inputCountryCheck = ()=>{
        if (searchInitialized) return;
        const searchInput = document.getElementById('shipping-search');
        if (!searchInput) return;
        const countryBodies = Array.from(document.querySelectorAll('.shipping-info-container__table tbody.country'));
        if (!countryBodies.length) return;
        const updateVisibility = ()=>{
            const query = searchInput.value.trim().toLowerCase();
            let matches = 0;
            if (query.length > 2) {
                countryBodies.forEach((tbody)=>{
                    const text = tbody.textContent.toLowerCase();
                    const isMatch = text.includes(query);
                    setBodyVisibility(tbody, isMatch);
                    if (isMatch) matches += 1;
                    checkFreeShippingAmount(isMatch, tbody);
                });
                if (matches === 0) countryBodies.forEach((tbody)=>{
                    const isRestOfWorld = tbody.textContent.toLowerCase().includes('rest of world');
                    setBodyVisibility(tbody, isRestOfWorld);
                    checkFreeShippingAmount(isRestOfWorld, tbody);
                });
            } else countryBodies.forEach((tbody)=>{
                const isRestOfWorld = tbody.textContent.toLowerCase().includes('rest of world');
                setBodyVisibility(tbody, isRestOfWorld);
                checkFreeShippingAmount(isRestOfWorld, tbody);
            });
        };
        [
            'input',
            'change',
            'focus',
            'keyup'
        ].forEach((eventName)=>{
            searchInput.addEventListener(eventName, updateVisibility);
        });
        countryBodies.forEach((tbody)=>{
            tbody.addEventListener('click', ()=>toggleCountryDetails(tbody));
        });
        searchInitialized = true;
        updateVisibility();
    };
    // If the placeholders were never resolved (no shipping row for the visitor's country,
    // rates endpoint down, etc.) swap the announcement to its neutral fallback text instead
    // of showing "Free shipping to Denmark above [VALUE] USD".
    const applyFallbackIfUnresolved = ()=>{
        shippingAnnouncementElements.forEach((wrapper)=>{
            const announcementText = wrapper.querySelector('.announcement-bar__text');
            if (!announcementText) return;
            const txt = announcementText.textContent;
            if (!txt.includes('[VALUE]') && !txt.includes('[COUNTRY]') && !txt.includes('[CURRENCY]')) return;
            const fallback = wrapper.dataset.textFallback;
            if (fallback) announcementText.textContent = fallback;
        });
    };
    let fallbackTimer = null;
    const scheduleFallback = (ms = 2500)=>{
        clearTimeout(fallbackTimer);
        fallbackTimer = setTimeout(applyFallbackIfUnresolved, ms);
    };
    const triggerSearchUpdate = ()=>{
        const searchInput = document.getElementById('shipping-search');
        if (searchInput) searchInput.dispatchEvent(new Event('input', {
            bubbles: true
        }));
        scheduleFallback();
    };
    const fetchLocationInformation = async ()=>{
        // Shopify's native geolocation suggestion endpoint (same-origin, free) -
        // replaces the former api.ipstack.com call and its paid access key.
        try {
            const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
            const response = await fetch(`${root}browsing_context_suggestions.json?source=geolocation_recommendation&country%5Benabled%5D=true`);
            const data = await response.json();
            const countryName = data?.detected_values?.country_name || '';
            const countryCode = data?.detected_values?.country?.handle || '';
            const shippingSearch = document.getElementById('shipping-search');
            if (shippingSearch) shippingSearch.value = countryName;
            if (countryName) {
                sessionStorage.setItem('IPStackVisitorCountry', countryName);
                replaceVariables('[COUNTRY]', countryName);
                triggerSearchUpdate();
            }
            if (countryCode && countryCode !== window.Shopify.country) document.querySelector('.country-redirect-modal')?.open();
        } catch (error) {
            console.error('Unable to fetch location information', error);
        }
    };
    const fetchShippingRates = async ()=>{
        try {
            let data;
            const storedRates = sessionStorage.getItem('StoreShippingRates');
            if (storedRates) data = JSON.parse(storedRates);
            else {
                const store = window.Shopify?.shop || '';
                const response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getShippingZones?store=${store}`);
                data = await response.json();
                sessionStorage.setItem('StoreShippingRates', JSON.stringify(data));
            }
            populateTable(data);
            inputCountryCheck();
            triggerSearchUpdate();
        } catch (error) {
            console.error('Unable to fetch shipping rates', error);
            applyFallbackIfUnresolved();
        }
    };
    const visitorCountry = sessionStorage.getItem('IPStackVisitorCountry');
    const shippingSearch = document.getElementById('shipping-search');
    if (visitorCountry && shippingSearch) {
        shippingSearch.value = visitorCountry;
        fetchShippingRates();
        replaceVariables('[COUNTRY]', visitorCountry);
        triggerSearchUpdate();
    } else {
        fetchLocationInformation();
        fetchShippingRates();
    }
    // safety net: never leave raw placeholders on screen
    scheduleFallback(6000);
    document.querySelectorAll('#shopify-section-announcement-bar .announcement-bar[shipping-modal-enabled]').forEach((el)=>{
        el.addEventListener('click', ()=>{
            const modal = document.querySelector('.shipping-modal');
            if (modal?.open) modal.open();
        });
    });
}


window.addEventListener('load', ()=>{
    const wrapperElement = document.querySelector('.announcement-bar__wrapper');
    if (!wrapperElement) return;
    function mainCarouselFunc() {
        // Get the first announcement bar with custom color
        const announcementBarFirst = wrapperElement.querySelector('.announcement-bar[custom-color]');
        if (announcementBarFirst) {
            const bgColor = announcementBarFirst.dataset.color || '';
            const textColor = announcementBarFirst.dataset.textColor || '';
            // Apply styles
            announcementBarFirst.style.backgroundColor = bgColor;
            // Update text elements
            const textElements = announcementBarFirst.querySelectorAll('.announcement-bar__text, .announcement-bar__arrow');
            textElements.forEach((el)=>{
                el.style.color = textColor;
            });
        }
        // Get all visible announcement bars
        const allBars = Array.from(wrapperElement.querySelectorAll('.announcement-bar:not(.hidden)'));
        const messagesCount = allBars.length;
        const interval = (parseInt(wrapperElement.dataset.interval, 10) || 5) * 1000; // Default to 5 seconds if not set
        const transition = wrapperElement.dataset.transitionSpeed || 'standard';
        const isCarousel = wrapperElement.dataset.isCarousel === 'true';
        // Set transition speed based on setting
        let transitionSpeed;
        switch(transition){
            case 'swift':
                transitionSpeed = 400;
                break;
            case 'standard':
                transitionSpeed = 600;
                break;
            case 'slow':
                transitionSpeed = 1000;
                break;
            default:
                transitionSpeed = 600; // Default to standard if not specified
        }
        // Set initial active class
        const firstBar = allBars[0];
        if (firstBar) firstBar.classList.add('active');
        // Set up the carousel interval if needed
        if (messagesCount > 1 && isCarousel) setInterval(()=>carousel(transitionSpeed), interval);
        function carousel(speed) {
            // Set the transition speed in CSS custom property
            document.documentElement.style.setProperty('--transition-speed', `${speed}ms`);
            const active = wrapperElement.querySelector('.announcement-bar.active');
            if (!active) return;
            const bars = Array.from(wrapperElement.querySelectorAll('.announcement-bar'));
            if (bars.length < 2) return;
            const next = active.nextElementSibling && active.nextElementSibling.classList.contains('announcement-bar') ? active.nextElementSibling : wrapperElement.querySelector('.announcement-bar');
            if (!next) return;
            // Set dynamic colors if needed
            if (next.hasAttribute('custom-color')) {
                next.style.setProperty('--announcement-bg-color', next.dataset.color || 'transparent');
                const textElement = next.querySelector('.announcement-bar__text');
                if (textElement) textElement.style.color = next.dataset.textColor || '';
            }
            // Set initial z-index for proper stacking
            next.style.zIndex = '2';
            // Remove active class from current and add to next
            active.classList.remove('active');
            next.classList.add('active');
            // After transition completes, cleanup z-index
            const onTransitionEnd = ()=>{
                next.style.zIndex = '';
                next.removeEventListener('transitionend', onTransitionEnd);
                // Reset the transition speed to default after animation
                document.documentElement.style.removeProperty('--transition-speed');
            };
            // Add transition end listener
            next.addEventListener('transitionend', onTransitionEnd, {
                once: true
            });
            // Fallback in case transitionend doesn't fire
            const fallbackTimeout = setTimeout(()=>{
                next.style.zIndex = '';
                next.removeEventListener('transitionend', onTransitionEnd);
                document.documentElement.style.removeProperty('--transition-speed');
            }, speed + 50);
            // Clean up the timeout when transition ends
            next.addEventListener('transitionend', ()=>clearTimeout(fallbackTimeout), {
                once: true
            });
        }
    }
    function mainCountdown() {
        const shopName = wrapperElement.dataset.shopName || '';
        const timezone = (()=>{
            switch(shopName){
                case 'Organic Basics US':
                    return 'America/New_York';
                case 'Organic Basics UK':
                    return 'Europe/London';
                case 'Organic Basics EU':
                default:
                    return 'Europe/Copenhagen';
            }
        })();
        const now = new Date();
        const currentTime = now.getTime();
        const countdownElements = document.querySelectorAll('.announcement-countdown');
        countdownElements.forEach((currEl)=>{
            const currItem = currEl.closest('.announcement-bar');
            itemCountdown(currEl, currItem);
        });
        function parseDateArray(value) {
            if (!value) return null;
            const parts = value.split(',').map((segment)=>Number(segment.trim()));
            if (parts.length < 5 || parts.some((part)=>Number.isNaN(part))) return null;
            parts[1] -= 1;
            return parts;
        }
        function buildDate(dateParts) {
            const date = new Date(dateParts[0], dateParts[1], dateParts[2], dateParts[3], dateParts[4]);
            return new Date(date.toLocaleString('en-US', {
                timezone: timezone
            }));
        }
        function updateCountdownValue(element, selector, value) {
            const target = element.querySelector(selector);
            if (target) target.textContent = value;
        }
        function itemCountdown(currEl, currItem) {
            // Set due date
            const dueDateParts = parseDateArray(currEl.dataset.dueDate);
            if (!dueDateParts) return;
            const dueDate = buildDate(dueDateParts);
            const dueEventTime = dueDate.getTime();
            const remTime = dueEventTime - currentTime;
            // Set from date
            const fromDateParts = parseDateArray(currEl.dataset.fromDate);
            if (!fromDateParts) return;
            const fromDate = buildDate(fromDateParts);
            const fromEventTime = fromDate.getTime();
            if (fromEventTime > currentTime) {
                currItem?.remove();
                return;
            }
            if (dueEventTime < currentTime) {
                currItem?.remove();
                return;
            }
            let sec = Math.floor(remTime / 1000);
            let min = Math.floor(sec / 60);
            let hour = Math.floor(min / 60);
            let day = Math.floor(hour / 24);
            hour %= 24;
            min %= 60;
            sec %= 60;
            updateCountdownValue(currEl, '.days', day);
            updateCountdownValue(currEl, '.hours', hour);
            updateCountdownValue(currEl, '.minutes', min);
            updateCountdownValue(currEl, '.seconds', sec);
        }
        setTimeout(mainCountdown, 1000);
    }
    function notShownOnThisPage() {
        wrapperElement.querySelectorAll('.not-shown-on-this-page').forEach((el)=>el.remove());
        if (!wrapperElement.children.length) wrapperElement.remove();
    }
    notShownOnThisPage();
    mainCountdown();
    mainCarouselFunc();
    // Second call serves as a callback function once carousel changed DOM
    notShownOnThisPage();
    (0, $c6ca6864d06916d1$export$703d9b492af7fd15)();
});
class $702e7ba34898c3e9$var$AnnouncementBarWrapper extends HTMLElement {
    constructor(){
        super();
        this.announcementBarMessages = [];
        this.observer = null;
    }
    connectedCallback() {
        this.announcementBarMessages = Array.from(this.querySelectorAll('.announcement-bar__text'));
        if (this.announcementBarMessages.length === 0) return;
        this.equalizeHeights();
        this.observeResize();
    }
    equalizeHeights() {
        let maxHeight = 0;
        // Reset height and measure
        this.announcementBarMessages.forEach((bar)=>{
            const height = bar.offsetHeight;
            if (height > maxHeight) maxHeight = height;
        });
        this.style.height = `${maxHeight + 8}px`; // Padding
    }
    observeResize() {
        if (typeof ResizeObserver === 'undefined') return;
        this.observer = new ResizeObserver(()=>{
            this.equalizeHeights();
        });
        this.announcementBarMessages.forEach((bar)=>{
            this.observer.observe(bar);
        });
    }
    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }
}
customElements.define('announcement-bar-wrapper', $702e7ba34898c3e9$var$AnnouncementBarWrapper);


class $e7497bf6d673cf5a$var$BundleProduct extends HTMLElement {
    constructor(){
        super();
        this.selectedValues = [];
        this.variantData = {};
        this.configured = false;
        this.setOrderDisplay(this.order);
        this.setAvailableOptions();
        this.addEvents();
    }
    set co2(co2) {
        this.co2 = co2;
    }
    get co2() {
        return parseInt(this.querySelector("[co2-footprint]")?.textContent);
    }
    set variantData(variantData) {}
    get variantData() {
        let varId = null;
        let varAvailable = false;
        let firstAvailableVariant, foundFirstAvailableVariant = false;
        this.querySelectorAll("#product-variant-ids option").forEach((opt)=>{
            let productVariantNrs = [
                "V1",
                "V2",
                "V3",
                "V4",
                "RPK"
            ];
            const supportsProdVersions = productVariantNrs.some((prodV)=>opt.textContent?.includes(prodV));
            if (supportsProdVersions) variantVersionLoop: for (const productVariantNr of productVariantNrs){
                let selectedValues = productVariantNr + " / " + this.selectedValues[0] + " / " + this.selectedValues[1];
                if (selectedValues.trim() == opt.textContent.trim()) {
                    varId = opt.value;
                    varAvailable = opt.getAttribute("available") === "true" ? true : false;
                    if (varAvailable && !foundFirstAvailableVariant) {
                        foundFirstAvailableVariant = true;
                        firstAvailableVariant = {
                            id: varId,
                            available: varAvailable
                        };
                        break variantVersionLoop;
                    }
                }
            }
            else {
                let selectedValues = this.selectedValues[0] + " / " + this.selectedValues[1];
                if (selectedValues.trim() == opt.textContent.trim()) {
                    varId = opt.value;
                    varAvailable = opt.getAttribute("available") === "true" ? true : false;
                    if (varAvailable && !foundFirstAvailableVariant) {
                        foundFirstAvailableVariant = true;
                        firstAvailableVariant = {
                            id: varId,
                            available: varAvailable
                        };
                    }
                }
            }
        });
        return firstAvailableVariant || {
            id: varId,
            available: varAvailable
        };
    }
    set productId(productId) {
        this.setAttribute('prod-id', productId);
    }
    get productId() {
        return this.getAttribute("prod-id");
    }
    set order(order) {
        this.setAttribute("order", order);
    }
    get order() {
        return this.getAttribute("data-order");
    }
    get selectors() {
        return this.querySelectorAll("custom-select");
    }
    setAvailableOptions() {
        //get variant ids and availability
        const productVariantOptions = Array.from(this.querySelectorAll("#product-variant-ids option"));
        const productVariantInfo = productVariantOptions.map((productVariantOption)=>[
                productVariantOption.textContent,
                productVariantOption.getAttribute("available")
            ]);
        //get all selectors, all options, and compare with the availability array combinations;
        let productSelectors = [];
        this.selectors.forEach((selector)=>{
            productSelectors.push(selector.options);
        });
        // remove duplicates
        let uniqueOptionTexts = {};
        productSelectors.forEach((selector)=>{
            selector.forEach((option)=>{
                var text = option.textContent;
                if (uniqueOptionTexts[text]) option.style.display = "none";
                else uniqueOptionTexts[text] = true;
            });
        });
        productSelectors.forEach((selector, selectorIndex)=>{
            selector.forEach((option)=>{
                let optionAvailability;
                if (selectorIndex != 0 && this.selectedValues[0] != null) option.setAttribute("available", "false");
                productVariantInfo.forEach((variant)=>{
                    let productVersionNrs = [
                        "V1",
                        "V2",
                        "V3",
                        "V4",
                        "RPK"
                    ];
                    const supportsProdVersions = productVersionNrs.some((prodV)=>variant[0]?.includes(prodV));
                    if (supportsProdVersions) variantVersionLoop: for (const productVariant of productVersionNrs){
                        let selectedValues = productVariant + " / " + this.selectedValues[0] + " / ";
                        if (variant[0].includes(selectedValues + option.textContent)) {
                            optionAvailability = variant[1];
                            if (variant[1] == 'true') {
                                option.setAttribute("available", optionAvailability);
                                break variantVersionLoop;
                            }
                        }
                    }
                    else {
                        let selectedValues = this.selectedValues[0] + " / ";
                        if (variant[0].includes(selectedValues + option.textContent)) {
                            optionAvailability = variant[1];
                            if (variant[1] == 'true') option.setAttribute("available", optionAvailability);
                        }
                    }
                });
            });
        });
    }
    setOrderDisplay(order, color, configured) {
        this.querySelector("[order-display] .color-swatch").textContent = order;
        color && this.querySelector("[order-display]").setAttribute("data-color", color);
        configured && this.querySelector("[order-display] [success-checkmark]").classList.remove('hidden');
    }
    addEvents() {
        let _this = this;
        this.selectors.forEach((selector)=>{
            selector.addEventListener("click", function() {
                _this.checkConfigured();
                _this.setAvailableOptions();
                _this.setConfiguredDisplay();
            });
        });
    }
    checkConfigured() {
        let allSelectorsChosen = true;
        this.selectedValues = [];
        this.selectors.forEach((selector)=>{
            if (selector.getAttribute("value") == null) allSelectorsChosen = false;
            else this.selectedValues.push(selector.getAttribute("value"));
        });
        if (allSelectorsChosen) {
            if (this.variantData.available == true) {
                this.configured = true;
                this.querySelector("[error-variant-unavailable]").classList.add("hidden");
                this.color = this.querySelector(".select-selected").getAttribute('data-color');
            } else this.querySelector("[error-variant-unavailable]").classList.remove("hidden");
        }
        this.parentNode.checkAddToCart();
    }
    setConfiguredDisplay() {
        if (this.configured) {
            this.setOrderDisplay("", this.color, true);
            this.classList.add("configured");
            this.setAttribute("configured", '');
        } else this.setOrderDisplay(this.order);
    }
}
class $e7497bf6d673cf5a$var$BundleSelector extends HTMLElement {
    constructor(){
        super();
        this.addToCartBtn = this.parentElement.querySelector('button[name="add-bundle"]');
        this.addToCartBtn.querySelector("span").textContent = this.addToCartBtn.dataset.initialText;
        this.checkAddToCart();
    }
    set configuredBundles(configuredBundles) {}
    get configuredBundles() {
        return this.querySelectorAll("bundle-product[configured]");
    }
    addProductListToCart(atcBtn, productsToAdd) {
        const _this = this;
        const cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
        if (productsToAdd.items.length >= 1) {
            atcBtn.setAttribute("disabled", "");
            atcBtn.querySelector("span").textContent = "Adding...";
            productsToAdd.sections = cart.getSectionsToRender().map((section)=>section.id);
            productsToAdd.sections_url = window.location.pathname;
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(productsToAdd)
            }).then((response)=>{
                return response.json();
            }).then((data)=>{
                atcBtn.removeAttribute("disabled", "");
                atcBtn.querySelector("span").textContent = atcBtn.dataset.successText;
                //close modal
                document.querySelector("modal-popup.configure_bundle-modal").modalClose();
                //cart
                cart.setActiveElement(document.activeElement);
                setTimeout(()=>{
                    cart.renderContents(data);
                });
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                setTimeout(()=>{
                    cart.open();
                    atcBtn.querySelector("span").textContent = atcBtn.dataset.initialText;
                }, 400);
                if (data.status == 422) _this.parentElement.querySelector("[error-cart]").textContent = data.description;
            }).catch((err)=>{});
        }
    }
    atcHandler(e) {
        e.preventDefault();
        //FIXME: pass correct this
        const _this = document.querySelector("bundle-selector");
        const configuredBundles = _this.configuredBundles;
        let productsToAdd = {
            'items': []
        };
        for (let bundleProduct of configuredBundles){
            let productObj = {
                "id": bundleProduct.variantData.id,
                "quantity": 1,
                "properties": {
                    item_co2: bundleProduct.co2 || 0
                }
            };
            if (productsToAdd.items.length > 0 && productsToAdd.items.filter((y)=>y.id === bundleProduct.variantData.id).length > 0) productsToAdd.items.find((y)=>y.id === bundleProduct.variantData.id).quantity++;
            else productsToAdd.items.push(productObj);
        }
        _this.addProductListToCart(this, productsToAdd);
    }
    addCartEvent() {
        this.addToCartBtn.removeEventListener("click", this.atcHandler);
        this.addToCartBtn.addEventListener("click", this.atcHandler);
    }
    checkAddToCart() {
        let allConfigured = true;
        this.querySelectorAll("bundle-product").forEach((product)=>{
            if (product.configured == false) allConfigured = false;
            if (product.variantData.available == false) allConfigured = false;
        });
        if (allConfigured) {
            this.addToCartBtn.removeAttribute("disabled");
            this.addCartEvent();
        } else this.addToCartBtn.setAttribute("disabled", '');
    }
}
customElements.define('bundle-product', $e7497bf6d673cf5a$var$BundleProduct);
customElements.define('bundle-selector', $e7497bf6d673cf5a$var$BundleSelector);



// PLP/carousel card USP tooltips: the CSS-positioned panel gets clipped by
// slider containers (overflow: hidden) and mispositioned by Flickity's
// transforms. On hover we portal the panel to <body> with fixed coordinates
// so it escapes every clipping/stacking context; on leave it goes back.
// Hover-only, like the rest of the card USP interaction.
function $e30d24862456cd98$var$initCardUspTooltips() {
    const PANEL_WIDTH = 300;
    let openTip = null;
    let closeTimer = null;
    const close = ()=>{
        if (!openTip) return;
        const { el: el, home: home } = openTip;
        el.removeAttribute('style');
        home.appendChild(el);
        openTip = null;
    };
    const scheduleClose = ()=>{
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 120);
    };
    const open = (usp)=>{
        const tip = usp.querySelector('.price-usp__info-box');
        if (!tip) return;
        clearTimeout(closeTimer);
        if (openTip && openTip.el !== tip) close();
        if (openTip && openTip.el === tip) return;
        const rect = usp.getBoundingClientRect();
        const width = Math.min(PANEL_WIDTH, window.innerWidth - 16);
        const left = Math.max(8, Math.min(rect.left, window.innerWidth - width - 8));
        openTip = {
            el: tip,
            home: tip.parentNode
        };
        document.body.appendChild(tip);
        tip.style.position = 'fixed';
        tip.style.top = rect.bottom + 6 + 'px';
        tip.style.left = left + 'px';
        tip.style.right = 'auto';
        tip.style.width = width + 'px';
        tip.style.opacity = '1';
        tip.style.visibility = 'visible';
        tip.style.zIndex = '9999';
        tip.addEventListener('mouseenter', ()=>clearTimeout(closeTimer));
        tip.addEventListener('mouseleave', scheduleClose);
    };
    document.addEventListener('mouseover', (e)=>{
        const usp = e.target.closest && e.target.closest('.price-usp--card');
        if (usp) open(usp);
    });
    document.addEventListener('mouseout', (e)=>{
        const usp = e.target.closest && e.target.closest('.price-usp--card');
        if (usp && !(e.relatedTarget && usp.contains(e.relatedTarget))) scheduleClose();
    });
    // Any scroll shifts the anchor — just close.
    document.addEventListener('scroll', close, {
        passive: true,
        capture: true
    });
}
$e30d24862456cd98$var$initCardUspTooltips();


let $f3fd55930e9caf92$var$$infoContainer = document.querySelector(".cart-extra-info");
function $f3fd55930e9caf92$var$showPopup(e) {
    let $tooltip = document.querySelector(".cart-extra-info__tooltip");
    if ($tooltip.classList.contains("d-none")) $tooltip.classList.remove("d-none");
    else $tooltip.classList.add("d-none");
}
function $f3fd55930e9caf92$var$chooseDeviceType($infoContainer) {
    if ("ontouchstart" in document.documentElement) $infoContainer.addEventListener("click", $f3fd55930e9caf92$var$showPopup);
    else {
        $infoContainer.addEventListener("mouseenter", $f3fd55930e9caf92$var$showPopup);
        $infoContainer.addEventListener("mouseleave", $f3fd55930e9caf92$var$showPopup);
    }
}
if ($f3fd55930e9caf92$var$$infoContainer) $f3fd55930e9caf92$var$chooseDeviceType($f3fd55930e9caf92$var$$infoContainer);
else {
    const observer = new MutationObserver((mutationsList, observer)=>{
        for (const mutation of mutationsList)if (mutation.type === 'childList') {
            let $infoContainer = document.querySelector(".cart-extra-info");
            if ($infoContainer) $f3fd55930e9caf92$var$chooseDeviceType($infoContainer);
        }
    });
    const cartDrawer = document.querySelector(".cart-drawer");
    observer.observe(cartDrawer, {
        childList: true
    });
}


class $2bb81151451f121c$var$ColorSwatches extends HTMLElement {
    constructor(){
        super();
        this.productColors = this.querySelector('.product-colors');
        this.listEl = this.closest('li.grid__item') || this.closest('.flickity__slider .carousel__cell');
        if (this.listEl) this.cardWrapper = this.listEl.querySelector('.card-wrapper');
        if (this.cardWrapper) this.productColorsEl = this.cardWrapper.querySelector('.product-colors');
        if (this.productColorsEl) {
            this.rightArrowEl = this.productColorsEl.querySelector('.product-colors-scroll-right');
            this.addEventListener('scroll', this.onRightArrowScroll.bind(this));
        }
        this.renderRightArrow();
        if (this.listEl) {
            const resizeObserver = new ResizeObserver(()=>{
                this.renderRightArrow();
            });
            resizeObserver.observe(this.listEl);
        }
        if (this.rightArrowEl) this.rightArrowEl.addEventListener('click', this.onRightArrowClick.bind(this));
        this.addEventListener('change', this.onColorSwatchChange);
        this.resizeObserver = new ResizeObserver(this.calculateMaxColors.bind(this));
        this.resizeObserver.observe(this);
        if (this.dataset.event == 'hover') {
            if (this.productColors) {
                const swatches = this.productColors.querySelectorAll('label.color');
                swatches.forEach((swatch)=>{
                    const listener = this.onColorSwatchHover.bind(this);
                    swatch.addEventListener('mouseenter', listener);
                });
            }
        }
        this.triggerYotpo();
    }
    triggerYotpo() {
        const thisYotpo = this.parentElement.parentElement.querySelector('.yotpo-widget-instance');
        if (thisYotpo && yotpoWidgetsContainer) {
            const instanceId = thisYotpo.dataset.yotpoInstanceId;
            yotpoWidgetsContainer.initWidget(`${instanceId}`, thisYotpo);
        }
    }
    onColorSwatchHover(event) {
        const input = event.target.previousElementSibling;
        if (!input.checked) {
            input.checked = true;
            this.dispatchEvent(new Event('change', {
                bubbles: true
            }));
            this.triggerYotpo();
        }
    }
    onColorSwatchChange() {
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant) {
            // Legacy path: embedded sibling-card JSON (kept for any cached/injected
            // markup that still carries it).
            const embedded = this.getProductData().find((product)=>product.id.toString() === this.connectedProductId);
            if (embedded) {
                this.renderProduct(embedded.html);
                window.dispatchEvent(new Event('more-content-loaded'));
                return;
            }
            // Current path: fetch the sibling card on demand via the Section
            // Rendering API. The token guards against out-of-order responses when
            // hovering across several swatches quickly.
            const token = this.swapToken = (this.swapToken || 0) + 1;
            this.getProductHtml(this.connectedProductHandle).then((html)=>{
                if (!html || token !== this.swapToken) return;
                this.renderProduct(html);
                window.dispatchEvent(new Event('more-content-loaded'));
            });
        }
    }
    getProductHtml(handle) {
        if (!handle) return Promise.resolve(null);
        const cache = $2bb81151451f121c$var$ColorSwatches.cardHtmlCache = $2bb81151451f121c$var$ColorSwatches.cardHtmlCache || {};
        if (!cache[handle]) {
            const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
            cache[handle] = fetch(`${root}products/${handle}?section_id=card-product`).then((response)=>response.ok ? response.text() : null).catch(()=>null);
        }
        return cache[handle];
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset)=>{
            const checked = Array.from(fieldset.querySelectorAll('input')).find((radio)=>radio.checked);
            return {
                value: checked.value,
                connectedProductId: checked.dataset.connectedProductId,
                connectedProductHandle: checked.dataset.handle
            };
        });
    }
    updateMasterId() {
        this.productId = this.dataset.productId;
        this.connectedProductId = this.options[0].connectedProductId;
        this.connectedProductHandle = this.options[0].connectedProductHandle;
        this.currentVariant = this.options[0].value;
    }
    renderProduct(html) {
        const destination = document.querySelector(`#CardWrapper-${this.productId}`);
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const source = parsedHtml.querySelector(`#CardWrapper-${this.connectedProductId}`);
        if (destination && source) {
            const destinationCardInner = destination.querySelector('.card > .card__inner');
            const sourceCardInner = source.querySelector('.card > .card__inner');
            if (destinationCardInner && sourceCardInner) destinationCardInner.replaceWith(sourceCardInner);
            const destinationCardInfoMain = destination.querySelector('.card > .card__content > .card__information > .card-info__main');
            const sourceCardInfoMain = source.querySelector('.card > .card__content > .card__information > .card-info__main');
            if (destinationCardInfoMain && sourceCardInfoMain) destinationCardInfoMain.innerHTML = sourceCardInfoMain.innerHTML;
            const destinationCardInfoPrice = destination.querySelector('.card > .card__content > .card__information > .card-info__price');
            const sourceCardInfoPrice = source.querySelector('.card > .card__content > .card__information > .card-info__price');
            if (destinationCardInfoPrice && sourceCardInfoPrice) destinationCardInfoPrice.innerHTML = sourceCardInfoPrice.innerHTML;
            const destinationCardQuickAdd = destination.querySelector('.card > .card__content > .quick-add');
            const sourceCardQuickAdd = source.querySelector('.card > .card__content > .quick-add');
            if (destinationCardQuickAdd && sourceCardQuickAdd) destinationCardQuickAdd.innerHTML = sourceCardQuickAdd.innerHTML;
            const destinationCardBadge = destination.querySelector('.card > .card__content > .card__badge');
            const sourceCardBadge = source.querySelector('.card > .card__content > .card__badge');
            if (destinationCardBadge && sourceCardBadge) destinationCardBadge.innerHTML = sourceCardBadge.innerHTML;
            const destinationPromoCode1 = destination.querySelector('.card > .card__content > .card__information [data-promo-code-1]');
            const sourcePromoCode1 = source.querySelector('.card > .card__content > .card__information [data-promo-code-1]');
            if (destinationPromoCode1 && sourcePromoCode1) destinationPromoCode1.parentNode.replaceChild(sourcePromoCode1, destinationPromoCode1);
            const destinationPromoCode2 = destination.querySelector('.card > .card__content > .card__information [data-promo-code-2]');
            const sourcePromoCode2 = source.querySelector('.card > .card__content > .card__information [data-promo-code-2]');
            if (destinationPromoCode2 && sourcePromoCode2) destinationPromoCode2.parentNode.replaceChild(sourcePromoCode2, destinationPromoCode2);
            const video = destinationCardInner.querySelector('video');
            if (video) video.play().catch((e)=>console.warn('Video play failed:', e));
        }
    }
    getProductData() {
        if (!this.productData) {
            // No embedded JSON is the normal case now (cards are fetched on demand)
            const jsonElement = this.querySelector('[type="application/json"]');
            if (!jsonElement) return [];
            try {
                const jsonContent = jsonElement.textContent.trim();
                if (!jsonContent) return [];
                this.productData = JSON.parse(jsonContent);
            } catch (e) {
                console.error('Failed to parse product data JSON:', e);
                return [];
            }
        }
        return this.productData;
    }
    calculateMaxColors() {
        if (!this.productColors) return;
        const additionalColors = this.productColors.querySelector('.product-colors-additional-colors');
        if (!additionalColors) return;
        const allSwatches = this.productColors.querySelectorAll('label.color');
        const availableWidth = this.offsetWidth;
        if (!allSwatches.length || !availableWidth) return;
        // Cache computed values
        const sampleSwatch = allSwatches[0];
        const swatchStyle = getComputedStyle(sampleSwatch);
        const swatchWidth = sampleSwatch.offsetWidth + parseFloat(swatchStyle.marginRight);
        const additionalStyle = getComputedStyle(additionalColors);
        const additionalColorsWidth = additionalColors.offsetWidth + parseFloat(additionalStyle.marginRight || 0);
        // Calculate max visible colors
        const maxColorsInitial = parseInt(additionalColors.dataset.maxColors) || 6;
        const maxColorsFit = Math.floor((availableWidth - additionalColorsWidth) / swatchWidth);
        const maxVisible = Math.min(maxColorsInitial, maxColorsFit);
        const swatchesCount = parseInt(additionalColors.dataset.colorsCount) || 0;
        const hiddenCount = Math.max(0, swatchesCount - maxVisible);
        // Update visibility
        allSwatches.forEach((swatch, index)=>{
            swatch.style.display = index < maxVisible ? '' : 'none';
        });
        // Update additional colors indicator
        if (hiddenCount > 0) {
            additionalColors.style.display = 'inline-flex';
            additionalColors.textContent = `+${hiddenCount}`;
        } else {
            additionalColors.style.display = 'none';
            additionalColors.textContent = '';
        }
        this.dataset.maxColors = maxVisible;
    }
    renderRightArrow() {
        if (!this.productColorsEl || !this.rightArrowEl) return;
        if (this.listEl.getBoundingClientRect().width < this.productColorsEl.getBoundingClientRect().width) {
            this.style.width = `${this.cardWrapper.getBoundingClientRect().width - 25}px`;
            this.rightArrowEl.style.display = 'flex';
            this.listEl.classList.add('overflowing');
        } else {
            this.rightArrowEl.style.display = 'none';
            this.listEl.classList.remove('overflowing');
        }
    }
    onRightArrowClick() {
        const scrollWidth = 4 * (this.productColorsEl.querySelector('.color').offsetWidth + 5);
        this.scrollBy({
            left: scrollWidth,
            behavior: 'smooth'
        });
    }
    onRightArrowScroll() {
        if (!this.rightArrowEl) return;
        const position = this.productColorsEl.getBoundingClientRect().left - this.getBoundingClientRect().left;
        const overflow = this.productColorsEl.offsetWidth - this.offsetWidth;
        if (position - 2 <= -overflow) this.rightArrowEl.style.display = 'none';
        else this.rightArrowEl.style.display = 'flex';
    }
}
$2bb81151451f121c$var$ColorSwatches.productData = [];
customElements.define('color-swatches', $2bb81151451f121c$var$ColorSwatches);


let $e6a069c719dcad61$var$counterElement = document.getElementById('counter');
if ($e6a069c719dcad61$var$counterElement) {
    let startTimestampInput = $e6a069c719dcad61$var$counterElement.getAttribute('data-start-timestamp');
    let endTimestampInput = $e6a069c719dcad61$var$counterElement.getAttribute('data-end-timestamp');
    let startTimestamp = startTimestampInput * 1000;
    let endTimestamp = endTimestampInput * 1000;
    let currentTimestamp = Math.floor(Date.now());
    if (currentTimestamp && startTimestamp && endTimestamp) {
        if (currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp) {
            let countdownDate = endTimestamp;
            let x = setInterval(function() {
                let now = new Date().getTime();
                let distance = countdownDate - now;
                if (distance < 0) {
                    clearInterval(x);
                    document.getElementById("countdown").innerHTML = "EXPIRED";
                } else {
                    let days = Math.floor(distance / 86400000);
                    let hours = Math.floor(distance % 86400000 / 3600000);
                    let minutes = Math.floor(distance % 3600000 / 60000);
                    let seconds = Math.floor(distance % 60000 / 1000);
                    document.querySelector(".counter-block-days p.counter-days-number").innerHTML = days;
                    document.querySelector(".counter-block-hours p.counter-hours-number").innerHTML = hours;
                    document.querySelector(".counter-block-minutes p.counter-minutes-number").innerHTML = minutes;
                    document.querySelector(".counter-block-seconds p.counter-seconds-number").innerHTML = seconds;
                }
            }, 1000);
        } else document.getElementById("countdown").style.display = "none";
    }
}


function $5c6560ff9ff0c66c$var$toggleExpandedState() {
    const currentExpandedState = this.getAttribute("aria-expanded");
    const newExpandedState = currentExpandedState === "true" ? "false" : "true";
    this.setAttribute("aria-expanded", newExpandedState);
}
const $5c6560ff9ff0c66c$var$expandContentElements = document.querySelectorAll('[expand-content]');
$5c6560ff9ff0c66c$var$expandContentElements.forEach(function(element) {
    element.addEventListener('click', $5c6560ff9ff0c66c$var$toggleExpandedState);
});


parcelRequire("ejSnv");
const $bb9e241b64119473$var$donationProjectNodes = document.querySelectorAll('.donation-project');
const $bb9e241b64119473$var$cartDonationNode = document.querySelector('.cart-donation-project');
let $bb9e241b64119473$var$pendingDonationRequest = null;
if ($bb9e241b64119473$var$cartDonationNode || $bb9e241b64119473$var$donationProjectNodes && $bb9e241b64119473$var$donationProjectNodes.length) $bb9e241b64119473$var$initDonationProjects();
function $bb9e241b64119473$var$startAnimation(entry, donationAmountAutomation) {
    const countSpeed = entry.target.getAttribute('data-count-speed') ? entry.target.getAttribute('data-count-speed') : 50;
    const amountCountedInHundreds = entry.target.getAttribute('data-count-in-hundreds') ? entry.target.getAttribute('data-count-in-houndred') : 5000;
    const amountCountedInOnes = entry.target.getAttribute('data-count-in-ones') ? entry.target.getAttribute('data-count-in-houndred') : 0;
    const goalAmount = entry.target.getAttribute('data-goal-amount') || 0;
    const donationValue = Math.floor(Number(donationAmountAutomation.donationValue)) || 0;
    const currentAmountMetafield = Number(entry.target.getAttribute('data-amount')) || 0;
    const sourceOfCurrentAmount = entry.target.getAttribute('data-source-of-current-amount');
    const target = sourceOfCurrentAmount === 'current_amount' ? currentAmountMetafield : sourceOfCurrentAmount === 'api_automation' ? donationValue : 0;
    let progress = goalAmount > 0 ? target * 100 / goalAmount : 0;
    if (progress > 100) progress = 100;
    entry.target.style.cssText = `--progress: ${progress}%`;
    entry.target.querySelector('.donation-project__progress-bar').style.animationPlayState = 'running';
    $bb9e241b64119473$var$countUp(entry.target, countSpeed, amountCountedInHundreds, amountCountedInOnes, target);
}
function $bb9e241b64119473$var$countUp(project, speed, amountCountedInHundreds, amountCountedInOnes, target) {
    const targetPlacement = project.querySelector('.current-amount');
    const targetPlacementCopy = project.querySelector('.donation-project__progress-bar .current-amount');
    // Calculate breakpoints
    const thousandsLimit = Math.floor(target / 1000) * 1000;
    const hundredsLimit = Math.floor(target / 100) * 100;
    let count = 0;
    const thousandsInterval = setInterval(()=>{
        if (count == target) {
            const onesInterval = setInterval(()=>{
                if (count >= target) clearInterval(onesInterval);
                else {
                    count += 1;
                    targetPlacement.textContent = count.toLocaleString();
                    targetPlacementCopy.textContent = count.toLocaleString();
                }
            }, speed);
            clearInterval(onesInterval);
        } else if (count >= thousandsLimit) {
            clearInterval(thousandsInterval);
            countByHundreds();
        } else {
            count += 1000;
            targetPlacement.textContent = count.toLocaleString();
            targetPlacementCopy.textContent = count.toLocaleString();
        }
    }, speed);
    function countByHundreds() {
        const hundredsInterval = setInterval(()=>{
            if (count == target) {
                const onesInterval = setInterval(()=>{
                    if (count >= target) clearInterval(onesInterval);
                    else {
                        count += 1;
                        targetPlacement.textContent = count.toLocaleString();
                        targetPlacementCopy.textContent = count.toLocaleString();
                    }
                }, speed);
                clearInterval(onesInterval);
            } else if (count >= hundredsLimit) {
                clearInterval(hundredsInterval);
                countByOnes();
            } else {
                count += 100;
                targetPlacement.textContent = count.toLocaleString();
                targetPlacementCopy.textContent = count.toLocaleString();
            }
        }, speed);
    }
    function countByOnes() {
        const onesInterval = setInterval(()=>{
            if (count >= target) clearInterval(onesInterval);
            else {
                count += 1;
                targetPlacement.textContent = count.toLocaleString();
                targetPlacementCopy.textContent = count.toLocaleString();
            }
        }, speed);
    }
}
function $bb9e241b64119473$var$updateCartDonation(cartDonationNode, donationAmountAutomation) {
    if (!cartDonationNode) {
        console.error('Cart donation node not found');
        return;
    }
    const donationValue = donationAmountAutomation ? Math.floor(Number(donationAmountAutomation.donationValue)) || 0 : 0;
    const goalAmount = Number(cartDonationNode.getAttribute('data-goal-amount')) || 0;
    const currentAmountMetafield = Number(cartDonationNode.getAttribute('data-current-amount-metafield')) || 0;
    const sourceOfCurrentAmount = cartDonationNode.getAttribute('data-source-of-current-amount-cart-drawer');
    const progressVerb = cartDonationNode.getAttribute('data-progress-verb');
    const current = sourceOfCurrentAmount === 'current_amount' ? currentAmountMetafield : sourceOfCurrentAmount === 'api_automation' ? donationValue : 0;
    const progressRealPercentage = goalAmount > 0 ? Math.floor(current * 100 / goalAmount) : 0;
    const progress = progressRealPercentage > 100 ? 100 : progressRealPercentage;
    const progressBar = cartDonationNode.querySelector('.progressbar span');
    if (progressBar) progressBar.style.cssText = `--progress: ${progress}%`;
    const progressPercentageNumberNode = cartDonationNode.querySelector('.progress-block__progress-line p');
    if (progressPercentageNumberNode && progressVerb) progressPercentageNumberNode.textContent = `${progressRealPercentage}% ${progressVerb}`;
}
async function $bb9e241b64119473$var$getDonationAmountAutomation() {
    const CACHE_KEY = 'donationAmountAutomation';
    const CACHE_DURATION = 600000; // 10 minutes in milliseconds
    if ($bb9e241b64119473$var$pendingDonationRequest) return $bb9e241b64119473$var$pendingDonationRequest;
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
            const { data: data, timestamp: timestamp } = JSON.parse(cached);
            const now = Date.now();
            // If cache is still valid return it immediately
            if (now - timestamp < CACHE_DURATION) return data;
            else console.log('donation amount automation cache expired');
        }
    } catch (e) {
        console.log('cache read failed, fetching from API');
    }
    const devApi = ''; // replace with your local server url
    const productionApi = 'https://netlify.blacklemon.dk/.netlify';
    const functionName = '/functions/getOrganicBasicsDonationAmount';
    const api = devApi != '' && Shopify.theme.role === 'development' ? devApi : productionApi;
    const url = `${api}${functionName}`;
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    };
    // Set pending request to avoid multiple requests
    $bb9e241b64119473$var$pendingDonationRequest = fetch(url, options).then((response)=>{
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    }).then((data)=>{
        localStorage.setItem(CACHE_KEY, JSON.stringify({
            data: data,
            timestamp: Date.now()
        }));
        // Clear the pending request
        $bb9e241b64119473$var$pendingDonationRequest = null;
        return data;
    }).catch((error)=>{
        // Clear the pending request on error so it can retry
        $bb9e241b64119473$var$pendingDonationRequest = null;
        throw error;
    });
    return $bb9e241b64119473$var$pendingDonationRequest;
}
async function $bb9e241b64119473$var$initDonationProjects() {
    const donationProjectNodes = document.querySelectorAll('.donation-project');
    const cartDonationNode = document.querySelector('.cart-donation-project');
    if ((!donationProjectNodes || !donationProjectNodes.length) && !cartDonationNode) return;
    const donationObserverCallback = async (entries, observer)=>{
        const visibleEntries = entries.filter((entry)=>{
            if (!entry.isIntersecting) return false;
            const isDonationProject = entry.target.classList.contains('donation-project');
            const isCartDonationProject = entry.target.classList.contains('cart-donation-project');
            return isDonationProject || isCartDonationProject;
        });
        if (!visibleEntries.length) return;
        const donationAmountAutomation = await $bb9e241b64119473$var$getDonationAmountAutomation();
        visibleEntries.forEach((entry)=>{
            if (entry.target.classList.contains('donation-project')) $bb9e241b64119473$var$startAnimation(entry, donationAmountAutomation);
            else if (entry.target.classList.contains('cart-donation-project')) $bb9e241b64119473$var$updateCartDonation(entry.target, donationAmountAutomation);
            observer.unobserve(entry.target);
        });
    };
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 1 // Trigger when all of the element is visible
    };
    const donationObserver = new IntersectionObserver(donationObserverCallback, options);
    if (donationProjectNodes && donationProjectNodes.length) donationProjectNodes.forEach((element)=>{
        donationObserver.observe(element);
    });
    if (cartDonationNode) donationObserver.observe(cartDonationNode);
}


class $fce1656d825a2940$var$FactoriesSection extends HTMLElement {
    constructor(){
        super();
        this.init();
    }
    setModalContent(modal, factory) {
        this.propsToReplace.forEach((prop)=>{
            modal.querySelector(prop).innerHTML = factory.querySelector(prop)?.innerHTML;
        });
        modal.querySelector("[data-img]").src = factory.querySelector("[data-img]").textContent;
        return;
    }
    init() {
        this.inited = false;
        this.modal = this.querySelector("modal-popup");
        this.factories = this.querySelectorAll("[data-factory]");
        this.propsToReplace = [
            "[data-city]",
            "[data-country]",
            "[data-description]",
            "[data-family-run]",
            "[data-founding-year]",
            "[data-full-time]",
            "[data-employees]",
            "[data-overtime]",
            "[data-employee-benefits]",
            "[data-certifications]"
        ];
        this.addEvents();
        this.inited = true;
    }
    addEvents() {
        this.factories.forEach((factory)=>{
            factory.addEventListener("click", ()=>{
                this.setModalContent(this.modal, factory);
            });
        });
    }
}
customElements.define('factories-section', $fce1656d825a2940$var$FactoriesSection);


var $20a5eaaa6d897488$exports = {};
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if ($20a5eaaa6d897488$exports) {
    const Flickity = (parcelRequire("5eAAb"));
    (parcelRequire("2jNIg"));
    (parcelRequire("lUkdk"));
    (parcelRequire("8yoKV"));
    (parcelRequire("1hZWV"));
    (parcelRequire("cus4c"));
    (parcelRequire("77NAy"));
    (parcelRequire("c7TRI"));
    $20a5eaaa6d897488$exports = Flickity;
}


const $5b4d616fb9fe2b2f$var$HINTS_HIDDEN_STORAGE_KEY = 'flickity-hints-hidden';
class $5b4d616fb9fe2b2f$var$FlickitySlider extends HTMLElement {
    constructor(){
        super();
        this.restoreHintsVisibilityFromSession();
        this.slider = this.querySelector('.flickity__slider');
        if (!this.slider) return;
        // Check if this is mobile-only carousel
        this.isMobileOnly = this.hasAttribute('data-flickity-mobile-only');
        if (this.isMobileOnly && !this.isMobileViewport()) return; // Don't initialize on desktop
        const configAttr = this.dataset.flickityConfig || this.slider.dataset.flickityConfig;
        this.options = configAttr ? JSON.parse(configAttr) : {};
        this.hasInitialized = false;
        this.observeForInit();
    }
    restoreHintsVisibilityFromSession() {
        try {
            const areHintsHidden = sessionStorage.getItem($5b4d616fb9fe2b2f$var$HINTS_HIDDEN_STORAGE_KEY) === 'true';
            if (areHintsHidden) document.documentElement.setAttribute('data-flickity-hints-hidden', 'true');
        } catch (error) {
        // Ignore storage access issues.
        }
    }
    isMobileViewport() {
        const matches = window.matchMedia('(max-width: 749px)').matches;
        return matches;
    }
    observeForInit() {
        if (!('IntersectionObserver' in window)) {
            this.initFlickity();
            return;
        }
        this.io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                this.initFlickity();
                if (this.io) this.io.disconnect();
            });
        }, {
            rootMargin: '600px 0px',
            threshold: 0
        });
        this.io.observe(this);
    }
    disconnectedCallback() {
        this.io?.disconnect();
        if (this.handlePointerDown) this.removeEventListener('pointerdown', this.handlePointerDown);
        if (this.handlePointerMove) this.removeEventListener('pointermove', this.handlePointerMove);
        if (this.handlePointerUp) {
            this.removeEventListener('pointerup', this.handlePointerUp);
            this.removeEventListener('pointercancel', this.handlePointerUp);
        }
        if (this.handleTouchStart) this.removeEventListener('touchstart', this.handleTouchStart);
        if (this.handleTouchMove) this.removeEventListener('touchmove', this.handleTouchMove);
        if (this.handleTouchEnd) {
            this.removeEventListener('touchend', this.handleTouchEnd);
            this.removeEventListener('touchcancel', this.handleTouchEnd);
        }
    }
    initFlickity() {
        if (this.hasInitialized) return;
        this.hasInitialized = true;
        // Enable Flickity's built-in lazyload on mobile
        if (this.isMobileOnly) this.options.lazyLoad = 1; // Load adjacent images
        this.flkty = new (0, (/*@__PURE__*/$parcel$interopDefault($20a5eaaa6d897488$exports)))(this.slider, this.options);
        if (this.isMobileOnly) {
            this.cardMediaContainer = this.closest('.card__media--flickity');
            this.cardInner = this.closest('.card__inner');
            this.progressBar = this.cardInner?.querySelector('[data-flickity-progress]');
            this.hintBadge = this.cardInner?.querySelector('.card-media-hint');
            this.cardLink = this.closest('.card-wrapper')?.querySelector('.full-unstyled-link');
            this.lastDragTime = 0;
            this.tapGuard = {
                downAt: 0,
                startX: 0,
                startY: 0,
                moved: false,
                lastDuration: 0,
                lastUpAt: 0
            };
            this.scrollDetection = {
                startX: 0,
                startY: 0,
                isVerticalScroll: false
            };
            // Bind scroll detection to prevent swiping during vertical scroll
            this.bindScrollDetection();
            if (this.progressBar) {
                this.flkty.on('settle', ()=>this.updateProgressBar());
                this.flkty.on('scroll', ()=>this.updateProgressBar());
                this.updateProgressBar();
            }
            this.flkty.on('dragStart', ()=>{
                this.lastDragTime = Date.now();
            });
            this.flkty.on('dragEnd', ()=>{
                this.lastDragTime = Date.now();
            });
            if (this.cardLink) {
                this.bindTapGuards();
                this.flkty.on('staticClick', ()=>{
                    if (this.shouldNavigateOnTap()) window.location.href = this.cardLink.href;
                });
            }
        }
        this.init();
    }
    hideAllSwipeHints() {
        // Mark globally that hints have been hidden - CSS will handle hiding via [data-flickity-hints-hidden]
        document.documentElement.setAttribute('data-flickity-hints-hidden', 'true');
        try {
            sessionStorage.setItem($5b4d616fb9fe2b2f$var$HINTS_HIDDEN_STORAGE_KEY, 'true');
        } catch (error) {
        // Ignore storage access issues.
        }
    }
    updateProgressBar() {
        if (!this.progressBar) return;
        const slideCount = this.flkty.slides.length;
        const currentIndex = this.flkty.selectedIndex;
        const progress = (currentIndex + 1) / slideCount * 100;
        this.progressBar.style.width = progress + '%';
        // Mark as swiped after first interaction and hide all hints globally
        if (currentIndex > 0 && this.cardMediaContainer) {
            this.cardMediaContainer.classList.add('card__media--swiped');
            this.hideAllSwipeHints();
        }
    }
    bindTapGuards() {
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.addEventListener('pointerdown', this.handlePointerDown, {
            passive: true
        });
        this.addEventListener('pointermove', this.handlePointerMove, {
            passive: true
        });
        this.addEventListener('pointerup', this.handlePointerUp, {
            passive: true
        });
        this.addEventListener('pointercancel', this.handlePointerUp, {
            passive: true
        });
    }
    bindScrollDetection() {
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.addEventListener('touchstart', this.handleTouchStart, {
            passive: true
        });
        this.addEventListener('touchmove', this.handleTouchMove, {
            passive: false
        });
        this.addEventListener('touchend', this.handleTouchEnd, {
            passive: true
        });
        this.addEventListener('touchcancel', this.handleTouchEnd, {
            passive: true
        });
    }
    handleTouchStart(event) {
        const touch = event.touches[0];
        this.scrollDetection.startX = touch.clientX;
        this.scrollDetection.startY = touch.clientY;
        this.scrollDetection.isVerticalScroll = false;
    }
    handleTouchMove(event) {
        if (!event.touches.length) return;
        const touch = event.touches[0];
        const deltaX = Math.abs(touch.clientX - this.scrollDetection.startX);
        const deltaY = Math.abs(touch.clientY - this.scrollDetection.startY);
        // If movement is detected and not yet determined
        if (!this.scrollDetection.isVerticalScroll && (deltaX > 5 || deltaY > 5)) // Vertical scroll is dominant
        {
            if (deltaY > deltaX * 1.5) {
                this.scrollDetection.isVerticalScroll = true;
                // Disable Flickity dragging
                if (this.flkty) {
                    this.flkty.options.draggable = false;
                    this.flkty.updateDraggable();
                }
            }
        }
    }
    handleTouchEnd() {
        // Re-enable dragging after touch ends
        if (this.scrollDetection.isVerticalScroll && this.flkty) {
            this.flkty.options.draggable = true;
            this.flkty.updateDraggable();
        }
        this.scrollDetection.isVerticalScroll = false;
    }
    handlePointerDown(event) {
        this.tapGuard.downAt = Date.now();
        this.tapGuard.startX = event.clientX;
        this.tapGuard.startY = event.clientY;
        this.tapGuard.moved = false;
    }
    handlePointerMove(event) {
        if (!this.tapGuard.downAt) return;
        const dx = Math.abs(event.clientX - this.tapGuard.startX);
        const dy = Math.abs(event.clientY - this.tapGuard.startY);
        if (dx > 8 || dy > 8) this.tapGuard.moved = true;
    }
    handlePointerUp() {
        if (!this.tapGuard.downAt) return;
        const now = Date.now();
        this.tapGuard.lastDuration = now - this.tapGuard.downAt;
        this.tapGuard.lastUpAt = now;
        this.tapGuard.downAt = 0;
    }
    shouldNavigateOnTap() {
        const now = Date.now();
        const recentTap = now - this.tapGuard.lastUpAt < 400;
        // Quick taps are the MOST click-like input - never reject them for being
        // short (a fast tap is often <60ms and was being silently discarded,
        // making cards feel dead). Only reject long-presses.
        const longEnough = this.tapGuard.lastDuration <= 600;
        const notMoved = !this.tapGuard.moved;
        const notJustDragged = now - this.lastDragTime > 300;
        return recentTap && longEnough && notMoved && notJustDragged;
    }
    init() {
        if (this.flkty) this.flkty.resize();
    }
}
customElements.define('flickity-slider', $5b4d616fb9fe2b2f$var$FlickitySlider);
window.FlickitySlider = $5b4d616fb9fe2b2f$var$FlickitySlider;


document.addEventListener('DOMContentLoaded', ()=>{
    let animation_header = document.getElementById('logo-spinner__player-header');
    let elemToObserve = document.getElementById('shopify-section-header');
    let prevClassState = elemToObserve.classList.contains('shopify-section-header-sticky');
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName == 'class') {
                let currentClassState = mutation.target.classList.contains('shopify-section-header-sticky');
                if (prevClassState !== currentClassState) {
                    prevClassState = currentClassState;
                    if (animation_header) {
                        if (currentClassState) {
                            animation_header.seek(12);
                            animation_header.play();
                        } else animation_header.stop();
                    }
                }
            }
        });
    });
    observer.observe(elemToObserve, {
        attributes: true
    });
});


// The co2 chips live inside the product-info container, so a packs-dropdown
// repaint replaces them. Re-bind on `product-info-repainted`. After a swap the
// chips are brand-new elements, so re-running never stacks listeners.
$e2c01314e79ac036$var$initCo2Chips();
window.addEventListener('product-info-repainted', $e2c01314e79ac036$var$initCo2Chips);
function $e2c01314e79ac036$var$initCo2Chips() {
    const chips = document.querySelectorAll('.chip.co2-label');
    chips.forEach((chip)=>{
        chip.addEventListener('click', (event)=>{
            const sectionFeatures = document.querySelectorAll('.section--features.collection');
            if (!sectionFeatures.length) return;
            sectionFeatures.forEach((element)=>{
                if (element.id !== 'features-footprint') element.classList.add('d-none');
                else element.classList.remove('d-none');
            });
            const footprintSection = document.getElementById('features-footprint');
            if (!footprintSection) return;
            const scrollValue = footprintSection.getBoundingClientRect().top + window.pageYOffset;
            const href = chip.getAttribute('href') || '';
            // trigger scroll animation only if chip url setting is empty
            if (href.trim() === '#') {
                event.preventDefault();
                window.scrollTo({
                    top: scrollValue,
                    behavior: 'smooth'
                });
            }
        });
    });
}


class $962369c57cf06914$var$ModalElement extends HTMLElement {
    constructor(){
        super();
        this.body = document.body;
        this.modalToggle = this.querySelector('button.modal__toggle');
        this.modalContent = this.querySelector('.modal__content');
        this.modalDialog = this.querySelector('.modal__dialog');
        this.close = this.modalDialog?.querySelector(':scope > .modal__close-button');
        this.onOutsideClick = this.handleBodyClick.bind(this);
        this.debouncedOnClick = $962369c57cf06914$var$debounce((event)=>{
            this.modalClose(event);
        });
        this.debouncedOnToggleClick = $962369c57cf06914$var$debounce((event)=>{
            this.onToggleClick(event);
        });
        this.modalToggle?.addEventListener('click', this.debouncedOnToggleClick.bind(this));
        this.close?.addEventListener('click', this.debouncedOnClick.bind(this));
    }
    onToggleClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.modalClose(event) : this.open(event);
    }
    toggleHeader(visible) {
        if (!this.hasAttribute('data-hide-header')) return;
        const headerElementsWrapper = document.querySelector('.header-elements-wrapper');
        if (!headerElementsWrapper) return;
        if (visible) headerElementsWrapper.classList.remove('header-hidden');
        else headerElementsWrapper.classList.add('header-hidden');
    }
    open() {
        this.body.addEventListener('click', this.onOutsideClick);
        this.dispatchEvent(new CustomEvent("modal-open"));
        this.setAttribute('open', true);
        this.body.classList.add('overflow-hidden');
        this.toggleHeader(false);
        if (this.closest('.product__info-wrapper')) this.closest('.product__info-wrapper').style.zIndex = 3;
    }
    modalClose(event) {
        event && event.preventDefault();
        this.dispatchEvent(new CustomEvent("modal-close"));
        this.removeAttribute('open');
        this.toggleHeader(true);
        if (!this.parentElement.parentElement.classList.contains('bundle-product')) {
            this.body.classList.remove('overflow-hidden');
            if (this.closest('.product__info-wrapper')) this.closest('.product__info-wrapper').style.removeProperty('z-index');
            else if (document.querySelector('.product__info-wrapper')) document.querySelector('.product__info-wrapper').style.removeProperty('z-index');
        }
        this.body.removeEventListener('click', this.onOutsideClick);
    }
    handleBodyClick(event) {
        if (event.target.tagName.toLowerCase() !== 'a') {
            event.preventDefault();
            if (event.target.classList.contains('modal-overlay')) {
                if (this.hasAttribute('open') && !this.classList.contains('discount-modal')) this.modalClose(event);
            }
        }
    }
}
customElements.define('modal-popup', $962369c57cf06914$var$ModalElement);
function $962369c57cf06914$var$debounce(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}


parcelRequire("8H191");
if (document.querySelector('.mobile-facets__wrapper')) {
    let lastDeviceType;
    function checkDevice() {
        const currentDeviceType = window.innerWidth > 768 ? 'desktop' : 'mobile';
        if (!lastDeviceType || currentDeviceType !== lastDeviceType) {
            if (currentDeviceType === 'desktop') $1bea9d28d9321d72$var$desktopFunc();
            else $1bea9d28d9321d72$var$mobileFunc();
            lastDeviceType = currentDeviceType;
        }
    }
    checkDevice();
    window.addEventListener('resize', checkDevice);
    $1bea9d28d9321d72$export$9a93d579ca1d4ee6();
}
function $1bea9d28d9321d72$var$desktopFunc() {
    $1bea9d28d9321d72$var$teleportElement('.facet-main__wrapper', '.facet-main__wrapper-desktop');
}
function $1bea9d28d9321d72$var$mobileFunc() {
    $1bea9d28d9321d72$var$teleportElement('.facet-main__wrapper', '.facet-main__wrapper-mobile');
    const facet = document.querySelector('.facet-main__wrapper');
    if (!facet) return;
    if (facet.classList.contains('d-md-flex') && facet.classList.contains('d-none')) facet.classList.remove('d-md-flex', 'd-none');
}
function $1bea9d28d9321d72$var$teleportElement(elementClass, targetContainerClass) {
    var element = document.querySelector(elementClass);
    var targetContainer = document.querySelector(targetContainerClass);
    if (element && targetContainer) targetContainer.appendChild(element);
}
function $1bea9d28d9321d72$export$9a93d579ca1d4ee6() {
    if (document.querySelector('.range_container')) {
        const fromSlider1 = document.querySelector('#fromSlider');
        const toSlider1 = document.querySelector('#toSlider');
        if (!fromSlider1 || !toSlider1) return;
        const fromInput = document.querySelector('#Mobile-Filter-Price-GTE');
        const toInput = document.querySelector('#Mobile-Filter-Price-LTE');
        if (!fromInput || !toInput) return;
        fillSlider(fromSlider1, toSlider1, toSlider1);
        setToggleAccessible(toSlider1);
        fromSlider1.oninput = ()=>{
            controlFromSlider(fromSlider1, toSlider1, fromInput);
        };
        toSlider1.oninput = ()=>{
            controlToSlider(fromSlider1, toSlider1, toInput);
        };
        fromInput.oninput = ()=>controlFromInput(fromSlider1, fromInput, toInput, toSlider1);
        toInput.oninput = ()=>controlToInput(toSlider1, fromInput, toInput, toSlider1);
    }
    function controlFromInput(fromSlider1, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromSlider1, toSlider, toSlider);
        if (from > to) {
            fromSlider1.value = to;
            fromInput.value = to;
        } else fromSlider1.value = from;
    }
    function controlToInput(toSlider1, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromSlider, toSlider1, toSlider1);
        setToggleAccessible(toInput);
        if (from <= to) {
            toSlider1.value = to;
            toInput.value = to;
        } else toInput.value = from;
    }
    function controlFromSlider(fromSlider1, toSlider1, fromInput) {
        const [from, to] = getParsed(fromSlider1, toSlider1);
        fillSlider(fromSlider1, toSlider1, toSlider1);
        if (fromSlider1.value !== fromSlider1.min) {
            if (from > to) {
                fromSlider1.value = to;
                fromInput.value = to;
            } else fromInput.value = from;
        } else fromInput.value = '';
    }
    function controlToSlider(fromSlider1, toSlider1, toInput) {
        const [from, to] = getParsed(fromSlider1, toSlider1);
        fillSlider(fromSlider1, toSlider1, toSlider1);
        setToggleAccessible(toSlider1);
        if (toSlider1.value !== toSlider1.max) {
            if (from <= to) {
                toSlider1.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
                toSlider1.value = from;
            }
        } else toInput.value = '';
    }
    function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [
            from,
            to
        ];
    }
    function fillSlider(from, to, controlSlider) {
        const rangeDistance = to?.max - to?.min;
        const fromPosition = from?.value - to?.min;
        const toPosition = to?.value - to?.min;
        const sliderColor = '#C7C7C7';
        let rangeColor = '#000';
        if (controlToSlider) controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${fromPosition / rangeDistance * 100}%,
        ${rangeColor} ${fromPosition / rangeDistance * 100}%,
        ${rangeColor} ${toPosition / rangeDistance * 100}%, 
        ${sliderColor} ${toPosition / rangeDistance * 100}%, 
        ${sliderColor} 100%)`;
    }
    function setToggleAccessible(currentTarget) {
        const toSlider1 = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) toSlider1.style.zIndex = 2;
        else toSlider1.style.zIndex = 0;
    }
}


parcelRequire("75MpZ");
class $323351d717ea705a$var$FeaturesSection extends HTMLElement {
    constructor(){
        super();
        this.sectionFeatures = this.querySelectorAll('.section--features');
        this.btns = this.querySelectorAll('.section--features .section--features__navigation > button');
        this.init();
    }
    init() {
        this.hideFeaturesSection();
        this.sectionFeatures.forEach((block)=>{
            block.querySelectorAll('.section--features__navigation > button').forEach((btn, i)=>{
                const span = document.createElement('span');
                span.classList.add('divider');
                span.innerText = '/';
                if (i != 0) btn.parentNode.insertBefore(span, btn);
            });
        });
        this.btns.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                this.onNavClick(btn);
            });
        });
    }
    hideFeaturesSection() {
        this.sectionFeatures.forEach((block, i)=>{
            if (i != 0) block.classList.add('d-none');
        });
    }
    onNavClick(btn) {
        const block = this.getElementsByClassName(btn.dataset.block);
        this.sectionFeatures.forEach((block)=>{
            block.classList.add('d-none');
        });
        if (block) {
            if (typeof block == 'object') {
                block[0].classList.remove('d-none');
                block[0].classList.add('d-block');
            } else {
                block.classList.remove('d-none');
                block.classList.add('d-block');
            }
        }
    }
}
customElements.define('features-section', $323351d717ea705a$var$FeaturesSection);



(0, $c6ca6864d06916d1$export$703d9b492af7fd15)();


class $8cc48ac1980ebd3a$var$SizeGuide extends HTMLElement {
    constructor(){
        super();
        this.chipLinks = this.querySelector('.chip-links').querySelectorAll('.chip-link');
        this.chipContents = this.querySelector('.chip-contents').querySelectorAll('.chip-content');
        this.chipLinks.forEach((chipLink)=>{
            chipLink.classList.remove('active');
            chipLink.addEventListener('click', this.onChipLinkClick.bind(this));
        });
        this.chipLinks[0].classList.add('active');
        this.chipContents.forEach((chipContent)=>{
            chipContent.classList.remove('active');
        });
        this.chipContents[0].classList.add('active');
    }
    onChipLinkClick(event) {
        this.chipLinks.forEach((chipLink)=>{
            chipLink.classList.remove('active');
        });
        event.target.classList.add('active');
        var activeClass = '';
        event.target.classList.forEach((chipLinkClass)=>{
            if (chipLinkClass.includes('tab')) activeClass = chipLinkClass.split('-')[0];
        });
        this.chipContents?.forEach((chipContent)=>{
            chipContent.classList.remove('active');
        });
        this.querySelector(`.${activeClass}-content`).classList.add('active');
    }
}
customElements.define('size-guide', $8cc48ac1980ebd3a$var$SizeGuide);
function $8cc48ac1980ebd3a$var$debounce(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
$8cc48ac1980ebd3a$var$setUpSizeUnits();
function $8cc48ac1980ebd3a$var$setUpSizeUnits() {
    let units = [];
    document.querySelectorAll("size-guide table td span")?.forEach((size)=>{
        const unit = size.dataset.unit;
        if (unit != undefined && !units.includes(unit)) units.push(unit);
    });
}


const $809dd41d1d235fbf$var$slideshowHeadingNodes = document.querySelectorAll('slideshow-component .banner__heading');
if ($809dd41d1d235fbf$var$slideshowHeadingNodes) $809dd41d1d235fbf$var$handleHeadingsCustomColors($809dd41d1d235fbf$var$slideshowHeadingNodes);
function $809dd41d1d235fbf$var$handleHeadingsCustomColors(slideshowHeadingNodes) {
    slideshowHeadingNodes.forEach((headingNode)=>{
        const { headingPart1: headingPart1, headingPart2: headingPart2, enableCColorHeadingPart1: enableCColorHeadingPart1, enableCColorHeadingPart2: enableCColorHeadingPart2 } = headingNode.dataset;
        const bannerClassPart1 = ".banner__heading--first";
        const bannerClassPart2 = ".banner__heading--second";
        if (enableCColorHeadingPart1 === 'true' && headingPart1) setRichTextCustomColors(headingPart1, headingNode, bannerClassPart1);
        if (enableCColorHeadingPart2 === 'true' && headingPart2) setRichTextCustomColors(headingPart2, headingNode, bannerClassPart2);
        function setRichTextCustomColors(headingPartText, headingNode, bannerClass) {
            const regexFindColors = /[^[\]]+(?=])/g;
            const resultMatchGroup = headingPartText.match(regexFindColors);
            if (resultMatchGroup != null && resultMatchGroup.length > 0) {
                for(let i = 0; i < resultMatchGroup.length; i++){
                    const color = resultMatchGroup[i].split("/")[0].split("=")[1];
                    const word = resultMatchGroup[i].split("/")[1];
                    headingPartText = headingPartText.replace(`[${resultMatchGroup[i]}]`, `<span style="color: ${color}">${word}</span>`);
                }
                headingNode.querySelector(bannerClass).innerHTML = headingPartText;
            }
        }
    });
}


parcelRequire("7Wc4a");
const $f531aad1c05f67a5$var$target = document.querySelector('.collection-hero__filter-container');
const $f531aad1c05f67a5$var$quickLinksNoImages = document.querySelector('#popular--categories-container-1');
const $f531aad1c05f67a5$var$quickLinksWithImages = document.querySelector('#popular--categories-container-2');
if ($f531aad1c05f67a5$var$quickLinksNoImages && !$f531aad1c05f67a5$var$quickLinksWithImages) $f531aad1c05f67a5$var$quickLinksNoImages.classList.add('fade-visible');
if ($f531aad1c05f67a5$var$quickLinksNoImages && $f531aad1c05f67a5$var$quickLinksWithImages) document.addEventListener('scroll', function(el) {
    const quickLinksWithImagesDistanceFromTop = $f531aad1c05f67a5$var$quickLinksWithImages.getBoundingClientRect().top;
    const quickLinksWithImagesHeight = $f531aad1c05f67a5$var$quickLinksWithImages.offsetHeight;
    const showStickyQuickLinksPixels = parseInt(quickLinksWithImagesDistanceFromTop) + parseInt(quickLinksWithImagesHeight);
    if (showStickyQuickLinksPixels < window.scrollY) $f531aad1c05f67a5$var$quickLinksNoImages.classList.add('fade-visible');
    else $f531aad1c05f67a5$var$quickLinksNoImages.classList.remove('fade-visible');
});
if ($f531aad1c05f67a5$var$target) {
    function mobileFiltersPosition(input) {
        if (input == 'load' && window.innerWidth < 749 || input == 'resize' && window.innerWidth < 749) {
            // Get the DOM nodes
            let element = document.querySelector('.collection-hero__filter-container');
            let target = document.querySelector('#MainContent');
            // Move stuff
            target.prepend(element);
        } else if (input == 'resize' && window.innerWidth >= 749) {
            // Get the DOM nodes
            let element = document.querySelector('.collection-hero__filter-container');
            let target = document.querySelector('#popular--categories-container');
            // Move stuff
            if (target && element) target.after(element);
        }
    }
    window.addEventListener('load', ()=>{
        mobileFiltersPosition('load');
    });
    window.addEventListener('resize', ()=>{
        mobileFiltersPosition('resize');
    });
}


{
    const streamerContent = document.querySelector('.streamer__content');
    if (streamerContent) {
        const wrapperContent = document.querySelector('.streamer__wrapper');
        const streamContentChildren = streamerContent.querySelectorAll('.streamer__message');
        for(let i = 0; i < 20; i++)streamContentChildren.forEach(function(el) {
            const clonnedEl = el.cloneNode(true);
            streamerContent.appendChild(clonnedEl);
        });
    }
}

const $b7d38ec2a9acda51$var$modal = document.querySelector('.country-redirect-modal');
if ($b7d38ec2a9acda51$var$modal) {
    //close if current country ok
    $b7d38ec2a9acda51$var$modal.querySelector('.country-redirect-button').addEventListener('click', ()=>{
        $b7d38ec2a9acda51$var$modal.querySelector('.modal__close-button').click();
    });
    $b7d38ec2a9acda51$var$modal.querySelector('.packs-dropdown').addEventListener('click', ()=>{
        $b7d38ec2a9acda51$var$modal.querySelector('.packs-dropdown').classList.toggle('active');
    });
    $b7d38ec2a9acda51$var$modal.querySelectorAll('.dropdown-option').forEach((option)=>{
        option.addEventListener('click', ()=>{
            const href = option.getAttribute('data-href');
            if (window.location.href.startsWith(href)) {
                $b7d38ec2a9acda51$var$modal.querySelector('.modal__close-button').click();
                return;
            }
            if (href) window.location.href = href;
        });
    });
}


function $499c0cfcaca01eb2$var$getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary)=>{
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    summary.addEventListener('click', (event)=>{
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', $499c0cfcaca01eb2$var$onKeyUpEscape);
});
const $499c0cfcaca01eb2$var$trapFocusHandlers = {};
function $499c0cfcaca01eb2$export$bec45a54c2e66c22(container, elementToFocus = container) {
    var elements = $499c0cfcaca01eb2$var$getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    $499c0cfcaca01eb2$export$c761a6bf8c4188fe();
    $499c0cfcaca01eb2$var$trapFocusHandlers.focusin = (event)=>{
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', $499c0cfcaca01eb2$var$trapFocusHandlers.keydown);
    };
    $499c0cfcaca01eb2$var$trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', $499c0cfcaca01eb2$var$trapFocusHandlers.keydown);
    };
    $499c0cfcaca01eb2$var$trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }
        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };
    document.addEventListener('focusout', $499c0cfcaca01eb2$var$trapFocusHandlers.focusout);
    document.addEventListener('focusin', $499c0cfcaca01eb2$var$trapFocusHandlers.focusin);
    elementToFocus.focus();
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    $499c0cfcaca01eb2$var$focusVisiblePolyfill();
}
function $499c0cfcaca01eb2$var$focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN'
    ];
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event)=>{
        if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
    });
    window.addEventListener('mousedown', (event)=>{
        mouseClick = true;
    });
    window.addEventListener('focus', ()=>{
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
        if (mouseClick) return;
        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
    }, true);
}
window.pauseAllMedia = function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video)=>{
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video)=>{
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video)=>video.pause());
    document.querySelectorAll('product-model').forEach((model)=>{
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
};
function $499c0cfcaca01eb2$export$c761a6bf8c4188fe(elementToFocus = null) {
    document.removeEventListener('focusin', $499c0cfcaca01eb2$var$trapFocusHandlers.focusin);
    document.removeEventListener('focusout', $499c0cfcaca01eb2$var$trapFocusHandlers.focusout);
    document.removeEventListener('keydown', $499c0cfcaca01eb2$var$trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus({
        preventScroll: true
    });
}
function $499c0cfcaca01eb2$var$onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}
class $499c0cfcaca01eb2$var$QuantityInput extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: true
        });
        this.querySelectorAll('button').forEach((button)=>button.addEventListener('click', this.onButtonClick.bind(this)));
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('quantity-input', $499c0cfcaca01eb2$var$QuantityInput);
window.debounce = function debounce(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
};
function $499c0cfcaca01eb2$export$1811237fdf5ac5d(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: `application/${type}`
        }
    };
}
/*
 * Shopify Common JS
 *
 */ if (typeof window.Shopify == 'undefined') window.Shopify = {};
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};
Shopify.setSelectorByValue = function(selector, value) {
    for(var i = 0, count = selector.options.length; i < count; i++){
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);
    for(var key in params){
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    if (this.countryEl) {
        Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
        this.initCountry();
    }
    if (this.provinceEl) this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },
    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
    },
    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) this.provinceContainer.style.display = 'none';
        else {
            for(var i = 0; i < provinces.length; i++){
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }
            this.provinceContainer.style.display = '';
        }
    },
    clearOptions: function(selector) {
        while(selector.firstChild)selector.removeChild(selector.firstChild);
    },
    setOptions: function(selector, values) {
        for(var i = 0, count = values.length; i < values.length; i++){
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};
class $499c0cfcaca01eb2$var$MenuDrawer extends HTMLElement {
    constructor(){
        super();
        this.sentinelObserver = null;
        this.gridObserver = null;
        this.mainDetailsToggle = this.querySelector('details');
        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }
    connectedCallback() {
        const buttonElement = document.querySelector('#Details-menu-drawer-container');
        document.addEventListener('search-button-clicked', (event)=>{
            this.closeAnimation(buttonElement);
            document.querySelector('#shopify-section-header').classList.remove('menu-open');
        });
        this.#handleFilterIconVisibility();
    }
    disconnectedCallback() {
        if (this.sentinelObserver) this.sentinelObserver.disconnect();
        if (this.gridObserver) this.gridObserver.disconnect();
    }
    #handleFilterIconVisibility() {
        const elementId = this.dataset.filterIconId;
        const filterIconElem = this.querySelector(`#${elementId}`);
        if (!(filterIconElem instanceof HTMLElement)) return;
        document.body.classList.add('has-filter-icon-mobile');
        const scrollThreshold = 770;
        // Create sentinel inside the parent container
        let sentinel = this.querySelector('.scroll-sentinel');
        this.style.position = 'relative';
        if (!sentinel) {
            sentinel = document.createElement('div');
            sentinel.classList.add('scroll-sentinel');
            sentinel.textContent = 'sentinel';
            sentinel.style.top = `${scrollThreshold}px`;
            this.prepend(sentinel);
        }
        let isIconVisible = false;
        const sentinelObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    filterIconElem.classList.add('filter-icon-mobile--visible');
                    isIconVisible = true;
                } else {
                    const rect = entry.boundingClientRect;
                    if (rect.top > 0) {
                        filterIconElem.classList.remove('filter-icon-mobile--visible');
                        isIconVisible = false;
                    } else {
                        filterIconElem.classList.add('filter-icon-mobile--visible');
                        isIconVisible = true;
                    }
                }
            });
        }, {
            threshold: 0,
            rootMargin: '0px' // trigger exactly when the element enters the viewport
        });
        sentinelObserver.observe(sentinel);
        this.sentinelObserver = sentinelObserver;
        const productGrid = this.closest('.section-main-collection-product-grid');
        if (productGrid) {
            const gridObserver = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) // If product grid is not visible and we're below it (footer section)
                    filterIconElem.classList.remove('filter-icon-mobile--visible');
                    else if (entry.isIntersecting && isIconVisible) // The icon should be visible when scrolling from footer back to product grid and hidden when scrolling to the top
                    filterIconElem.classList.add('filter-icon-mobile--visible');
                });
            }, {
                threshold: 0,
                rootMargin: '0px' // trigger exactly when the element enters the viewport
            });
            gridObserver.observe(productGrid);
            this.gridObserver = gridObserver;
        }
    }
    bindEvents() {
        this.querySelectorAll('summary').forEach((summary)=>summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button:not(.localization-selector)').forEach((button)=>button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        function addTrapFocus() {
            $499c0cfcaca01eb2$export$bec45a54c2e66c22(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }
        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else setTimeout(()=>{
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            parentMenuElement && parentMenuElement.classList.add('submenu-open');
            !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement?.nextElementSibling?.addEventListener('transitionend', addTrapFocus);
        }, 100);
    }
    openMenuDrawer(summaryElement) {
        setTimeout(()=>{
            this.mainDetailsToggle.classList.add('menu-opening');
            document.body.classList.add('overflow-hidden', 'drawer-open');
        });
        if (!summaryElement) return;
        summaryElement.setAttribute('aria-expanded', true);
        $499c0cfcaca01eb2$export$bec45a54c2e66c22(this.mainDetailsToggle, summaryElement);
        if (summaryElement.classList.contains('mobile-facets__open-wrapper')) return;
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;
        this.mainDetailsToggle.classList.remove('menu-opening');
        document.body.classList.remove('overflow-hidden', 'drawer-open');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details)=>{
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu)=>{
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        $499c0cfcaca01eb2$export$c761a6bf8c4188fe(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
    }
    onFocusOut() {
        setTimeout(()=>{
            if (!this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        $499c0cfcaca01eb2$export$c761a6bf8c4188fe(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
        let animationStart;
        const handleAnimation = (time)=>{
            if (animationStart === undefined) animationStart = time;
            const elapsedTime = time - animationStart;
            if (elapsedTime < 400) window.requestAnimationFrame(handleAnimation);
            else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) $499c0cfcaca01eb2$export$bec45a54c2e66c22(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
            }
        };
        window.requestAnimationFrame(handleAnimation);
    }
}
customElements.define('menu-drawer', $499c0cfcaca01eb2$var$MenuDrawer);
class $499c0cfcaca01eb2$var$HeaderDrawer extends $499c0cfcaca01eb2$var$MenuDrawer {
    constructor(){
        super();
        this.filtersElementMobile = document.querySelector('.facet-main__wrapper-mobile');
        this.filtersElementDesktop = document.querySelector('.facet-main__wrapper-desktop');
        this.filterElementSearch = document.getElementById('main-collection-filters');
    }
    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        if (this.header.querySelector('sticky-header')) document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.querySelector('sticky-header').getBoundingClientRect().bottom - this.borderOffset)}px`);
        else document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add('menu-open');
        if (this.filtersElementDesktop) this.filtersElementDesktop.classList.add('display_none');
        if (this.filtersElementMobile) this.filtersElementMobile.classList.add('display_none');
        if (this.filterElementSearch) this.filterElementSearch.classList.add('display_none');
        setTimeout(()=>{
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        $499c0cfcaca01eb2$export$bec45a54c2e66c22(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
        this.querySelector('menu-drawer-mobile')?.setFeatured();
    }
    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        if (this.filtersElementDesktop) this.filtersElementDesktop.classList.remove('display_none');
        if (this.filtersElementMobile) this.filtersElementMobile.classList.remove('display_none');
        if (this.filterElementSearch) this.filterElementSearch.classList.remove('display_none');
    }
}
customElements.define('header-drawer', $499c0cfcaca01eb2$var$HeaderDrawer);
class $499c0cfcaca01eb2$export$1fa217be60c2f188 extends HTMLElement {
    constructor(){
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event)=>{
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) this.addEventListener('pointerup', (event)=>{
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
        else this.addEventListener('click', (event)=>{
            if (event.target === this) this.hide();
        });
    }
    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }
    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        $499c0cfcaca01eb2$export$bec45a54c2e66c22(this, this.querySelector('[role="dialog"]'));
    }
    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        $499c0cfcaca01eb2$export$c761a6bf8c4188fe(this.openedBy);
    }
}
customElements.define('modal-dialog', $499c0cfcaca01eb2$export$1fa217be60c2f188);
class $499c0cfcaca01eb2$var$ModalOpener extends HTMLElement {
    constructor(){
        super();
        let button = this.querySelector('button');
        if (!button) button = this;
        button.addEventListener('click', ()=>{
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) {
                if (typeof modal.show === 'function') modal.show(button);
                else if (typeof modal.open === 'function') modal.open(button);
            }
        });
    }
}
customElements.define('modal-opener', $499c0cfcaca01eb2$var$ModalOpener);
class $499c0cfcaca01eb2$export$9baddd6b241a6836 extends HTMLElement {
    constructor(){
        super();
        if (!HTMLMediaElement.prototype.hasOwnProperty('playing')) Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
            get: function() {
                return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
            }
        });
        this.loadContentEvent();
    }
    loadContentEvent() {
        this.autoPlay = this.dataset.autoPlay;
        if (this.autoPlay == 'true') this.loadContent(this);
        else {
            const poster = this.querySelector('[id^="Deferred-Poster-"]');
            if (!poster) return;
            poster.addEventListener('click', this.loadContent.bind(this));
        }
    }
    loadContent(focus = true) {
        if (!this.autoPlay == 'true') {
            window.pauseAllMedia();
            this.removeAttribute('loaded');
        }
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
        if (this.getAttribute('loaded') && !this.querySelector('video').playing) this.querySelector('video').play();
    }
}
customElements.define('deferred-media', $499c0cfcaca01eb2$export$9baddd6b241a6836);
const $499c0cfcaca01eb2$var$VIDEO_POSTER_MQ = '(max-width: 749px)';
function $499c0cfcaca01eb2$var$applyResponsiveVideoPoster(video) {
    if (video.closest('.video-block')?.querySelector('.video-block__poster')) return;
    const { posterMobile: posterMobile, posterDesktop: posterDesktop } = video.dataset;
    if (!posterMobile || !posterDesktop || posterMobile === posterDesktop) return;
    const apply = ()=>{
        video.poster = window.matchMedia($499c0cfcaca01eb2$var$VIDEO_POSTER_MQ).matches ? posterMobile : posterDesktop;
    };
    apply();
    if (video.dataset.posterBound) return;
    video.dataset.posterBound = 'true';
    window.matchMedia($499c0cfcaca01eb2$var$VIDEO_POSTER_MQ).addEventListener('change', apply);
}
function $499c0cfcaca01eb2$var$hideVideoBlockPoster(block) {
    block?.classList.add('video-block--playing');
}
function $499c0cfcaca01eb2$var$bindVideoBlockPoster(block) {
    const video = block.querySelector('.video-block__inner video');
    if (!video) return;
    $499c0cfcaca01eb2$var$applyResponsiveVideoPoster(video);
    if (block.dataset.posterPlayBound) return;
    block.dataset.posterPlayBound = 'true';
    const hidePoster = ()=>$499c0cfcaca01eb2$var$hideVideoBlockPoster(block);
    video.addEventListener('playing', hidePoster);
    video.addEventListener('ended', hidePoster);
    if (video.readyState >= 2 && !video.paused) hidePoster();
}
function $499c0cfcaca01eb2$var$playVideoInBlock(block) {
    const video = block.querySelector('.video-block__inner video');
    if (!video) return Promise.resolve();
    $499c0cfcaca01eb2$var$applyResponsiveVideoPoster(video);
    video.muted = true;
    video.setAttribute('muted', '');
    const tryPlay = ()=>video.play().then(()=>$499c0cfcaca01eb2$var$hideVideoBlockPoster(block)).catch(()=>{});
    if (video.readyState >= 2) return tryPlay();
    return new Promise((resolve)=>{
        let played = false;
        const attempt = ()=>{
            if (played) return;
            played = true;
            tryPlay().then(resolve);
        };
        video.addEventListener('canplay', attempt, {
            once: true
        });
        video.addEventListener('loadeddata', attempt, {
            once: true
        });
        if (video.readyState >= 1) queueMicrotask(()=>{
            if (video.readyState >= 2) attempt();
        });
        if (video.networkState !== HTMLMediaElement.NETWORK_LOADING && video.querySelector('source')) video.load();
    });
}
function $499c0cfcaca01eb2$var$playVideosInSlide(slide) {
    if (!slide) return;
    const blocks = slide.querySelectorAll('.video-block');
    return Promise.all([
        ...blocks
    ].filter((block)=>$499c0cfcaca01eb2$var$videoViewportMatches(block)).map((block)=>$499c0cfcaca01eb2$var$playVideoInBlock(block)));
}
function $499c0cfcaca01eb2$var$activateVideoSources(video) {
    video?.querySelectorAll('source[data-src]').forEach((source)=>{
        const url = source.getAttribute('data-src');
        if (url && !source.src) source.src = url;
    });
}
function $499c0cfcaca01eb2$var$videoViewportMatches(block) {
    const viewport = block.dataset.videoViewport;
    if (!viewport || viewport === 'all') return true;
    const isMobile = window.matchMedia($499c0cfcaca01eb2$var$VIDEO_POSTER_MQ).matches;
    return viewport === 'mobile' ? isMobile : !isMobile;
}
function $499c0cfcaca01eb2$var$activateDeferredImage(img) {
    if (!img) return;
    const src = img.getAttribute('data-deferred-src');
    const srcset = img.getAttribute('data-deferred-srcset');
    if (src && !img.src) img.src = src;
    if (srcset && !img.srcset) img.srcset = srcset;
}
function $499c0cfcaca01eb2$var$mountDeferredViewportImage(block) {
    if (block.hasAttribute('data-loaded')) return block.querySelector('img');
    const template = block.querySelector('template');
    if (!template?.content?.firstElementChild) return null;
    const img = template.content.firstElementChild.cloneNode(true);
    $499c0cfcaca01eb2$var$activateDeferredImage(img);
    block.appendChild(img);
    block.setAttribute('data-loaded', '');
    return img;
}
function $499c0cfcaca01eb2$var$mountDeferredVideoBlock(block) {
    if (block.hasAttribute('data-loaded')) return block.querySelector('.video-block__inner video');
    const template = block.querySelector('template');
    const inner = block.querySelector('.video-block__inner');
    if (!template?.content?.firstElementChild || !inner) return null;
    const video = template.content.firstElementChild.cloneNode(true);
    $499c0cfcaca01eb2$var$activateVideoSources(video);
    inner.appendChild(video);
    block.setAttribute('data-loaded', '');
    $499c0cfcaca01eb2$var$bindVideoBlockPoster(block);
    video.load();
    return video;
}
function $499c0cfcaca01eb2$var$tryActivateLazyVideoBlock(block) {
    if (!block || block.hasAttribute('data-loaded')) return false;
    if (!$499c0cfcaca01eb2$var$videoViewportMatches(block)) return false;
    if (block.hasAttribute('data-viewport-media')) {
        $499c0cfcaca01eb2$var$mountDeferredViewportImage(block);
        return true;
    }
    $499c0cfcaca01eb2$var$mountDeferredVideoBlock(block);
    $499c0cfcaca01eb2$var$playVideoInBlock(block);
    return true;
}
let $499c0cfcaca01eb2$var$lazyVideoObserver;
const $499c0cfcaca01eb2$var$lazyVideoObservedBlocks = new WeakSet();
let $499c0cfcaca01eb2$var$lazyVideoViewportListenerBound = false;
const $499c0cfcaca01eb2$var$lazyVideoPendingViewport = new Set();
function $499c0cfcaca01eb2$var$getLazyVideoObserver() {
    if ($499c0cfcaca01eb2$var$lazyVideoObserver) return $499c0cfcaca01eb2$var$lazyVideoObserver;
    $499c0cfcaca01eb2$var$lazyVideoObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const block = entry.target;
            if ($499c0cfcaca01eb2$var$tryActivateLazyVideoBlock(block)) {
                $499c0cfcaca01eb2$var$lazyVideoObserver.unobserve(block);
                $499c0cfcaca01eb2$var$lazyVideoObservedBlocks.delete(block);
                $499c0cfcaca01eb2$var$lazyVideoPendingViewport.delete(block);
                return;
            }
            if (block.dataset.videoViewport) {
                $499c0cfcaca01eb2$var$lazyVideoPendingViewport.add(block);
                $499c0cfcaca01eb2$var$lazyVideoObserver.unobserve(block);
                $499c0cfcaca01eb2$var$lazyVideoObservedBlocks.delete(block);
            }
        });
    }, {
        rootMargin: '200px 0px',
        threshold: 0.01
    });
    return $499c0cfcaca01eb2$var$lazyVideoObserver;
}
function $499c0cfcaca01eb2$var$bindLazyVideoViewportListener() {
    if ($499c0cfcaca01eb2$var$lazyVideoViewportListenerBound) return;
    $499c0cfcaca01eb2$var$lazyVideoViewportListenerBound = true;
    window.matchMedia($499c0cfcaca01eb2$var$VIDEO_POSTER_MQ).addEventListener('change', ()=>{
        // Re-scan lazy video blocks when viewport mode changes (desktop <-> mobile).
        // This ensures hidden-at-load mobile blocks are observed once they become visible.
        $499c0cfcaca01eb2$var$initLazyVideoBlocks(document);
        $499c0cfcaca01eb2$var$lazyVideoPendingViewport.forEach((block)=>{
            if ($499c0cfcaca01eb2$var$tryActivateLazyVideoBlock(block)) $499c0cfcaca01eb2$var$lazyVideoPendingViewport.delete(block);
        });
    });
}
function $499c0cfcaca01eb2$var$initLazyVideoBlocks(root = document) {
    const blocks = [
        ...root.querySelectorAll('[data-lazy-intersection][data-deferred-video]:not([data-loaded]), [data-lazy-intersection][data-viewport-media]:not([data-loaded])')
    ].filter((block)=>!block.closest('slideshow-component'));
    if (!blocks.length) return;
    $499c0cfcaca01eb2$var$bindLazyVideoViewportListener();
    if (typeof IntersectionObserver === 'undefined') {
        blocks.forEach((block)=>$499c0cfcaca01eb2$var$tryActivateLazyVideoBlock(block));
        return;
    }
    const observer = $499c0cfcaca01eb2$var$getLazyVideoObserver();
    blocks.forEach((block)=>{
        if ($499c0cfcaca01eb2$var$lazyVideoObservedBlocks.has(block)) return;
        observer.observe(block);
        $499c0cfcaca01eb2$var$lazyVideoObservedBlocks.add(block);
    });
}
function $499c0cfcaca01eb2$var$initVideoBlocks(root = document) {
    root.querySelectorAll('.video-block:not([data-deferred-video])').forEach($499c0cfcaca01eb2$var$bindVideoBlockPoster);
    $499c0cfcaca01eb2$var$initLazyVideoBlocks(root);
}
class $499c0cfcaca01eb2$var$SliderComponent extends HTMLElement {
    constructor(){
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.sliderDots = this.querySelector('[id^="GalleryThumbnails-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.modelSizeLabelMobile = document.querySelector('.model-size__label.d-block.d-md-none');
        if (!this.slider) return;
        this.initPages();
        const resizeObserver = new ResizeObserver((entries)=>this.initPages());
        resizeObserver.observe(this.slider);
        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element)=>element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.cardContent = this.sliderItemsToShow[0].querySelector('.card-wrapper > .card > .card__content');
        this.sliderButtons = this.slider.parentNode.querySelector('.slider-buttons');
        if (this.cardContent && this.sliderButtons) this.sliderButtons.style.top = `calc(50% - ${this.cardContent.clientHeight / 2}px)`;
        this.update();
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }
    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (this.modelSizeLabelMobile) {
            if (this.currentPage !== 1) this.modelSizeLabelMobile.classList.add('visually-hidden');
            else this.modelSizeLabelMobile.classList.remove('visually-hidden');
        }
        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }
        if (this.currentPage != previousPage) this.dispatchEvent(new CustomEvent('slideChanged', {
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        }));
        if (this.enableSliderLooping) return;
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) this.prevButton?.setAttribute('disabled', 'disabled');
        else this.prevButton?.removeAttribute('disabled');
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) this.nextButton?.setAttribute('disabled', 'disabled');
        else this.nextButton?.removeAttribute('disabled');
    }
    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}
customElements.define('slider-component', $499c0cfcaca01eb2$var$SliderComponent);
class $499c0cfcaca01eb2$var$SlideshowComponent extends $499c0cfcaca01eb2$var$SliderComponent {
    constructor(){
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        this.slideshowSlides = this.slider?.querySelectorAll('.slideshow__slide') ?? [];
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
        const videoHandledByInline = window.__slideshowVideoLoaderActive === 'inline';
        if (this.sliderControlWrapper) {
            this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
            this.sliderControlLinksArray.forEach((link)=>link.addEventListener('click', this.linkToSlide.bind(this)));
        }
        this.slider?.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
        if (!videoHandledByInline) {
            this.addEventListener('slideChanged', this.onSlideChanged.bind(this));
            this.observeSlideMedia();
            const firstSlide = this.getSlideshowSlide(0);
            this.loadDeferredVideos(firstSlide);
            $499c0cfcaca01eb2$var$playVideosInSlide(firstSlide);
            window.__slideshowVideoLoaderActive = 'bundle';
            window.matchMedia($499c0cfcaca01eb2$var$VIDEO_POSTER_MQ).addEventListener('change', ()=>{
                const slide = this.getSlideshowSlide((this.currentPage ?? 1) - 1);
                this.querySelectorAll('.video-block[data-video-viewport]').forEach((block)=>{
                    if ($499c0cfcaca01eb2$var$videoViewportMatches(block)) return;
                    block.classList.remove('video-block--playing');
                    block.querySelectorAll('video').forEach((video)=>video.pause());
                });
                this.loadDeferredVideos(slide);
                $499c0cfcaca01eb2$var$playVideosInSlide(slide);
            });
        }
        if (this.slider?.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
    getSlideshowSlide(index) {
        return this.slideshowSlides[index] ?? this.sliderItemsToShow[index];
    }
    observeSlideMedia() {
        if (!this.slider || typeof IntersectionObserver === 'undefined') return;
        this.slideMediaObserver?.disconnect();
        this.slideMediaObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                this.loadDeferredVideos(entry.target);
                this.slideMediaObserver.unobserve(entry.target);
            });
        }, {
            root: this.slider,
            threshold: 0.25
        });
        this.slideshowSlides.forEach((slide, index)=>{
            if (index === 0) return;
            if (slide.querySelector('[data-deferred-video]')) this.slideMediaObserver.observe(slide);
        });
    }
    onSlideChanged(event) {
        const slide = this.getSlideshowSlide(this.currentPage - 1) ?? event.detail.currentElement;
        this.pauseInactiveSlideVideos();
        this.loadDeferredVideos(slide);
        const nextSlide = this.getSlideshowSlide(this.currentPage);
        if (nextSlide && nextSlide !== slide) this.loadDeferredVideos(nextSlide);
        requestAnimationFrame(()=>$499c0cfcaca01eb2$var$playVideosInSlide(slide));
    }
    loadSlideMedia(slide) {
        if (!slide) return;
        this.loadDeferredVideos(slide);
        this.loadDeferredImages(slide);
    }
    loadDeferredVideos(slide) {
        if (!slide) return;
        slide.querySelectorAll('[data-deferred-video]:not([data-loaded])').forEach((block)=>{
            if (!$499c0cfcaca01eb2$var$videoViewportMatches(block)) return;
            $499c0cfcaca01eb2$var$mountDeferredVideoBlock(block);
        });
    }
    loadDeferredImages(slide) {
        slide.querySelectorAll('picture[data-deferred-picture]:not([data-loaded])').forEach((picture)=>{
            picture.querySelectorAll('source[data-deferred-srcset]').forEach((source)=>{
                source.srcset = source.dataset.deferredSrcset;
            });
            const img = picture.querySelector('img[data-deferred-src]');
            if (img?.dataset.deferredSrc) img.src = img.dataset.deferredSrc;
            picture.setAttribute('data-loaded', '');
        });
        slide.querySelectorAll('img[data-deferred-src]:not([data-loaded])').forEach((img)=>{
            if (img.closest('picture[data-deferred-picture]')) return;
            if (img.dataset.deferredSrc) img.src = img.dataset.deferredSrc;
            if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
            img.setAttribute('data-loaded', '');
        });
    }
    pauseInactiveSlideVideos() {
        this.slideshowSlides.forEach((slide, index)=>{
            if (index === this.currentPage - 1) return;
            slide.querySelectorAll('.video-block').forEach((block)=>{
                block.classList.remove('video-block--playing');
                block.querySelectorAll('video').forEach((video)=>video.pause());
            });
        });
    }
    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }
    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
        if (!isFirstSlide && !isLastSlide) return;
        if (isFirstSlide && event.currentTarget.name === 'previous') this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        else if (isLastSlide && event.currentTarget.name === 'next') this.slideScrollPosition = 0;
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton?.removeAttribute('disabled');
        if (!this.sliderControlButtons.length) return;
        this.sliderControlButtons.forEach((link)=>{
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1]?.classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1]?.setAttribute('aria-current', true);
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }
    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }
    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index)=>{
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }
    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}
customElements.define('slideshow-component', $499c0cfcaca01eb2$var$SlideshowComponent);
class $499c0cfcaca01eb2$var$VariantSelects extends HTMLElement {
    constructor(){
        super();
        // MODIFIED: Added a flag to track the initial state when no URL params are present.
        this.initialLoadNoParams = true;
        this.inits();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }
    connectedCallback() {
        this.getChosenSize();
    }
    inits() {
        this.inventoryNote = document.querySelector('.inventoryNote');
        if (document.querySelector('#option-map')) this.optionMap = JSON.parse(document.querySelector('#option-map').textContent);
        this.updateInventoryNote();
    }
    getChosenSize() {
        // In quick-add modals, variant-selects elements have data-original-section set.
        if (this.dataset && this.dataset.originalSection) return;
        const params = new URLSearchParams(document.location.search);
        const size = decodeURIComponent(params.get('size'));
        // MODIFIED: If URL params for size exist, disable the special initial behavior.
        if (size && size !== 'null') this.initialLoadNoParams = false;
        let isBraProduct = false;
        if (document.querySelector('[data-bra-options]')) isBraProduct = true;
        if (isBraProduct) {
            this.querySelectorAll('[data-size]').forEach((sizeInput)=>{
                if (sizeInput.dataset.size.replace(/\D/g, '') == size.replace(/\D/g, '')) sizeInput.click();
            });
            this.querySelectorAll('[data-cup]').forEach((sizeInput)=>{
                if (sizeInput.dataset.cup.replace(/[0-9]/g, '') == size.replace(/[0-9]/g, '')) sizeInput.click();
            });
        } else this.querySelectorAll('[data-size]').forEach((sizeInput)=>{
            if (sizeInput.dataset.size == size) sizeInput.click();
        });
        this.onVariantChange();
        if (size && size != 'null') this.updateColorSwatches(size);
    }
    updateInventoryNote() {
        // MODIFIED: If it's the initial load with no params, clear the inventory message and stop.
        const targetBtn = document.querySelector('.product-form__submit.pick-size');
        if (this.initialLoadNoParams) {
            if (this.inventoryNote) {
                this.inventoryNote.textContent = '';
                this.inventoryNote.appendChild(document.createTextNode('\u00A0'));
                this.inventoryNote.classList.add('inventoryNote--placeholder');
            }
            if (targetBtn) targetBtn.classList.remove('hidden');
            return;
        }
        if (this.inventoryNote && typeof variantStock !== 'undefined') {
            this.updateOptions();
            this.updateMasterId();
            if (typeof variantStock !== 'undefined') this.currentVariantQuantity = variantStock.find(({ id: id })=>id === this.currentVariant.id).inventory_quantity;
            else this.currentVariantQuantity = 0;
            this.lowInventoryThreshold = this.inventoryNote.dataset.lowInventoryThreshold;
            if (this.currentVariantQuantity <= this.lowInventoryThreshold && this.lowInventoryThreshold > 0 && this.currentVariantQuantity > 0) {
                this.lowInventoryHtml = window.variantStrings.lowInventoryHtml.replace('[quantity]', this.currentVariantQuantity);
                if (this.lowInventoryHtml) {
                    this.inventoryNote.textContent = this.lowInventoryHtml;
                    this.inventoryNote.classList.remove('inventoryNote--placeholder');
                }
            } else {
                this.inventoryNote.textContent = '';
                this.inventoryNote.appendChild(document.createTextNode('\u00A0'));
                this.inventoryNote.classList.add('inventoryNote--placeholder');
            }
        }
    }
    updateLowStockNotice() {
        if (typeof connectedProductVariantData === 'undefined') return;
        const sizeLabels = document.querySelectorAll('.product__info-wrapper label[data-size]');
        const colorLabels = document.querySelectorAll('.product__info-wrapper label[data-color]');
        const lowStockThreshold = 15;
        function updateLabel(label, inventory) {
            label.classList.toggle('sold-out-label', inventory <= 0);
            label.classList.toggle('low-stock-label', inventory > 0 && inventory < lowStockThreshold);
            label.setAttribute('data-inventory', inventory);
        }
        // aggregate inventory of each size/color combination
        connectedProductVariantData.forEach((v)=>{
            const existingVariant = connectedProductVariantData.find((existingV)=>v['color'] === existingV['color'] && v['size'] === existingV['size']);
            existingVariant;
        });
        // remove duplicates based on matches on color and size
        connectedProductVariantData = connectedProductVariantData.filter((v, index, self)=>{
            return self.findIndex((t)=>t.color === v.color && t.size === v.size) === index;
        });
        // find inventory of each size in current color
        sizeLabels.forEach((label)=>{
            const variant = connectedProductVariantData.find((v)=>{
                if (colorLabels.length > 1) {
                    const isColor = v['color'].replaceAll(' ', '-').toLowerCase() == this.options[0]?.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == this.options[1]?.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == this.options[2]?.replaceAll(' ', '-').toLowerCase();
                    const isSize = v['size'].toLowerCase() == label.dataset.size.toLowerCase();
                    return isColor && isSize;
                } else {
                    const isSize = v['size'].toLowerCase() == label.dataset.size.toLowerCase();
                    return isSize;
                }
            });
            if (variant) updateLabel(label, variant.inventory_quantity);
        });
        // find inventory of each color in current size
        colorLabels.forEach((label)=>{
            const variant = connectedProductVariantData.find((v)=>{
                const isSize = v['size'].replaceAll(' ', '-').toLowerCase() == this.options[0]?.replaceAll(' ', '-').toLowerCase() || v['size'].replaceAll(' ', '-').toLowerCase() == this.options[1]?.replaceAll(' ', '-').toLowerCase() || v['size'].replaceAll(' ', '-').toLowerCase() == this.options[2]?.replaceAll(' ', '-').toLowerCase();
                const isColor = v['color'].replaceAll(' ', '-').toLowerCase() == label.dataset.colorNotHandlized.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == label.dataset.color.replaceAll(' ', '-').toLowerCase();
                return isColor && isSize;
            });
            if (variant) updateLabel(label, variant.inventory_quantity);
        });
    }
    onVariantChange() {
        const _this = this;
        this.updateOptions();
        // MODIFIED: When the user selects a size other than 'none', disable the special initial behavior.
        const selectedSize = this.querySelector('input[name="Size"]:checked')?.value;
        if (this.initialLoadNoParams && selectedSize && selectedSize !== 'none') this.initialLoadNoParams = false;
        this.updateMasterId();
        this.updateVariantStatuses();
        this.updateLowStockNotice();
        this.toggleAddButton(true, '', false, false);
        this.toggleBulkBuyButton();
        this.updatePickupAvailability();
        this.removeErrorMessage();
        //color swatch ?size= referral
        this.updateColorSwatches();
        this.updateInventoryNote();
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
        if (document.querySelector('.yotpo-reviews-star-ratings-widget')) {
            if (yotpoWidgetsContainer) yotpoWidgetsContainer.initWidgets();
        }
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select)=>select.value);
    }
    updateColorSwatches(size) {
        if (!document.querySelector('.product-colors-links')) return;
        const colorLinks = document.querySelector('.product-colors-links');
        let thisSizeOption;
        if (!size) thisSizeOption = this.optionMap['Size'].values.find((value)=>this.options.includes(value)) || '';
        else thisSizeOption = size;
        colorLinks.querySelectorAll('label').forEach((colorSwatch)=>{
            const colorSwatchLink = colorSwatch.querySelector('a');
            const colorSwatchOriginalHref = colorSwatchLink.dataset.originalHref;
            if (thisSizeOption && colorSwatchOriginalHref) colorSwatchLink.setAttribute('href', colorSwatchOriginalHref + '?size=' + encodeURIComponent(thisSizeOption));
        });
        window.dispatchEvent(new CustomEvent('colorSwatchesUpdated', {
            detail: thisSizeOption
        }));
    }
    updateMasterId() {
        // Find the variant that matches the selected options
        this.currentVariant = this.getVariantData().find((variant)=>{
            // Loop through each option and see if it matches the variant
            return !variant.options.map((option, index)=>{
                // If the option is empty, it's the default value and should match
                return this.options[index] === option;
            }).includes(false); // If any of the options don't match, return false
        });
    }
    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (mediaGallery && mediaGallery.setActiveMedia) mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        // May be absent when the variant's media isn't in this (possibly stale) modal —
        // prepend(null) would insert a stray "null" text node, so guard it.
        if (!newMediaModal) return;
        modalContent.prepend(newMediaModal);
    }
    updateURL() {
        if (!this.currentVariant || this.dataset?.updateUrl === 'false') return;
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const id = this.currentVariant.id;
        const size = this.currentVariant.option2;
        if (id) params.set('variant', id);
        if (size) params.set('size', size);
        const newURL = `${url.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newURL);
    }
    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        const sectionId = this.dataset.section;
        const productForms = document.querySelectorAll(`#product-form-${sectionId}, #bulk-product-form-${sectionId}, #product-form-installment-${sectionId}`);
        productForms.forEach((productForm)=>{
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    }
    updateVariantStatuses() {
        const productForm = document.querySelector('.product__info-wrapper product-form.product-form');
        if (productForm) document.dispatchEvent(new CustomEvent('product:size-warning-toggle', {
            detail: {
                status: false
            }
        }));
        const currentSize = this.querySelector('input[type="radio"][name="Size"]:checked')?.value;
        const variantElements = [
            ...this.querySelectorAll('.product-form__input input[type="radio"][name="Variant"]')
        ];
        const versions = variantElements.map((v)=>v.value);
        for (const version of versions){
            const foundVariant = this.variantData.find((variant)=>{
                return variant.options.includes(version) && variant.options.includes(currentSize);
            });
            if (foundVariant?.available) {
                const variantsEle = this.querySelector(`input[type="radio"][name="Variant"][value="${version}"]`);
                if (!variantsEle?.checked) variantsEle.click();
                break;
            }
        }
    }
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        if (this.currentVariant && this.currentVariant.available) {
            if (pickUpAvailability.fetchAvailability) pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }
    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;
        const productForm = section.querySelector('product-form');
        if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
    }
    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const originalSection = this.dataset.originalSection;
        const section = this.dataset.section;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${originalSection ? originalSection : section}`).then((response)=>response.text()).then((responseText)=>{
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`price-${section}`);
            const source = html.getElementById(`price-${originalSection ? originalSection : section}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(`price-${section}`);
            const color_label = document.getElementById(`Color_label-${section}`);
            if (price) price.classList.remove('visibility-hidden');
            if (color_label) color_label.innerHTML = this.currentVariant.option2;
        });
    }
    toggleAddButton(disable = true, text, modifyClass = true, modifyText = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const wishlistButton = productForm.querySelector('.klaviyo-bis-trigger');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (modifyText & !wishlistButton) {
                if (text) addButtonText.textContent = text;
            }
        } else {
            addButton.removeAttribute('disabled');
            if (modifyText) addButtonText.textContent = window.variantStrings.addToCart;
        }
        if (wishlistButton) {
            const variantSelected = this.currentVariant && this.currentVariant != 'undefined';
            const variantAvailable = this.currentVariant?.available;
            if (variantSelected && variantAvailable) {
                // Variant selected and available → show add button, hide wishlist
                addButton.classList.remove('hidden');
                wishlistButton.classList.add('hidden');
                document.querySelector('.product-form__submit.pick-size').classList.add('hidden');
                console.log('Variant selected and available');
            } else if (variantSelected && !variantAvailable) {
                // Variant selected but NOT available → show wishlist, hide add button
                addButton.classList.add('hidden');
                wishlistButton.classList.remove('hidden');
                document.querySelector('.product-form__submit.pick-size').classList.add('hidden');
                console.log('Variant selected but NOT available');
            } else // No variant selected → hide both buttons
            console.log('No variant selected');
        }
        if (!modifyClass) return;
    }
    async toggleBulkBuyButton() {
        const section = this.dataset.section;
        const form = document.getElementById(`bulk-product-form-${section}`);
        if (!form) return;
        const productForm = form.closest('product-form');
        if (this.currentVariant.quantity > 0 && this.currentVariant.quantity >= this.currentVariant.bulk_quantity) productForm.classList.remove('d-none');
        else productForm.classList.add('d-none');
    }
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('#product-variants[type="application/json"]').textContent);
        this.variantQuantity = this.variantQuantity || JSON.parse(this.querySelector('#product-variants-quantity[type="application/json"]').textContent);
        this.variantQuantity.forEach((qtyItem)=>{
            const dataItem = this.variantData.find((data)=>data.id === qtyItem.id);
            if (dataItem) {
                dataItem.quantity = qtyItem.quantity;
                dataItem.bulk_quantity = qtyItem.bulk_quantity;
            }
        });
        return this.variantData;
    }
}
customElements.define('variant-selects', $499c0cfcaca01eb2$var$VariantSelects);
class $499c0cfcaca01eb2$var$VariantRadios extends $499c0cfcaca01eb2$var$VariantSelects {
    constructor(){
        super();
        const variantData = super.getVariantData();
        const isBraOptions = this.dataset.braOptions === 'true';
        this.isBraOptions = isBraOptions;
        if (isBraOptions) {
            this.createBraOptions();
            this.braSizeOptionContainer.classList.remove('visibility-hidden');
            this.braCupOptionContainer.classList.remove('visibility-hidden');
        }
        for(let i = 0; i < variantData.length; i++)if (variantData[i].available) {
            const options = [];
            if (variantData[i].option1) options.push(variantData[i].option1);
            if (variantData[i].option2) options.push(variantData[i].option2);
            if (variantData[i].option3) options.push(variantData[i].option3);
            options.map((option)=>{
                let elSize = document.querySelector('[data-size="' + option + '"]');
                elSize?.classList.remove('sold-out');
                elSize?.classList.remove('sold-out-label');
            });
        }
    }
    createBraOptions() {
        this.braSizeOptionContainer = this.querySelector('[data-bra-size]');
        this.braCupOptionContainer = this.querySelector('[data-bra-cup]');
        this.braSizeOptions = this.querySelectorAll('[data-bra-size] .label-group');
        this.braCupOptions = this.querySelectorAll('[data-bra-cup] .label-group');
        this.preparedBraSizeOptions = buildBraOption(this.braSizeOptions, this.braSizeOptionContainer, 'size', /\D/g, sortByNameAlph);
        this.preparedBraCupOptions = buildBraOption(this.braCupOptions, this.braCupOptionContainer, 'cup', /[0-9]/g, sortByNameLex);
        function buildBraOption(braOptions, braOptionContainer, dataset, replaceRegex, sortByCb) {
            // bra sizes text
            braOptions.forEach((braOption)=>{
                braOption.querySelector('label').textContent = braOption.querySelector('label').textContent.replace(replaceRegex, '');
                braOption.querySelector('label').dataset[dataset] = braOption.querySelector('label').dataset[dataset].replace(replaceRegex, '');
                braOption.querySelector('input').value = braOption.querySelector('input').value.replace(replaceRegex, '');
            });
            let braOptionSeen = {};
            let braOptionsArray = Array.from(braOptions);
            braOptionsArray = braOptionsArray.sort(sortByCb);
            // remove duplicates
            const braOptionsArrayFiltered = braOptionsArray.filter((braOption)=>{
                const txtContent = braOption.querySelector('label').textContent;
                if (braOptionSeen[txtContent]) return false;
                else {
                    braOptionSeen[txtContent] = true;
                    return true;
                }
            });
            braOptionsArray.forEach((label)=>braOptionContainer.removeChild(label));
            braOptionsArrayFiltered.forEach((label)=>braOptionContainer.appendChild(label));
            return braOptionsArrayFiltered;
        }
        // prepare object for storing different size+cup variants
        const variants = JSON.parse(this.querySelector('#product-variants').textContent);
        this.sizeOptionExists = {};
        this.preparedBraSizeOptions.forEach((option)=>{
            variants.forEach((variant)=>{
                const variantSize = variant.option2.replace(/\D/g, '');
                const variantCup = variant.option2.replace(/[0-9]/g, '');
                this.preparedBraCupOptions.forEach((cupOption)=>{
                    const sizeOptionSize = option.querySelector('label').dataset.size;
                    const cupOptionCup = cupOption.querySelector('label').dataset.cup;
                    if (variantCup == cupOptionCup) {
                        if (!this.sizeOptionExists[`${sizeOptionSize}`]) this.sizeOptionExists[`${sizeOptionSize}`] = {};
                        if (variantSize == sizeOptionSize) {
                            this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup] = {};
                            this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].exists = true;
                            this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].available = variant.available;
                            this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].variant = variant;
                        }
                    }
                });
            });
        });
        function sortByNameAlph(a, b) {
            return parseInt(a.querySelector('label').textContent.toLowerCase()) - parseInt(b.querySelector('label').textContent.toLowerCase());
        }
        function sortByNameLex(a, b) {
            if (a.querySelector('label').textContent.trim().toLowerCase() < b.querySelector('label').textContent.trim().toLowerCase()) return -1;
            if (a.querySelector('label').textContent.trim().toLowerCase() > b.querySelector('label').textContent.trim().toLowerCase()) return 1;
            return 0;
        }
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        const _this = this;
        this.options = fieldsets.map((fieldset)=>{
            return Array.from(fieldset.querySelectorAll('input')).find((radio)=>radio.checked)?.value;
        });
        if (!this.isBraOptions) return;
        // only for bra options
        this.braChosenSize = this.options[1];
        this.braChosenCup = this.options[2];
        // Before a size AND cup are picked these are undefined, and
        // `undefined + undefined` is NaN - which is neither null nor undefined, so
        // it slips past the `this.options[n]?.replaceAll(...)` guards downstream and
        // throws "replaceAll is not a function" on every bra PDP load, aborting the
        // low-stock/sold-out pass. Only combine once both halves exist.
        this.options[1] = this.braChosenSize !== undefined && this.braChosenCup !== undefined ? this.braChosenSize + this.braChosenCup : undefined;
        this.options.pop();
        if (!this.prevBraSizeOptions) this.prevBraSizeOptions = this.preparedBraSizeOptions;
        if (!this.prevBraCupOptions) this.prevBraCupOptions = this.preparedBraCupOptions;
        // reset options to all
        this.prevBraSizeOptions.forEach((option)=>this.braSizeOptionContainer.appendChild(option));
        this.prevBraCupOptions.forEach((option)=>this.braCupOptionContainer.appendChild(option));
        // add sold out
        let allCupsUnavailable = true;
        Object.keys(this.sizeOptionExists).forEach((sizeJsonOption)=>{
            allCupsUnavailable = true;
            Object.keys(this.sizeOptionExists[sizeJsonOption]).forEach((cupJsonOption)=>{
                if (this.sizeOptionExists[sizeJsonOption][cupJsonOption].available) allCupsUnavailable = false;
            });
            if (allCupsUnavailable) this.preparedBraSizeOptions.forEach((option)=>{
                if (option.querySelector('label').dataset.size == sizeJsonOption) {
                    option.querySelector('label').classList.add('sold-out');
                    option.querySelector('label').classList.add('sold-out-label');
                }
            });
        });
        // remove unavailable
        if (this.sizeOptionExists[this.braChosenSize]) Object.keys(this.sizeOptionExists[this.braChosenSize]).forEach((cupJsonOption)=>{
            // soldout on cups
            this.preparedBraCupOptions.forEach((cupOption)=>{
                if (cupOption.querySelector('label').dataset.cup == cupJsonOption) {
                    if (this.sizeOptionExists[this.braChosenSize][cupJsonOption].available) {
                        cupOption.querySelector('label').classList.remove('sold-out');
                        cupOption.querySelector('label').classList.remove('sold-out-label');
                    } else {
                        cupOption.querySelector('label').classList.add('sold-out');
                        cupOption.querySelector('label').classList.add('sold-out-label');
                    }
                }
                // if cup doesn't exist remove options
                if (!Object.keys(this.sizeOptionExists[this.braChosenSize]).includes(cupOption.querySelector('label').dataset.cup)) {
                    const firstCup = Object.keys(this.sizeOptionExists[this.braChosenSize])[0];
                    // select first option if cup option was removed (to prevent undefined cup)
                    if (!this.braCupOptionContainer.querySelector('input:checked')) selectFirstOptionLoop: for (const option of this.preparedBraCupOptions){
                        if (option.querySelector('label').dataset.cup == firstCup) break selectFirstOptionLoop;
                    }
                    // remove cups
                    if (this.braCupOptionContainer.contains(cupOption)) {
                        if (cupOption.querySelector('label').dataset.cup == this.braChosenCup) {
                            // workaround to prevent unable to select different cups after selected cup option is removed
                            cupOption.querySelector('input').checked = false;
                            cupOption.closest('.label-group').querySelector('label').click();
                            setTimeout(()=>{
                                this.braCupOptionContainer.removeChild(cupOption);
                            }, 10);
                        } else this.braCupOptionContainer.removeChild(cupOption);
                    }
                }
            });
        /* remove unavailable sizes
        if (this.braChosenCup) {
          this.preparedBraSizeOptions.forEach(sizeOption => {
            if (!Object.keys(this.sizeOptionExists[sizeOption.querySelector('label').dataset.size]).includes(this.braChosenCup)) {
              if (this.braSizeOptionContainer.contains(sizeOption)) {
                this.braSizeOptionContainer.removeChild(sizeOption);
              }
            }
          })
        }
        */ });
    }
}
customElements.define('variant-radios', $499c0cfcaca01eb2$var$VariantRadios);
class $499c0cfcaca01eb2$var$StickyWatcher {
    constructor(selector){
        this.element = document.querySelector(selector);
        if (!this.element) return;
        this.top = parseInt(getComputedStyle(this.element).top, 10) || 0;
        this.check = this.check.bind(this);
        window.addEventListener('scroll', this.check, {
            passive: true
        });
        window.addEventListener('resize', this.check);
        this.check();
    }
    check() {
        if (!this.element) return;
        const rectTop = this.element.getBoundingClientRect().top;
        if (rectTop <= this.top + 50) this.element.classList.add('sticky');
        else this.element.classList.remove('sticky');
    }
}
new $499c0cfcaca01eb2$var$StickyWatcher('.facet-main__wrapper-desktop');
new $499c0cfcaca01eb2$var$StickyWatcher('.facet-main__wrapper-mobile');
(function() {
    function init() {
        // 1. Select all target videos
        const videos = document.querySelectorAll('video.promo-text-media');
        // 2. Define the observer options
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.6
        };
        // 3. Define the callback function for the observer
        const handlePlay = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const vid = entry.target;
                    // ensure autoplay is allowed on most browsers
                    try {
                        vid.muted = true;
                        vid.playsInline = true;
                        vid.setAttribute('muted', '');
                        vid.setAttribute('playsinline', '');
                    } catch (e) {}
                    const playPromise = vid.play();
                    if (playPromise !== undefined) playPromise.catch((error)=>{
                        console.warn("Autoplay prevented by browser policy:", error);
                    });
                }
            });
        };
        // 4. Create the observer
        const observer = new IntersectionObserver(handlePlay, options);
        // small helper to observe a video only once
        const observeVideo = (video)=>{
            if (!(video instanceof HTMLVideoElement)) return;
            if (video.__promoObserved) return;
            video.__promoObserved = true;
            // friendly defaults
            video.preload = video.preload || 'auto';
            try {
                video.muted = true;
                video.playsInline = true;
            } catch (e) {}
            observer.observe(video);
            // console.log for quick debug (remove in production)
            console.debug('Observing video.promo-text-media', video);
        };
        // 5. Start observing each existing video
        videos.forEach(observeVideo);
        const mo = new MutationObserver((mutations)=>{
            for (const m of mutations){
                if (m.type !== 'childList') continue;
                m.addedNodes.forEach((node)=>{
                    if (node.nodeType !== 1) return;
                    if (node.matches && node.matches('video.promo-text-media')) observeVideo(node);
                    else if (node.querySelectorAll) node.querySelectorAll('video.promo-text-media').forEach(observeVideo);
                });
            }
        });
        mo.observe(document.documentElement || document.body, {
            childList: true,
            subtree: true
        });
    }
    // Run init whether DOMContentLoaded already fired or not (avoids race).
    if (document.readyState === 'loading') document.addEventListener("DOMContentLoaded", init, {
        once: true
    });
    else init();
})();
$499c0cfcaca01eb2$var$lazyLoadImages();
window.addEventListener('more-content-loaded', $499c0cfcaca01eb2$var$lazyLoadImages);
function $499c0cfcaca01eb2$var$lazyLoadImages() {
    // 1. Select target images
    const lazyImages = document.querySelectorAll('.card__media img:not(.observed)');
    // 2. Define standard options (optional: rootMargin loads images 200px before they appear)
    const options = {
        root: null,
        rootMargin: '0px 0px 300px 0px',
        threshold: 0.01 // trigger when 1% of the image is visible
    };
    // 3. Image Observer Callback
    const imageObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const img = entry.target;
                // Swap data-src to src
                if (img.dataset.src) img.src = img.dataset.src;
                // Swap data-srcset to srcset
                if (img.dataset.srcset) img.srcset = img.dataset.srcset;
                // Optional: Add a class for CSS transitions (e.g., fade-in)
                img.classList.add('observed');
                // Stop observing this image after loading
                observer.unobserve(img);
            }
        });
    }, options);
    // 4. Start observing each image
    lazyImages.forEach((image)=>{
        imageObserver.observe(image);
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>$499c0cfcaca01eb2$var$initVideoBlocks(), {
    once: true
});
else $499c0cfcaca01eb2$var$initVideoBlocks();
document.addEventListener('shopify:section:load', (event)=>{
    $499c0cfcaca01eb2$var$initVideoBlocks(event.target);
});




$d2a39fa7521e334e$var$startTrackingCart();
function $d2a39fa7521e334e$var$startTrackingCart() {
    document.querySelectorAll('cart-remove-button')?.forEach((button)=>{
        button.addEventListener("click", (event)=>{
            removeFromCartGEvents(event.target);
        });
    });
    function removeFromCartGEvents(el) {
        const productItem = el.closest('.cart-item');
        if (!productItem) return;
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'remove_from_cart',
            'currency': document.querySelector("body").dataset.currency,
            'ecommerce': {
                'items': [
                    {
                        item_id: productItem.dataset.id,
                        item_name: productItem.dataset.title,
                        item_brand: productItem.dataset.brand,
                        price: productItem.dataset.price
                    }
                ]
            }
        });
        console.log("Remove from cart event");
    }
}
class $d2a39fa7521e334e$export$d6a23a7cc9349916 extends HTMLElement {
    constructor(){
        super();
        this.addEventListener("click", (event)=>{
            event.preventDefault();
            const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}
customElements.define("cart-remove-button", $d2a39fa7521e334e$export$d6a23a7cc9349916);
class $d2a39fa7521e334e$export$15b705ee80c3249 extends HTMLElement {
    constructor(){
        super();
        this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
        this.maxFailedRetries = 3;
        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput)=>total + parseInt(quantityInput.value), 0);
        this.debouncedOnChange = debounce((event)=>{
            this.onChange(event);
        }, 300);
        this.addEventListener("change", this.debouncedOnChange.bind(this));
    }
    onChange(event) {
        this.maxFailedRetries = 3;
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
    }
    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items").dataset.id,
                selector: ".js-contents"
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section"
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: ".shopify-section"
            },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer").dataset.id,
                selector: ".js-contents"
            }
        ];
    }
    async updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        const itemCo2 = document.querySelectorAll('.cart-item__co2');
        const itemCo2Value = itemCo2.length ? itemCo2[line - 1].value : '';
        // /cart/change.js REPLACES a line's properties with whatever is sent — it never merges.
        // Sending item_co2 on its own therefore deleted every OTHER property on that line, so
        // one press of +/- wiped the Final Sale notice and the _line_gender tag. Reported as
        // "the notice disappears when a discount applies" (Christian, 2026-09-15) because the
        // 3-for discount is reached BY changing quantity — the discount itself was innocent.
        // Read what the line currently has and merge, so item_co2 is refreshed and nothing else
        // is touched. If the read fails, send no properties at all: Shopify then leaves the
        // line's properties exactly as they were, which is the safe direction to fail in.
        let properties;
        try {
            const cartUrl = window.routes && routes.cart_url || '/cart';
            const cart = await (await fetch(`${cartUrl}.js`)).json();
            const current = cart.items && cart.items[line - 1] && cart.items[line - 1].properties || {};
            properties = {
                ...current
            };
            if (itemCo2Value) properties.item_co2 = itemCo2Value;
        } catch (e) {
            properties = null;
        }
        const body = JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map((section)=>section.section),
            sections_url: window.location.pathname,
            ...properties ? {
                properties: properties
            } : {}
        });
        fetch(`${routes.cart_change_url}`, {
            ...(0, $499c0cfcaca01eb2$export$1811237fdf5ac5d)(),
            body: body
        }).then((response)=>{
            return response.text();
        }).then((state)=>{
            const parsedState = JSON.parse(state);
            this.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");
            if (parsedState.errors) throw new Error(parsedState.errors);
            if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
            this.getSectionsToRender().forEach((section)=>{
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                const renderCartEvent = new CustomEvent("rendered-cart");
                window.dispatchEvent(renderCartEvent);
            });
            this.updateLiveRegions(line, parsedState.item_count);
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) cartDrawerWrapper ? (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            else if (parsedState.item_count === 0 && cartDrawerWrapper) (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
            else if (document.querySelector(".cart-item") && cartDrawerWrapper) (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(cartDrawerWrapper, document.querySelector(".cart-item__name"));
            this.disableLoading();
        }).catch((err)=>{
            this.querySelectorAll(".loading-overlay").forEach((overlay)=>overlay.classList.add("hidden"));
            const maxQty = parseInt(err.message.split(" ")[1]);
            if (this.maxFailedRetries > 0) {
                if (maxQty && typeof maxQty === "number") this.updateQuantity(line, maxQty, name);
                this.maxFailedRetries--;
            }
            const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error;
            this.disableLoading();
        });
    }
    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            lineItemError.querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace("[quantity]", quantityElement.value);
        }
        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);
        const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);
        setTimeout(()=>{
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
    enableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");
        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);
        [
            ...cartItemElements,
            ...cartDrawerItemElements
        ].forEach((overlay)=>overlay.classList.remove("hidden"));
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
    disableLoading() {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");
    }
}
customElements.define("cart-items", $d2a39fa7521e334e$export$15b705ee80c3249);
if (!customElements.get("cart-note")) customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor(){
        super();
        this.addEventListener("change", debounce((event)=>{
            const body = JSON.stringify({
                note: event.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...(0, $499c0cfcaca01eb2$export$1811237fdf5ac5d)(),
                body: body
            });
        }, 300));
    }
});
class $d2a39fa7521e334e$export$3abeb559052d55d extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('keyup', (evt)=>evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
        this.showCartDrawerAfterRedirection();
    }
    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event)=>{
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event)=>{
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }
    showCartDrawerAfterRedirection() {
        if (window.location.href.includes("show-cart-drawer")) {
            this.open();
            window.history.replaceState({}, document.title, "/");
        }
    }
    open(triggeredBy) {
        const scrollableTarget = this.querySelector('cart-drawer-items');
        if (scrollableTarget) document.body.classList.add('overflow-hidden', 'relative');
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(()=>{
            this.classList.add('animate', 'active');
        });
        this.querySelector('#CartDrawer-Checkout').addEventListener('click', this.checkoutValidation.bind(this));
        this.addEventListener('transitionend', ()=>{
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(containerToTrapFocusOn, focusElement);
        }, {
            once: true
        });
        document.body.classList.add('overflow-hidden', 'hide-icons');
    }
    close() {
        document.body.classList.remove('overflow-hidden', 'relative');
        this.querySelector('#CartDrawer-Checkout').removeEventListener('click', this.checkoutValidation.bind(this));
        this.classList.remove('active');
        (0, $499c0cfcaca01eb2$export$c761a6bf8c4188fe)(this.activeElement);
        document.body.classList.remove('overflow-hidden', 'hide-icons');
    }
    checkoutValidation(event) {
        const cartDrawerTerms = document.querySelector("#CartDrawer-terms");
        if (!cartDrawerTerms) return;
        if (!cartDrawerTerms.checked) {
            event.preventDefault();
            this.querySelector('.checkout_validation-modal')?.open();
            return false;
        }
    }
    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');
        if (cartDrawerNote.nextElementSibling.getAttribute('id')) cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        cartDrawerNote.addEventListener('click', (event)=>{
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
    refetchCartItems() {
        try {
            // cache: "no-store" so returning from checkout doesn't re-render with a stale, HTTP-cached cart.
            fetch(`/cart`, {
                cache: "no-store"
            }).then((data)=>{
                return data.text();
            }).then((parsedData)=>{
                const newCartItems = new DOMParser().parseFromString(parsedData, 'text/html').querySelector("cart-drawer");
                if (newCartItems.querySelectorAll(".cart-item").length) {
                    this.querySelectorAll('.is-empty').forEach((isEmptyNode)=>isEmptyNode.classList.remove("is-empty"));
                    const emptyInner = this.querySelector(".drawer__inner-empty");
                    if (emptyInner) emptyInner.remove();
                    const cartCountdown = this.querySelector(".cart-countdown");
                    if (cartCountdown) cartCountdown.classList.remove("hidden");
                    const cartDrawer = document.querySelector("cart-drawer");
                    if (cartDrawer) cartDrawer.classList.remove("is-empty");
                    this.parentElement.classList.remove("is-empty");
                }
                const cartItems = this.querySelector("#CartDrawer-CartItems");
                if (cartItems) cartItems.innerHTML = newCartItems.querySelector("#CartDrawer-CartItems").innerHTML;
                const cartFooter = this.querySelector(".drawer__footer-wrapper");
                if (cartFooter) cartFooter.innerHTML = newCartItems.querySelector(".drawer__footer-wrapper").innerHTML;
                // Let dependent UI (e.g. the free-shipping countdown bar) recalculate from the fresh cart.
                window.dispatchEvent(new CustomEvent("rendered-cart"));
            });
        } catch (error) {
            console.error(error);
        }
    }
    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section)=>{
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        setTimeout(()=>{
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
            const renderCartEvent = new CustomEvent("rendered-cart");
            window.dispatchEvent(renderCartEvent);
        });
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }
    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('cart-drawer', $d2a39fa7521e334e$export$3abeb559052d55d);
class $d2a39fa7521e334e$export$db97af19f1eec5a0 extends $d2a39fa7521e334e$export$15b705ee80c3249 {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            }
        ];
    }
}
customElements.define('cart-drawer-items', $d2a39fa7521e334e$export$db97af19f1eec5a0);
class $d2a39fa7521e334e$export$a82bb8931df5e23e extends HTMLElement {
    constructor(){
        super();
        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.notification.addEventListener('keyup', (evt)=>evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton)=>closeButton.addEventListener('click', this.close.bind(this)));
    }
    open() {
        this.notification.classList.add('animate', 'active');
        this.notification.addEventListener('transitionend', ()=>{
            this.notification.focus();
            (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(this.notification);
        }, {
            once: true
        });
        document.body.addEventListener('click', this.onBodyClick);
    }
    close() {
        this.notification.classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
        (0, $499c0cfcaca01eb2$export$c761a6bf8c4188fe)(this.activeElement);
    }
    renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section)=>{
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        this.open();
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`
            },
            {
                id: 'cart-notification-button'
            },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure, header-menu');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('cart-notification', $d2a39fa7521e334e$export$a82bb8931df5e23e);
// Re-render the cart drawer when the shopper returns from checkout (typically via the browser back
// button). Checkout can change cart-level state — most notably an applied discount code — which the
// cached store page and drawer don't reflect until a reload, leaving the free-shipping bar showing a
// stale "threshold reached" state. We mark the departure to checkout, and on the way back re-fetch
// the cart and refresh the drawer's totals + free-shipping bar in place. See BLE-11137.
(function refreshCartDrawerOnReturnFromCheckout() {
    const RETURN_FLAG = "ob:returning-from-checkout";
    // sessionStorage throws when storage is unavailable (Safari private browsing, disabled cookies,
    // quota exceeded). This runs on every document click, so an uncaught throw would break unrelated
    // click handlers — degrade to "no refresh" instead.
    const setFlag = ()=>{
        try {
            sessionStorage.setItem(RETURN_FLAG, "1");
        } catch (error) {
        /* storage unavailable */ }
    };
    const readAndClearFlag = ()=>{
        try {
            const flag = sessionStorage.getItem(RETURN_FLAG);
            // Clear it whenever it was set, so a later forward navigation doesn't refresh unnecessarily.
            if (flag) sessionStorage.removeItem(RETURN_FLAG);
            return flag;
        } catch (error) {
            return null;
        }
    };
    document.addEventListener("click", (event)=>{
        const checkoutTrigger = event.target.closest('[name="checkout"], #CartDrawer-Checkout, .shopify-payment-button, a[href*="/checkout"]');
        if (checkoutTrigger) setFlag();
    }, true);
    window.addEventListener("pageshow", (event)=>{
        if (!readAndClearFlag()) return;
        const [navigation] = performance.getEntriesByType("navigation");
        const cameBack = event.persisted || navigation?.type === "back_forward";
        if (!cameBack) return;
        const drawer = document.querySelector("cart-drawer");
        if (typeof drawer?.refetchCartItems === "function") drawer.refetchCartItems();
    });
})();


const $c81c3df9529c7ce2$var$selectors = {
    customerAddresses: '[data-customer-addresses]',
    addressCountrySelect: '[data-address-country-select]',
    addressContainer: '[data-address]',
    toggleAddressButton: 'button[aria-expanded]',
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: 'button[data-confirm-message]'
};
const $c81c3df9529c7ce2$var$attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message'
};
const $c81c3df9529c7ce2$var$Shopify = window.Shopify;
class $c81c3df9529c7ce2$export$16b91333b6249bfc {
    constructor(){
        if (window.customerAddresses) return window.customerAddresses;
        setTimeout(()=>{
            this._initialize();
        }, 100);
    }
    _initialize() {
        this.elements = this._getElements();
        if (Object.keys(this.elements).length === 0) {
            setTimeout(()=>{
                this._initialize();
            }, 500);
            return;
        }
        this._setupCountries();
        this._setupEventListeners();
        window.customerAddresses = this;
    }
    _getElements() {
        const container = document.querySelector($c81c3df9529c7ce2$var$selectors.customerAddresses);
        return container ? {
            container: container,
            addressContainer: container.querySelector($c81c3df9529c7ce2$var$selectors.addressContainer),
            toggleButtons: container.querySelectorAll($c81c3df9529c7ce2$var$selectors.toggleAddressButton),
            cancelButtons: container.querySelectorAll($c81c3df9529c7ce2$var$selectors.cancelAddressButton),
            deleteButtons: container.querySelectorAll($c81c3df9529c7ce2$var$selectors.deleteAddressButton),
            countrySelects: container.querySelectorAll($c81c3df9529c7ce2$var$selectors.addressCountrySelect)
        } : {};
    }
    _setupCountries() {
        if ($c81c3df9529c7ce2$var$Shopify && $c81c3df9529c7ce2$var$Shopify.CountryProvinceSelector) {
            // eslint-disable-next-line no-new
            new $c81c3df9529c7ce2$var$Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                hideElement: 'AddressProvinceContainerNew'
            });
            this.elements.countrySelects.forEach((select)=>{
                const formId = select.dataset.formId;
                // eslint-disable-next-line no-new
                new $c81c3df9529c7ce2$var$Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
                    hideElement: `AddressProvinceContainer_${formId}`
                });
            });
        }
    }
    _setupEventListeners() {
        this.elements.cancelButtons.forEach((element)=>{
            element.addEventListener('click', this._handleCancelButtonClick);
        });
        this.elements.deleteButtons.forEach((element)=>{
            element.addEventListener('click', this._handleDeleteButtonClick);
        });
    }
    _toggleExpanded(target) {
        const currentValue = target.getAttribute($c81c3df9529c7ce2$var$attributes.expanded);
        const newValue = (currentValue === "false").toString();
        target.setAttribute($c81c3df9529c7ce2$var$attributes.expanded, newValue);
        target.setAttribute("data-expanded", newValue);
    }
    _handleAddEditButtonClick = ({ currentTarget: currentTarget })=>{
        this._toggleExpanded(currentTarget);
    };
    _handleCancelButtonClick = ({ currentTarget: currentTarget })=>{
        const addressContainer = currentTarget.closest("[data-address]");
        const toggleButton = addressContainer ? addressContainer.querySelector(`[${$c81c3df9529c7ce2$var$attributes.expanded}]`) : null;
        if (toggleButton) this._toggleExpanded(toggleButton);
    };
    _handleDeleteButtonClick = ({ currentTarget: currentTarget })=>{
        // eslint-disable-next-line no-alert
        if (confirm(currentTarget.getAttribute($c81c3df9529c7ce2$var$attributes.confirmMessage))) $c81c3df9529c7ce2$var$Shopify.postLink(currentTarget.dataset.target, {
            parameters: {
                _method: 'delete'
            }
        });
    };
}
window.onload = ()=>{
    typeof $c81c3df9529c7ce2$export$16b91333b6249bfc !== 'undefined' && new $c81c3df9529c7ce2$export$16b91333b6249bfc();
};


class $efdbc15424b9706c$export$744d08d458a2219d extends HTMLElement {
    constructor(){
        super();
        this.filtersElementDesktop = document.querySelector('.facet-main__wrapper-desktop');
        this.filterElementSearch = document.getElementById('main-collection-filters');
        // dropdown
        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle?.querySelector('summary').nextElementSibling;
        this.mainDetailsToggle?.addEventListener('focusout', this.onElementout.bind(this));
        this.mainDetailsToggle?.addEventListener('toggle', this.onToggle.bind(this));
        // mega menu
        this.mainMegaMenu = this.querySelector('.mega-menu');
        this.mainMegaMenuToggle = this.mainMegaMenu?.querySelector('.header__menu-item');
        this.mainMegaMenuContent = this.mainMegaMenuToggle?.nextElementSibling;
        this.mainMegaMenuToggle?.addEventListener('mouseleave', this.onElementout.bind(this), false);
        this.mainMegaMenuContent?.addEventListener('mouseleave', this.onElementout.bind(this), false);
        this.mainMegaMenuToggle?.addEventListener('mouseover', this.onToggle.bind(this), false);
    }
    onElementout(event) {
        setTimeout(()=>{
            if (event.type == 'focusout') {
                if (!this.contains(document.activeElement)) this.close(event);
            } else this.close(event);
        });
    }
    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();
        if (this.mainMegaMenu.hasAttribute('open')) this.animations.forEach((animation)=>animation.play());
        else this.animations.forEach((animation)=>animation.cancel());
    }
    open() {
        this.mainMegaMenu?.setAttribute('open', '');
        this.mainMegaMenuToggle?.setAttribute('aria-expanded', true);
        this.filtersElementDesktop?.classList.add('z-2');
    }
    close(event) {
        if (event) {
            if (event.type == 'focusout') {
                this.mainDetailsToggle?.removeAttribute('open');
                this.mainDetailsToggle?.querySelector('summary').setAttribute('aria-expanded', false);
            }
            let toElement = event.toElement || event.relatedTarget;
            if (toElement != this.mainMegaMenuContent) {
                this.mainMegaMenu?.removeAttribute('open');
                this.mainMegaMenuToggle?.setAttribute('aria-expanded', false);
                if (this.filtersElementDesktop) this.filtersElementDesktop?.classList.remove('z-2');
                if (this.filterElementSearch) this.filterElementSearch.classList.remove('display_none');
            }
        }
    }
}
customElements.define('details-disclosure', $efdbc15424b9706c$export$744d08d458a2219d);
class $efdbc15424b9706c$export$2730b686806681be extends $efdbc15424b9706c$export$744d08d458a2219d {
    constructor(){
        super();
        this.header = document.querySelector('.header-wrapper');
    }
    onToggle() {
        if (!this.header) return;
        // Close all other open mega menus before opening this one
        this.closeOtherMegaMenus();
        this.header.preventHide = this.mainMegaMenu?.hasAttribute('open');
        this.open();
        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
    closeOtherMegaMenus() {
        // Find all header-menu elements and close their mega menus except this one
        const allHeaderMenus = document.querySelectorAll('header-menu');
        if (!allHeaderMenus || allHeaderMenus.length <= 1) return;
        allHeaderMenus.forEach((headerMenu)=>{
            if (headerMenu !== this) {
                const megaMenu = headerMenu.querySelector('.mega-menu');
                const menuToggle = headerMenu.querySelector('.header__menu-item');
                if (!megaMenu || !menuToggle) return;
                if (megaMenu?.hasAttribute('open')) {
                    megaMenu.removeAttribute('open');
                    menuToggle?.setAttribute('aria-expanded', false);
                }
            }
        });
    }
}
customElements.define('header-menu', $efdbc15424b9706c$export$2730b686806681be);
class $efdbc15424b9706c$export$e93b0271171ef3a extends $efdbc15424b9706c$export$744d08d458a2219d {
    constructor(){
        super();
        this.header = document.querySelector('.header-wrapper');
    }
    onToggle() {
        if (!this.header) return;
        this.header.preventHide = this.mainDetailsToggle.open;
        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
}
customElements.define('header-dropdown', $efdbc15424b9706c$export$e93b0271171ef3a);



class $c37e6b43335f0047$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');
        this.detailsContainer.addEventListener('keyup', (event)=>event.code.toUpperCase() === 'ESCAPE' && this.close());
        this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
        this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
        this.summaryToggle.setAttribute('role', 'button');
    }
    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }
    onSummaryClick(event) {
        event.preventDefault();
        event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }
    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }
    open(event) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');
        (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
        document.dispatchEvent(new CustomEvent('search-button-clicked', {
            bubbles: true,
            composed: true,
            detail: {
                message: 'Search button clicked'
            }
        }));
        document.querySelector('#Details-menu-drawer-container')?.setAttribute('open', false);
        document.querySelector('#Details-menu-drawer-container')?.classList.remove('menu-opening');
    }
    close(focusToggle = true) {
        (0, $499c0cfcaca01eb2$export$c761a6bf8c4188fe)(focusToggle ? this.summaryToggle : null);
        this.detailsContainer.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');
    }
}
customElements.define('details-modal', $c37e6b43335f0047$export$2e2bcd8739ae039);



class $6b658db0a1a64c51$var$FacetFiltersForm extends HTMLElement {
    constructor(){
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.debouncedOnSubmit = debounce((event)=>{
            this.onSubmitHandler(event);
        }, 500);
        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
    static setListeners() {
        const onHistoryChange = (event)=>{
            const searchParams = event.state ? event.state.searchParams : $6b658db0a1a64c51$var$FacetFiltersForm.searchParamsInitial;
            if (searchParams === $6b658db0a1a64c51$var$FacetFiltersForm.searchParamsPrev) return;
            $6b658db0a1a64c51$var$FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }
    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element)=>{
            element.classList.toggle('disabled', disable);
        });
    }
    static renderPage(searchParams, event, updateURLHash = true) {
        $6b658db0a1a64c51$var$FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = $6b658db0a1a64c51$var$FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) countContainer.classList.add('loading');
        if (countContainerDesktop) countContainerDesktop.classList.add('loading');
        sections.forEach((section)=>{
            const url = `${window.location.pathname}?${searchParams}`;
            const filterDataUrl = (element)=>element.url === url;
            $6b658db0a1a64c51$var$FacetFiltersForm.filterData.some(filterDataUrl) ? $6b658db0a1a64c51$var$FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : $6b658db0a1a64c51$var$FacetFiltersForm.renderSectionFromFetch(url, event);
        });
        if (updateURLHash) $6b658db0a1a64c51$var$FacetFiltersForm.updateURLHash(searchParams);
    }
    static renderSectionFromFetch(url, event) {
        fetch(url).then((response)=>response.text()).then((responseText)=>{
            const html = responseText;
            $6b658db0a1a64c51$var$FacetFiltersForm.filterData = [
                ...$6b658db0a1a64c51$var$FacetFiltersForm.filterData,
                {
                    html: html,
                    url: url
                }
            ];
            $6b658db0a1a64c51$var$FacetFiltersForm.renderFilters(html, event);
            $6b658db0a1a64c51$var$FacetFiltersForm.renderProductGridContainer(html);
            $6b658db0a1a64c51$var$FacetFiltersForm.renderProductCount(html);
            (0, $1bea9d28d9321d72$export$9a93d579ca1d4ee6)();
        });
    }
    static renderSectionFromCache(filterDataUrl, event) {
        const html = $6b658db0a1a64c51$var$FacetFiltersForm.filterData.find(filterDataUrl).html;
        $6b658db0a1a64c51$var$FacetFiltersForm.renderFilters(html, event);
        $6b658db0a1a64c51$var$FacetFiltersForm.renderProductGridContainer(html);
        $6b658db0a1a64c51$var$FacetFiltersForm.renderProductCount(html);
        (0, $1bea9d28d9321d72$export$9a93d579ca1d4ee6)();
    }
    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
        window.dispatchEvent(new Event('more-content-loaded'));
    }
    static renderProductCount(html) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const newCountElementFilter = parsedHTML.querySelector('.product-count');
        const newCountFilter = newCountElementFilter ? newCountElementFilter.innerHTML : '0';
        const currentContainer = document.getElementById('ProductCount');
        const currentContainerDesktop = document.getElementById('ProductCountDesktop');
        const currentContainerFilter = document.querySelector('.product-count');
        if (currentContainer) currentContainer.classList.remove('loading');
        if (currentContainerDesktop) currentContainerDesktop.classList.remove('loading');
        if (currentContainerFilter) currentContainerFilter.innerHTML = newCountFilter;
    }
    static toggleSizeFacetVisibility() {
        const facets = document.querySelectorAll('#FacetFiltersFormMobile .js-filter.mobile-facets__details:not(.price-range-details)');
        if (!facets.length) return;
        facets.forEach((facet)=>{
            const enabledOptions = facet.querySelectorAll('.mobile-facets__checkbox:not([disabled])');
            // hide when 0 or 1 enabled option, show otherwise
            facet.style.display = enabledOptions.length <= 1 ? 'none' : '';
        });
    }
    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
        const matchesIndex = (element)=>{
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter((element)=>!matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
        facetsToRender.forEach((element)=>{
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });
        $6b658db0a1a64c51$var$FacetFiltersForm.renderActiveFacets(parsedHTML);
        $6b658db0a1a64c51$var$FacetFiltersForm.renderAdditionalElements(parsedHTML);
        const newButtonContainer = parsedHTML.querySelector('#filterCloseClearButton');
        const oldButtonContainer = document.querySelector('#filterCloseClearButton');
        if (newButtonContainer && oldButtonContainer) oldButtonContainer.outerHTML = newButtonContainer.outerHTML;
        // add timeout to ensure this gets executed last
        setTimeout(()=>{
            const onSaleInput = document.querySelector('#Filter-On-Sale');
            if (onSaleInput && window.location.href.includes('filter.p.m.custom.is_product_on_sale=1')) onSaleInput.setAttribute('checked', 'true');
        }, 5);
        if (countsToRender) $6b658db0a1a64c51$var$FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        $6b658db0a1a64c51$var$FacetFiltersForm.toggleSizeFacetVisibility();
    }
    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [
            '.active-facets-mobile',
            '.active-facets-desktop'
        ];
        activeFacetElementSelectors.forEach((selector)=>{
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });
        $6b658db0a1a64c51$var$FacetFiltersForm.toggleActiveFacets(false);
    }
    static renderAdditionalElements(html) {
        const mobileElementSelectors = [
            '.mobile-facets__open',
            '.mobile-facets__count',
            '.sorting'
        ];
        mobileElementSelectors.forEach((selector)=>{
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });
        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');
        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');
        if (sourceElement && targetElement) target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        if (targetElementAccessibility && sourceElementAccessibility) target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
    static updateURLHash(searchParams) {
        history.pushState({
            searchParams: searchParams
        }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id
            }
        ];
    }
    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }
    onSubmitForm(searchParams, event) {
        $6b658db0a1a64c51$var$FacetFiltersForm.renderPage(searchParams, event);
    }
    onActiveSortHandler(target) {
        const targetWrapper = target.closest('.mobile-facets__submenu');
        if (!targetWrapper) return;
        targetWrapper.querySelectorAll('.mobile-facets__list .mobile-facets__item').forEach((item)=>{
            item.classList.remove('checked');
            const itemInput = item.querySelector('input');
            if (itemInput.tagName === 'INPUT') itemInput.checked = false;
        });
        target.parentElement.classList.toggle('checked');
        if (target.parentElement.classList.contains('checked')) target.checked = true;
    }
    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.target.classList.contains('mobile-facets__checkbox')) {
            const currentTarget = event.target;
            const currentTargetType = currentTarget.getAttribute('data-type');
            if (currentTargetType === 'sort') this.onActiveSortHandler(currentTarget);
            else {
                const parentLi = currentTarget.closest('li');
                if (parentLi && parentLi.dataset.radioGroup === 'availability') {
                    const allItemsInGroup = document.querySelectorAll(`li[data-radio-group="availability"]`);
                    allItemsInGroup.forEach((item)=>{
                        item.classList.remove('checked');
                    });
                    parentLi.classList.add('checked');
                } else parentLi.classList.toggle('checked');
            }
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
            sortFilterForms.forEach((form)=>{
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') forms.push(this.createSearchParams(form));
                } else if (form.id === 'FacetFiltersFormMobile') forms.push(this.createSearchParams(form));
            });
            this.onSubmitForm(forms.join('&'), event);
        }
    }
    onActiveFilterClick(event) {
        event.preventDefault();
        $6b658db0a1a64c51$var$FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        $6b658db0a1a64c51$var$FacetFiltersForm.renderPage(url);
    }
}
$6b658db0a1a64c51$var$FacetFiltersForm.filterData = [];
$6b658db0a1a64c51$var$FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
$6b658db0a1a64c51$var$FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', $6b658db0a1a64c51$var$FacetFiltersForm);
$6b658db0a1a64c51$var$FacetFiltersForm.setListeners();
class $6b658db0a1a64c51$var$PriceRange extends HTMLElement {
    constructor(){
        super();
        this.querySelectorAll('input').forEach((element)=>element.addEventListener('change', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        let minInput = inputs[0];
        let maxInput = inputs[1];
        if (minInput.value === '') minInput.value = minInput.getAttribute('min');
        if (maxInput.value === '') maxInput.value = maxInput.getAttribute('max');
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
    }
    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));
        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}
customElements.define('price-range', $6b658db0a1a64c51$var$PriceRange);
class $6b658db0a1a64c51$var$FacetRemove extends HTMLElement {
    constructor(){
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event)=>{
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }
    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}
customElements.define('facet-remove', $6b658db0a1a64c51$var$FacetRemove);


class $874a32e76b909941$var$StickyHeader extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.predictiveSearch = this.querySelector('predictive-search');
        this.body = document.querySelector('body');
        this.onScrollHandler = this.onScroll.bind(this);
        this.onScrollHandler;
        window.addEventListener('scroll', this.onScrollHandler, false);
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }
    onScroll() {
        const announcementBarheight = document.querySelector("#shopify-section-announcement-bar").offsetHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop < announcementBarheight) this.hide();
        else this.reveal();
    }
    hide() {
        this.header.classList.remove('shopify-section-header-sticky');
        this.body.classList.remove('sticky-header-active');
    }
    reveal() {
        this.header.classList.add('shopify-section-header-sticky');
        this.body.classList.add('sticky-header-active');
    }
}
customElements.define('sticky-header', $874a32e76b909941$var$StickyHeader);


class $ffe58a94cfe2e792$var$LocalizationForm extends HTMLElement {
    constructor(){
        super();
        this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('.disclosure__list-wrapper')
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('a').forEach((item)=>item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
    }
    onItemClick(event) {
    //! temporarily commented, hardcoded country selector
    // event.preventDefault(); 
    //const form = this.querySelector('form');
    //this.elements.input.value = event.currentTarget.dataset.value;
    //if (form) form.submit();
    }
    openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
    closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) this.hidePanel();
    }
}
customElements.define('localization-form', $ffe58a94cfe2e792$var$LocalizationForm);


if (!customElements.get('media-gallery')) customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor(){
        super();
        this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch)=>{
            mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }
    onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement?.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
    // const deferredMedias = this.elements.viewer.querySelectorAll("deferred-media");
    // deferredMedias.forEach(deferredMedia => {
    //   deferredMedia.loadContentEvent();
    // })
    }
    setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        // The requested media may not exist in this gallery — e.g. the packs
        // dropdown swaps the product-info section but intentionally leaves the
        // media gallery as-is, so a newly selected pack variant's featured_media
        // isn't present here. Bail out instead of throwing on `activeMedia.classList`;
        // an uncaught throw here aborts global.js's onVariantChange before it runs
        // updateVariantInput, which leaves the wrong variant id in the form (and so
        // the wrong size gets added to cart).
        if (!activeMedia) return;
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element)=>{
            element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        if (prepend) {
            activeMedia.parentElement.prepend(activeMedia);
            if (this.elements.thumbnails) {
                const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }
            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }
        this.preventStickyHeader();
        window.setTimeout(()=>{
            if (this.elements.thumbnails) activeMedia.parentElement.scrollTo({
                left: activeMedia.offsetLeft
            });
        });
        this.playActiveMedia(activeMedia);
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }
    setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element)=>element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft
        });
    }
    announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = ()=>{
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(()=>{
                this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
        };
        image.src = image.src;
    }
    playActiveMedia(activeItem) {
        if (this.dataset.desktopLayout != "stacked_full" && this.dataset.desktopLayout != "stacked") window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
    }
    preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide)=>slide.setAttribute('role', 'presentation'));
    }
});


class $2f0992361777f1ce$var$MenuDrawerMobile extends HTMLElement {
    constructor(){
        super();
        this.submenuLevel1 = this.querySelectorAll('.menu-drawer__navigation .submenu__level-1');
        this.primaryMenuItems = this.querySelectorAll('.menu-drawer__menu-1 > li > .menu-drawer__menu-item:not(a)');
        this.bindEvents();
    }
    setFeatured() {
    // Featured section is now a heading, no longer needs aria-expanded
    // This method is kept for backward compatibility but is no longer used
    }
    bindEvents() {
        this.primaryMenuItems.forEach((item)=>item.addEventListener('click', this.onMenuItemClick.bind(this)));
        // Use event delegation for secondary menu items (level 2 accordion)
        this.addEventListener('click', (event)=>{
            const menuItem = event.target.closest('.menu-drawer__menu-2 > li > .menu-drawer__menu-item:not(a)');
            if (menuItem) {
                event.preventDefault();
                event.stopPropagation();
                this.toggleSecondaryMenu(menuItem);
            }
        });
    }
    onMenuItemClick(event) {
        const menuItemElement = event.currentTarget;
        setTimeout(()=>{
            this.openMenuDrawer(menuItemElement);
        }, 50);
    }
    toggleSecondaryMenu(menuItemElement) {
        // Get all secondary menu items in the menu-2 list
        const menu2 = menuItemElement.closest('.menu-drawer__menu-2');
        if (!menu2) return;
        const allSecondaryItems = menu2.querySelectorAll(':scope > li > .menu-drawer__menu-item:not(a)');
        const isCurrentlyOpen = menuItemElement.getAttribute('aria-expanded') === 'true';
        // Close all items first
        if (allSecondaryItems.length > 0) allSecondaryItems.forEach((item)=>{
            item.setAttribute('aria-expanded', 'false');
        });
        // If it wasn't open, open it now
        if (!isCurrentlyOpen) menuItemElement.setAttribute('aria-expanded', 'true');
    }
    openMenuDrawer(menuItemElement) {
        if (menuItemElement?.parentNode?.parentNode?.classList?.contains('menu-drawer__menu-1')) {
            const menuItems = menuItemElement?.closest('.menu-drawer__menu')?.querySelectorAll('li > .menu-drawer__menu-item:not(a)');
            menuItems.length && menuItems.forEach((item)=>{
                if (item.hasAttribute('aria-expanded')) {
                    const linkHandle = item.getAttribute('data-link-handle');
                    const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
                    submenuLevel1?.removeAttribute('aria-expanded');
                    item.removeAttribute('aria-expanded');
                }
            });
        }
        if (menuItemElement.hasAttribute('aria-expanded')) {
            const linkHandle = menuItemElement.getAttribute('data-link-handle');
            const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
            menuItemElement?.removeAttribute('aria-expanded');
            submenuLevel1?.removeAttribute('aria-expanded');
        } else {
            const linkHandle = menuItemElement.getAttribute('data-link-handle');
            const submenuLevel1 = this.querySelector(`.submenu__level-1[data-link-handle="${linkHandle}"]`);
            menuItemElement?.setAttribute('aria-expanded', true);
            submenuLevel1?.setAttribute('aria-expanded', true);
        }
    }
}
customElements.define('menu-drawer-mobile', $2f0992361777f1ce$var$MenuDrawerMobile);



if (!customElements.get('pickup-availability')) customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor(){
        super();
        if (!this.hasAttribute('available')) return;
        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
    }
    fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) rootUrl = rootUrl + "/";
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then((response)=>response.text()).then((text)=>{
            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
        }).catch((e)=>{
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
        });
    }
    onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
    }
    renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);
        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }
    renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
            this.innerHTML = "";
            this.removeAttribute('available');
            return;
        }
        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        const button = this.querySelector('button');
        if (button) button.addEventListener('click', (evt)=>{
            document.querySelector('pickup-availability-drawer').show(evt.target);
        });
    }
});
if (!customElements.get('pickup-availability-drawer')) customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor(){
        super();
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.querySelector('button').addEventListener('click', ()=>{
            this.hide();
        });
        this.addEventListener('keyup', ()=>{
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
    }
    handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') this.hide();
    }
    hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        (0, $499c0cfcaca01eb2$export$c761a6bf8c4188fe)(this.focusElement);
    }
    show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        (0, $499c0cfcaca01eb2$export$bec45a54c2e66c22)(this);
    }
});


class $199c95fdb3765e81$var$PredictiveSearch extends HTMLElement {
    constructor(){
        super();
        this.cachedResults = {};
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.isOpen = false;
        this.setupEventListeners();
    }
    setupEventListeners() {
        const form = this.querySelector('form.search');
        form.addEventListener('submit', this.onFormSubmit.bind(this));
        this.input.addEventListener('input', debounce((event)=>{
            this.onChange(event);
        }, 300).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }
    getQuery() {
        return this.input.value.trim();
    }
    onChange() {
        const searchTerm = this.getQuery();
        if (!searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(searchTerm);
    }
    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
    onFocus() {
        const searchTerm = this.getQuery();
        if (!searchTerm.length) return;
        if (this.getAttribute('results') === 'true') this.open();
        else this.getSearchResults(searchTerm);
    }
    onFocusOut() {
        setTimeout(()=>{
            if (!this.contains(document.activeElement)) this.close();
        });
    }
    onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();
        switch(event.code){
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }
    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') event.preventDefault();
    }
    switchOption(direction) {
        if (!this.getAttribute('open')) return;
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allElements = this.querySelectorAll('li');
        let activeElement = this.querySelector('li');
        if (moveUp && !selectedElement) return;
        this.statusElement.textContent = '';
        if (!moveUp && selectedElement) activeElement = selectedElement.nextElementSibling || allElements[0];
        else if (moveUp) activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
        if (activeElement === selectedElement) return;
        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);
        this.setLiveRegionText(activeElement.textContent);
        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
    selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
        if (selectedProduct) selectedProduct.click();
    }
    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        this.setLiveRegionLoadingState();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`).then((response)=>{
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        }).then((text)=>{
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.cachedResults[queryKey] = resultsMarkup;
            this.renderSearchResults(resultsMarkup);
        }).catch((error)=>{
            this.close();
            throw error;
        });
    }
    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }
    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;
        setTimeout(()=>{
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }
    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        this.open();
    }
    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
    getResultsMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
    }
    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
    }
    close(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');
        if (selected) selected.setAttribute('aria-selected', false);
        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false;
        this.predictiveSearchResults.removeAttribute('style');
        this.isOpen = false;
    }
}
customElements.define('predictive-search', $199c95fdb3765e81$var$PredictiveSearch);



if (!customElements.get('product-form')) customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('button[name="add-bundle"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        document.addEventListener('product:size-warning-toggle', (e)=>{
            this.toggleProductSizeWarning(false);
        });
    }
    onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        const formData = new FormData(this.form);
        let sizeVariantIsSelected = this.checkSizeVariant(formData);
        if (!sizeVariantIsSelected) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        const itemCo2 = this.form.querySelector('[name="properties[item_co2]"]')?.value;
        const lineGender = this.form.querySelector('[name="properties[_line_gender]"]')?.value;
        const config = (0, $499c0cfcaca01eb2$export$1811237fdf5ac5d)('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        if (this.dataset.cartType != 'page') {
            formData.append('sections', this.cart.getSectionsToRender().map((section)=>section.id));
            formData.append('sections_url', window.location.pathname);
            if (itemCo2) formData.append('properties[item_co2]', itemCo2);
            if (lineGender) formData.append('properties[_line_gender]', lineGender);
            this.cart.setActiveElement(document.activeElement);
        }
        fetch(`${routes.cart_add_url}`, config).then((response)=>response.json()).then((response)=>{
            if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
            } else if (this.dataset.cartType == 'page') {
                window.location = window.routes.cart_url;
                return;
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
                document.body.addEventListener('modalClosed', ()=>{
                    setTimeout(()=>{
                        this.cart.renderContents(response);
                    });
                }, {
                    once: true
                });
                quickAddModal.hide(true);
            } else this.cart.renderContents(response);
        }).catch((e)=>{
            console.error(e);
        }).finally(()=>{
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
    toggleProductSizeWarning(show = true) {
        const warningPopup = document.querySelector('.product-warning-popup');
        if (!warningPopup) return;
        if (!show) warningPopup.classList.add('hidden');
        else warningPopup.classList.remove('hidden');
    }
    checkSizeVariant(formData) {
        try {
            const fieldsets = document.querySelectorAll('.product__info-wrapper fieldset:not(.d-none)');
            if (!fieldsets) return true;
            if (fieldsets.length < 2) return true;
            let sizeVariantIsSelected = false;
            for (const [key, value] of formData){
                const formattedKey = key.toLowerCase().trim();
                if (formattedKey === 'size') sizeVariantIsSelected = true;
            }
            if (!sizeVariantIsSelected) {
                this.toggleProductSizeWarning();
                return false;
            }
            return sizeVariantIsSelected;
        } catch (error) {
            console.error("Error checking size variant", error);
            return false;
        }
    }
});



if (!customElements.get('product-modal')) customElements.define('product-modal', class ProductModal extends (0, $499c0cfcaca01eb2$export$1fa217be60c2f188) {
    constructor(){
        super();
    }
    hide() {
        super.hide();
    }
    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }
    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element)=>{
            element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
    }
});



if (!customElements.get('product-model')) customElements.define('product-model', class ProductModel extends (0, $499c0cfcaca01eb2$export$9baddd6b241a6836) {
    constructor(){
        super();
    }
    loadContent() {
        super.loadContent();
        Shopify.loadFeatures([
            {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: this.setupModelViewerUI.bind(this)
            }
        ]);
    }
    setupModelViewerUI(errors) {
        if (errors) return;
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
});
window.ProductModel = {
    loadShopifyXR () {
        Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: this.setupShopifyXR.bind(this)
            }
        ]);
    },
    setupShopifyXR (errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', ()=>this.setupShopifyXR());
            return;
        }
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON)=>{
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
    }
};



if (!customElements.get('quick-add-modal')) customElements.define('quick-add-modal', class QuickAddModal extends (0, $499c0cfcaca01eb2$export$1fa217be60c2f188) {
    constructor(){
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.isVariantLoading = false;
        this.currentVariantUrl = null;
        this.hasLoadedVariant = false;
    }
    hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
    }
    show(opener1) {
        this.selectedSize = null;
        this.hasLoadedVariant = false;
        opener1.setAttribute('aria-disabled', true);
        opener1.classList.add('loading');
        opener1.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        fetch(opener1.getAttribute('data-product-url')).then((response)=>response.text()).then((responseText)=>{
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            this.cleanupForQuickAdd();
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener1);
            this.callListeners();
            this.listeningForSizeChange();
            this.listeningForVariantChange();
        }).finally(()=>{
            opener1.removeAttribute('aria-disabled');
            opener1.classList.remove('loading');
            opener1.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }
    setInnerHTML(element, html) {
        element.innerHTML = html;
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag)=>{
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute)=>{
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
    callListeners() {
        this.cleanupForQuickAdd();
        this.listeningForSizeChange();
        this.listeningForVariantChange();
    }
    cleanupForQuickAdd() {
        if (!this.modalContent) return;
        const breadcrumbs = this.modalContent.querySelector(".breadcrumbs");
        if (breadcrumbs) breadcrumbs.remove();
        const packBlock = this.modalContent.querySelectorAll(".packs-block");
        if (packBlock) packBlock.forEach((el)=>el.remove());
        this.modalContent.querySelectorAll(".info-accordion__container").forEach((el)=>el.remove());
        this.modalContent.querySelectorAll(".color-swatch_badge").forEach((el)=>el.remove());
        this.modalContent.querySelectorAll(".modal__toggle").forEach((el)=>el.remove());
        if (this.selectedSize && this.hasLoadedVariant) {
            let matchedInput = null;
            this.modalContent.querySelectorAll(".product-form__input input").forEach((label)=>{
                if (label.value === this.selectedSize && !label.nextElementSibling.className.includes("sold-out")) {
                    label.checked = true;
                    matchedInput = label;
                }
            });
            if (matchedInput) matchedInput.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    }
    listeningForSizeChange() {
        if (this.selectedSize) ;
        else this.selectedSize = null;
        if (!this.modalContent) return;
        this.modalContent.querySelectorAll(".product-form__input input").forEach((label)=>{
            label.addEventListener("change", (e)=>{
                this.selectedSize = e.target.value;
                this.listeningForVariantChange();
            });
        });
    }
    listeningForVariantChange() {
        if (!this.modalContent) return;
        this.modalContent.querySelectorAll(".product-colors-links label a").forEach((label)=>{
            const variantUrl = label.getAttribute("href");
            label.addEventListener("click", (e)=>{
                e.preventDefault();
                if (this.isVariantLoading) return;
                if (variantUrl === this.currentVariantUrl) return;
                this.currentVariantUrl = variantUrl;
                this.loadNewVariant(variantUrl);
            });
        });
    }
    loadNewVariant(variantUrl) {
        if (this.isVariantLoading) return;
        this.isVariantLoading = true;
        fetch(variantUrl).then((response)=>response.text()).then((responseText)=>{
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            this.hasLoadedVariant = true;
            this.callListeners();
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
        }).finally(()=>{
            setTimeout(()=>{
                this.isVariantLoading = false;
                opener.removeAttribute("aria-disabled");
                opener.classList.remove("loading");
                opener.querySelector(".loading-overlay__spinner").classList.add("hidden");
            }, 80);
        });
    }
    preventVariantURLSwitching() {
        this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }
    removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
    }
    preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect)=>{
            variantSelect.dataset.originalSection = sectionId;
        });
        this.productElement.querySelectorAll('.product-form__input input[name="Size"], .product-form__input input[data-size]').forEach((input)=>{
            input.checked = false;
        });
    }
    removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li)=>li.setAttribute('role', 'presentation'));
    }
});



if (!customElements.get('share-button')) customElements.define('share-button', class ShareButton extends (0, $efdbc15424b9706c$export$744d08d458a2219d) {
    constructor(){
        super();
        this.elements = {
            shareButton: this.querySelector('button'),
            shareSummary: this.querySelector('summary'),
            closeButton: this.querySelector('.share-button__close'),
            successMessage: this.querySelector('[id^="ShareMessage"]'),
            urlInput: this.querySelector('input')
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        if (navigator.share) {
            this.mainDetailsToggle.setAttribute('hidden', '');
            this.elements.shareButton.classList.remove('hidden');
            this.elements.shareButton.addEventListener('click', ()=>{
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                });
            });
        } else {
            this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
            this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
            this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
    }
    toggleDetails() {
        if (!this.mainDetailsToggle.open) {
            this.elements.successMessage.classList.add('hidden');
            this.elements.successMessage.textContent = '';
            this.elements.closeButton.classList.add('hidden');
            this.elements.shareSummary.focus();
        }
    }
    copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(()=>{
            this.elements.successMessage.classList.remove('hidden');
            this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
            this.elements.closeButton.classList.remove('hidden');
            this.elements.closeButton.focus();
        });
    }
    updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
    }
});


class $ae22762285de404f$var$ShowMoreButton extends HTMLElement {
    constructor(){
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event)=>{
            this.expandShowMore(event);
            const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
            if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) nextElementToFocus.querySelector('input').focus();
        });
    }
    expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element)=>element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item)=>item.classList.toggle('hidden'));
    }
}
customElements.define('show-more-button', $ae22762285de404f$var$ShowMoreButton);


document.addEventListener('shopify:block:select', function(event) {
    const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
    if (!blockSelectedIsSlide) return;
    const parentSlideshowComponent = event.target.closest('slideshow-component');
    parentSlideshowComponent.pause();
    setTimeout(function() {
        parentSlideshowComponent.slider.scrollTo({
            left: event.target.offsetLeft
        });
    }, 200);
});
document.addEventListener('shopify:block:deselect', function(event) {
    const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
    if (!blockDeselectedIsSlide) return;
    const parentSlideshowComponent = event.target.closest('slideshow-component');
    if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});





})();
//# sourceMappingURL=parcel_scripts.js.map
